import   React,
       { useEffect,
         useState,
         useContext } from 'react';
import { withRouter,
         Redirect } from 'react-router-dom';
import { Typography,
         Button,
         Drawer,
         Fade,
         Checkbox,
         FormGroup,
         FormControlLabel,
         TextField,
         SwipeableDrawer,
         Container, 
         Input} from '@material-ui/core';
import { makeStyles,
         withStyles } from '@material-ui/core/styles';
import { faAngleDoubleRight,
         faAngleRight,
         faAngleLeft,
         faEnvelope, 
         faSearch} from '@fortawesome/free-solid-svg-icons';     //icons: https://fontawesome.com/icons
import { playAudio, } from '../util/videoUtil';

import { CONSTS, 
         CONSLOG,
         INFO,
         STATS,
         initHistory,
         TIMES, } from '../util/object';
import { VIMEO_POST,
         BUCKET_API_SERVER,
         YOUTUBE_POST } from "../util/constants";
import { initWebcamAI,
         disableWebcamStream,
         drawVideoScreen,
         copyDivScreen,
         downloadFile,
         recordOutput } from "../util/videoUtil";
import { 
         getTutorial,
         processDrillsFromSequence,
         processDrillItems,
         processStateItems,
         setupScheme,
         lockScreenHorizontal,
         unlockScreenOrientation,
         setScreenOrientation,
         AdminSwitchUser,
         parseSliceParams,
         loadUserState,
         getPersonalTarget,
         makeVideoLink,
         arraySeqAscSort,
         arrayPerfDesSort,
         arrayUidDesSort,
         arrayTargetDesSort,
         arrayTimestampDesSort,
         decodeVideoHash,
         set_webcam_resolution,
         findVideoType,
         setFrameEvent,
         dumpObject,
         arrayTrackAscSort, 
         find_mp4_url,
         findSkipSteps,
         showLoadingMessage, 
         adjustDisplayDiv, 
         calcMeter2Pixel,
         calcSessionScore,
         map2Array,
         NOW,
         debugFemurStats} from '../util/util';
import { guiState } from '../util/aiMain';
import { GATag, sleep, Stack } from "../util/tools";
import { initDefender } from "../util/defender";
import { appContext } from "./index";
import { initVideoDisplay,
         timerDisplayResult,
        } from '../util/annotate'
import { startRun,
         stopSession,
         resetSession,
         removeOutliers,
         isolatePerfSummary,
         processDrillHistory,
         stopRun } from '../util/performance';
import { CreateVirtualSession,
         //ReadUserStateInfo,
         GetMsg,
         ReadDrillData,
         fetchSessionVideoLinks,
         fetchFootageLinks,
         fetchNewDrillLinks,
         ReadSectionData,
         ReadMotionData,
         ReadStateData,
         ReadTodayData,
         FetchFirestoreDrillSummary,
         getVimeoURL,
         StoreHistoryBucket,
         GetBucketVideoLink,
         CreateDatabase,
         FetchFirestoreDrillHistory } from '../util/database';
import { GoBack,
         Notice,
         Direction,
         BugReport,
         FullScreen,
         //ValidateRun,
         Settings,
         SendInvite,
         Wait } from "./Util";
import { VideoFrame,
         setPlayerSpeed,
         setPlayerTime,
         } from "./VideoPlayer";
import { Dashboard } from "./Dashboard";
import Catalog from "./Catalog";
import Tutorial from "./Tutorial";
import Results from "./Results";
import Game from "./Game";
import Mock from "./Mock";
import Webcam from "./Webcam";
import { BotAdmin, BotSlave } from "./BotAdmin";
//import Analyze from "./Analyze";
import { Countdown } from "./Util";
import { LineChart } from "./Graph";
import { SwitchUser } from "./Admin";
import { TargetClass } from '../class/TargetClass';
import { UtilClass } from '../class/UtilClass'
import { initAudio } from '../util/util'
import { knnCluster, 
         knnBestMatch,
         analyzeMotionMarkers,
         knnAnalyzeLoopPattern,
         setValidLimbs,
         processKnnData,
         initKnnState,
         knnLoadMarkers } from '../util/limbs';
import { CameraClass } from '../class/CameraClass';
import { } from '../util/analysis';

//const Vimeo = require("@vimeo/player");
//import YTPlayer from 'yt-player';
//import Player from '@vimeo/player';
//import { BrandingWatermark } from '@material-ui/icons';

var Util = new UtilClass();

var delay_kludge = false;


const auth_useStyles = makeStyles(theme => ({
    train_root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',     // 100%
        width: '100vw',
        maxWidth: '100%',
        //maxHeight: '100%',
        marginTop: '0vh',
        padding: "0",
        position: "relative",       // so we can do absolute later
        //backgroundColor:'#44ffff',
    },

    train_button: {
        "&:hover": {
            color: 'yellow',
            backgroundColor: '#3b58c1',
            borderColor: 'rgba(255,255,255,0)',
        },
		fontSize: '1.2rem',
        height: '8vh',
        width: '20vh',
        minWidth: '180px',
        minHeight: '45px',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: '0.5vh',
        padding: '10px',
        backgroundColor: 'rgba(53, 86, 102, 0.95)', 
        color: 'white',
        borderColor: 'rgba(255,255,255,0)',
        borderRadius: '15px',
        border: '0px',
        //boxShadow: '0 10 20 0',
        boxShadow: 'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
        alignItems: 'center',
        justifyContent: 'center',
    },
    catalog_theme: {
        backgroundColor: 'rgba(79,119, 137, 1)',
    },
    display_container: {
        position: 'relative',    // this allows child to go absolute posn
        display: "flex",
        padding: '50px 0 0 0',      // gives root for title bar
        margin: '0',
        width: "100vw",
        height: "100vh",        // must be full length
        flexDirection: "row",
        alignItems: "flex-start",
        maxWidth: "100%",
        flexWrap: 'wrap',     // this messing stuff up?
        zIndex: '0',
        background: '#5c5b5b',
    },
    perf_webcam_container: {
        //position: 'absolute',
        //top: '0',
        //right: '0',
        width: '100%',
        height: '100%',
        padding: '0',
        margin: '0',
        //zIndex: '150',
        //background: 'red',
    },
    webcam_container: {
        position: 'absolute',
        top: '0',
        right: '0',
        width: '200px',
        height: '120px',
        padding: '0',
        margin: '0',
        zIndex: '150',
        //background: 'red',
    },
    video_container: {
        display: "flex",
        position: 'relative',
        flexDirection: 'column',    //"row",
        justifySelf: "flex-start",
        padding: '0',
        margin: '0',
        paddingTop: CONSTS.GOBACK_BAR_HEIGHT+"px",
        width: "auto",
        height: "auto",
        alignSelf: "center",        // in case not covering 100%
        background: '#bbbbbb',
        zIndex: '0',
    },
    drill_container: {
        display: "flex",
        position: 'relative',       // need this for child absolute
        top: CONSTS.GOBACK_BAR_HEIGHT+"px",
        flexDirection: "row",
        flexWrap: 'wrap', 
        justifySelf: "flex-start",
        padding: '0',
        margin: '0',
        //paddingTop: CONSTS.GOBACK_BAR_HEIGHT+"px",
        height: "auto",
        width: "auto",
        maxWidth: '100%',
        zIndex: '0',
        //background: '#bbbbbb',
        //transform: 'translateY(-50px)',
    },
    drill_iframe: {
        margin: '0',
        padding: '0',
        zIndex: '130',
        //height: "100%",
        //position: "absolute",
        //top: "0",
        //left: "0",
        //width: "100%",
        //height: "100%",
        //zIndex: "100",
    },
    game_container: {
        display: "flex",
        flexDirection: "row",
        justifySelf: "flex-start",
        padding: '0',
        margin: '0',
        //paddingTop: "50px",
        paddingTop: CONSTS.GOBACK_BAR_HEIGHT+"px",
        height: "auto",
        width: "auto",
        background: '#bbbbbb',
		fontSize: '1.3rem',
        zIndex: '0',
    },
    dummy_container: {
        height: '0',
        width: '0',
    },

    adisplay_container: {
        display: "flex",
        padding: '0',
        margin: '0',
        width: "100vw",
        height: "100vh",        // must be full length
        flexDirection: "row",
        flexWrap: 'wrap',     // this messing stuff up?
        alignItems: "flex-start",
        maxWidth: "100%",
        zIndex: '0',
        //overflow: 'auto',       // DEBUG ONLY
    },
    adrill_container: {
        position: 'relative',
        padding: '0',
        margin: '0',
        paddingTop: CONSTS.GOBACK_BAR_HEIGHT+"px",
        height: "100%",     //"auto",
        width: "calc(100% - 200px)",     //"auto",
        maxWidth: '100%',
        zIndex: '0',
    },
    full_drill_container: {
        position: 'relative',
        padding: '0',
        margin: '0',
        paddingTop: CONSTS.GOBACK_BAR_HEIGHT+"px",
        height: "100%",     //"auto",
        width: "100%",     //"auto",
        maxWidth: '100%',
        zIndex: '0',
    },
    adrill_iframe: {
        margin: '0',
        padding: '0',
        zIndex: '130',
    },
    dev_output_canvas: {
        position: "absolute",
        top: '0',
        left: '0',
        padding: '0',
        margin: '0 0 0 0',       // 50px
        width: '100%',
        maxWidth: "100%",
        zIndex: '150',
        //width: "100%",
        //height: "calc(100% - 50px)",        // must be full length
        //background: '#ff000030',
    },
    dev_vcanvas: {
        position: 'absolute',
        top: '15%',         // 0
        left: '0',
        width: "1px",       //"100%", 1px
        height: "1px",      //"100%", 1px
        padding: '0',
        margin: '0',
        display: 'block',
        zIndex: '-100',
    },
    dev_control_container: {
        display: 'flex',
        flexDirection: 'row',
        position: "absolute",
        left: '0',
        bottom: '0px',
        height: '250px',
        width: 'calc(100% - 200px)',
    },
    create_drill_container: {
        display: 'flex',
        flexDirection: 'column',
        height: 'auto',
        width: '150px',
        padding: '8px 0',
        zIndex: '300',
        //background: '#f2f2f5aa',
        margin: '0 10px',
        justifyContent: 'flex-end',
    },
    drill_drawer_container: {
        display: 'flex',
        height: 'auto',
        width: '100%',
        padding: '5px',
        margin: '10px 0 0 0',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        background: '#f2f2f5aa',
    },
    drill_drawer: {
        display: 'flex',
        height: 'auto',
        width: '120px',
        padding: '8px 0',
        zIndex: '300',
        background: '#f2f2f5aa',
        flexDirection: 'column',
        alignItems: 'center',
    },
    input_label: {
		fontSize: '0.7rem',
        //width: '80%',
        //margin: 'auto',
    },
    text_input: {
		fontSize: '0.7rem',
        width: '80%',
        //margin: 'auto',
        borderColor: '#f6f3f3b0',
        background: '#f4efef',
        marginBottom: '3px',
    },
    checkbox_group: {
        background: '#b9bbf48f',
    },
    checkbox_input: {
		fontSize: '0.7rem',
        height: '18px',
        margin: '0',    //'2px 5px',
        borderColor: '#f6f3f3b0',
        //background: '#f4efef',
        //marginBottom: '3px',
    },
    dev_toggle_btn: {
		fontSize: '0.8rem',
        height: '20px',
        width: '100px',
        padding: '0',
        margin: '15px 0 3px 0',
        alignSelf: 'center',
        backgroundColor: '#bbb8b8',     // Dark Cornflower Blue
    },
    dev_ctl_btn: {
		fontSize: '0.7rem',
        height: '25px',
        width: '120px',
        marginBottom: '4px',
        padding: '5px',
        color: 'white',
        borderRadius: '4px',
        border: '0',
        zIndex: '380',
        backgroundColor: 'rgba(43, 65, 120, 0.95)',     // Dark Cornflower Blue
        justifyContent: 'center',
        alignSelf: 'center',
        //minWidth: '60px',
        //boxShadow: 'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
    },
    slave1_rank_text: {
        height: '55px',
        fontSize: '2.1rem',
        margin: '0',        //'5px 0',
        //width: '100%',
        //minWidth: '350px',
        //textAlign: 'left',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        color: 'yellow',
    },
}));


// Display top level menu
const Learn = (props) => {
    const classes = auth_useStyles();
    const { State, Dispatch } = useContext(appContext);
    function setState(name, value) {
        console.log("lrn_setState:  ",name," =", value, " @", Stack(new Error().stack));
        Dispatch({ type: [name], value: value });   // reducer wrapper
    }
    //const [ INFO.webcam_started, setINFO.webcam_started ] = useState(false);
    const [ GameStarted, setGameStarted ] = useState(false);
    const [ MockStarted, setMockStarted ] = useState(0); 
    const [ AnalyzeStarted, setAnalyzeStarted ] = useState(0); 
    const [ VideoStarted, setVideoStarted ] = useState(false);
    const [ ButtonText, setButtonText ] = useState(true);
    const [ LearnRedirect, setLearnRedirect ] = useState(false);
    const [ LearnTarget, setLearnTarget ] = useState("");
    const [ ShowDashboard, setShowDashboard ] = useState(false);
    const [ ShowCatalog, setShowCatalog ] = useState(true);
    const [ ShowWait, setShowWait ] = useState(false);
    const [ ShowNotice, setShowNotice ] = useState(false);
    const [ ShowWaitSpinner, setShowWaitSpinner ] = useState(false);
    const [ ShowBugReport, setShowBugReport ] = useState(false);
    const [ ShowTutorial, setShowTutorial ] = useState(false);
    const [ ShowAnalyzeVideo, setShowAnalyzeVideo ] = useState(false);
    const [ ShowAnalyzeWebcam, setShowAnalyzeWebcam ] = useState(false);

    const [ ShowCountdown, setShowCountdown ] = useState(false);
    const [ CountdownTime, setCountdownTime ] = useState(null);
    const [ CountdownList, setCountdownList ] = useState(null);
    const [ CountdownMsg, setCountdownMsg ] = useState(null);
    const [ CountdownName, setCountdownName ] = useState(null);

    const [ ShowGraph, setShowGraph ] = useState(false);
    const [ ShowExpand, setShowExpand ] = useState(false);
    const [ ShowSendInvite, setShowSendInvite ] = useState(false);
    const [ ShowAdminDialog, setShowAdminDialog ] = useState(false);
    const [ ShowPreFlight, setShowPreFlight ] = useState(false);
    const [ ShowWarning, setShowWarning ] = useState(false);

    const [ Report, setReport ] = useState("");
    const [ Confirmation, setConfirmation ] = useState(null);
    const [ Outcome, setOutcome ] = useState("");               // the title of the result output
    const [ Summary, setSummary ] = useState([]);
    const [ DrillSummary, setDrillSummary ] = useState([]);
    const [ SlowMo, setSlowMo ] = useState(INFO.slowmo_mode);
    const [ History, setHistory ] = useState(null);         // history for drill graphing
    const [ Fields, setFields ] = useState(null);             // field for drill graphing
    const [ Recording, setRecording ] = useState(INFO.record_mode);
    const [ CatalogTitle, setCatalogTitle ] = useState("");
    const [ CatalogGroups, setCatalogGroups ] = useState([]);
    const [ CatalogItems, setCatalogItems ] = useState([]);
    const [ CatalogType, setCatalogType ] = useState(null);
    const [ CatalogRefresh, setCatalogRefresh ] = useState(0);
    const [ TodayCatalogItems, setTodayCatalogItems ] = useState([]);
    const [ ShowTut, setShowTut ] = useState(null);
    const [ NoAI, setNoAI ] = useState(null);
    const [ NoDetect, setNoDetect ] = useState(false);      // if no Detect defined for Mock run
    const [ HideResults, setHideResults ] = useState(false);
    const [ Warning, setWarning ] = useState("");     // notice msg
    const [ ExpandIcon, setExpandIcon ] = useState(faAngleLeft);
    const [ ResultStyle, setResultStyle ] = useState("");
    const [ SelectedItem, setSelectedItem ] = useState({});
    const [ TabSelected, setTabSelected ] = useState(0);
    const [ AllDrills, setAllDrills ] = useState([]);
    const [ Mode, setMode ] = useState(null);
    const [ ModeRefresh, setModeRefresh ] = useState(0);
    const [ TabHistory, setTabHistory ] = useState({});  // to restore Tab setting

    const [ AllSections, setAllSections ] = useState([]);
    const [ AllMotions, setAllMotions ] = useState([]);
    //const [ AllToday, setAllToday ] = useState([]);
    const [ SessionName, setSessionName ] = useState("");
    const [ Progress, setProgress ] = useState("");
    const [ DashReload, setDashReload ] = useState(0);
    const [ ValidateRun, setValidateRun ] = useState(false);

    const [ DashboardMode, setDashboardMode ] = useState(false);
    const [ SkillsMode, setSkillsMode ] = useState(false);
    const [ AgilityMode, setAgilityMode ] = useState(false);
    const [ ConditioningMode, setConditioningMode ] = useState(false);
    const [ TodayMode, setTodayMode ] = useState(false);
    const [ PerfMode, setPerfMode ] = useState(false);
    const [ AnalyzeMode, setAnalyzeMode ] = useState(false);
    //const [ DrillMode, setDrillMode ] = useState(false);

    // These *Type is used to sync React cycle
    const [ ShowPerf, setShowPerf ] = useState(false);
    const [ ShowGame, setShowGame ] = useState(false);
    const [ ShowMock, setShowMock ] = useState(false);
    const [ ShowDrill, setShowDrill ] = useState(false);
    const [ ShowAnalyze, setShowAnalyze ] = useState(false);
    const [ NextSet, setNextSet ] = useState(1);
    const [ ShowRaiseHand, setShowRaiseHand] = useState(false);
    const [ Notices, setNotices ] = useState([]);
    const [ Instrns, setInstrns ] = useState([]);
    const [ Refresh, setRefresh ] = useState(0);
    const [ GameScheme, setGameScheme ] = useState([]);   // game setting
    const [ GameFingers, setGameFingers ] = useState(0);   // game setting
    const [ GameCnt, setGameCnt ] = useState(0);        // increase this will clear game canvas
    const [ MockCnt, setMockCnt ] = useState(0);        // increase this will clear game canvas
    const [ VerticalMode, setVerticalMode ] = useState(false);
    const [ Orientation, setOrientation ] = useState(0);
    const [ VideoPlayer, setVideoPlayer ] = useState(null);     // if video is vimeo or youtube
    const [ VideoItem, setVideoItem ] = useState(null);     // if video is vimeo or youtube
    //const [ VimeoType, setVimeoType ] = useState(true);     // replaced by PlayerTepy
    const [ PlayerType, setPlayerType ] = useState(null);     //  [ vimeo, youtube, native ]
    const [ HandsFree, setHandsFree ] = useState(true);      // switch to "no button" UI
    const [ ShowVideoControl, setShowVideoControl ] = useState(true);      // control video

    // Analyze Dev States: Init in handleShowAnalyzeVideo()
    //
    const [ DevAnalyzeMode, setDevAnalyzeMode ] = useState(false);     // developer running test AI
    const [ DevAnalyzeRunning, setDevAnalyzeRunning ] = useState(false);     //  developer running test AI
    const [ DevAnalyzeLive, setDevAnalyzeLive ] = useState(false);    // if true, use webcam as source
    const [ DevRunningAI, setDevRunningAI ] = useState(false);     //  developer running test AI
    const [ DevRecording, setDevRecording ] = useState(false);
    const [ DevSubKey, setDevSubKey ] = useState(null);           // [ flm, edit, replay ]
    const [ ShowDevButton, setShowDevButton ] = useState(false);    // developer running test AI
    const [ ShowDevDrillCreate, setShowDevDrillCreate ] = useState(false);    // developer running test AI
    const [ ShowEditMockVideo, setShowEditMockVideo ] = useState(false);
    const [ EditMockFootage, setEditMockFootage ] = useState(null);
    const [ DevDrillCreateOpen, setDevDrillCreateOpen ] = useState(false);    // developer running test AI
    const [ VideoRecordStart, setVideoRecordStart ] = useState('USE "S"');    // developer running test AI
    const [ VideoRecordEnd, setVideoRecordEnd ] = useState('USE "E"');    // developer running test AI
    const [ HasVideoEnds, setHasVideoEnds ] = useState(false);      // create drill: loop video to preview
    //const [ HasAllCreateInfo, setHasAllCreateInfo ] = useState(false);      // create drill: loop video to preview
    const [ PlayerPausedAutoSave, setPlayerPausedAutoSave ] = useState(false);    // create drill: auto save video to vimeo once video play stops
    const [ AnalyzePlayerPaused, setAnalyzePlayerPaused ] = useState(null);      // create drill: auto save video to vimeo once video play stops
    const [ PlayerPausedReplay, setPlayerPausedReplay ] = useState(null);      // create drill: loop video to preview
    const [ AnalyzerRefresh, setAnalyzerRefresh ] = useState(0);      // create drill: loop video to preview
    const [ AnalyzerAutoTrainAI, setAnalyzerAutoTrainAI ] = useState(true);      // create drill: loop video to preview

    const [ DrillNotes, setDrillNotes ] = useState("");
    const [ DevAIControlOpen, setDevAIControlOpen ] = useState(false);
    const [ DevMarkerTrace, setDevMarkerTrace ] = useState(false);      // knn debug
    const [ DevMarkerReset, setDevMarkerReset ] = useState(false);      // knn debug
    const [ TLState, setTLState ] = useState(true);
    const [ TRState, setTRState ] = useState(true);
    const [ BLState, setBLState ] = useState(true);
    const [ BRState, setBRState ] = useState(true);
    const [ CHState, setCHState ] = useState(false);
    const [ CBState, setCBState ] = useState(false);

    const [ ShowBotMaster, setShowBotMaster ] = useState(false);
    const [ ShowBotSlave, setShowBotSlave ] = useState(false);
    const [ BotSlaveTimer, setBotSlaveTimer ] = useState(null);
    const [ BotSlaveBackground, setBotSlaveBackground ] = useState(null);                 // poly: active list being displayed
    const [ BotSlaveNote, setBotSlaveNote ] = useState([]);                 // poly: active list being displayed
    const [ BotSlaveRanks, setBotSlaveRanks ] = useState([]);                 // poly: active list being displayed
    const [ BotSlaveDrillTitle, setBotSlaveDrillTitle ] = useState([]);                 // poly: active list being displayed
    const [ BotLastMsg, setBotLastMsg ] = useState(null);               // holding buffer, processing is async to read
    const [ HideInstruction, setHideInstruction ] = useState(false);
    const [ HideResult, setHideResult ] = useState(false);
 
    //
    const [ ReviewVideo, setReviewVideo ] = useState(null);       // for tutorial
    const [ VideoWidth, setVideoWidth ] = useState(0);        // increase this will clear game canvas
    const [ VideoHeight, setVideoHeight ] = useState(0);        // increase this will clear game canvas
    const [ PlayerVideoWidth, setPlayerVideoWidth ] = useState(0);        // increase this will clear game canvas
    const [ PlayerVideoHeight, setPlayerVideoHeight ] = useState(0);        // increase this will clear game canvas
    const [ CanvasVideoWidth, setCanvasVideoWidth ] = useState(0);        // increase this will clear game canvas
    const [ CanvasVideoHeight, setCanvasVideoHeight ] = useState(0);        // increase this will clear game canvas
    const [ RunStopped, setRunStopped ] = useState(false);
    const [ SettingDrawerOn, setSettingDrawerOn ] = useState(false);
    const [ ReturnToDashboard, setReturnToDashboard ] = useState(false);

    const [ Links, setLinks ] = useState([]);
    const [ VideosList, setVideosList ] = useState([]);
    const [ UseDirections, setUseDirections ] = useState([]);
    const [ WarningText, setWarningText ] = useState([]);       // for preflight instrn

    const [ ShowNeedHorizontal, setShowNeedHorizontal ] = useState(false);
    const [ OperationComplete, setOperationComplete ] = useState(false);
    const [ WebcamWidth, setWebcamWidth ] = useState(false);
    const [ WebcamHeight, setWebcamHeight ] = useState(false);
    const [ VideoFrameReady, setVideoFrameReady ] = useState(0);
    const [ DrillActive, setDrillActive ] = useState(false);        // semaphore to block multiple drill starts
    const [ AutoDrillStart, setAutoDrillStart ] = useState(0);  // start the drill in the next React cycle
    const [ RampStartTimer, setRampStartTimer ] = useState(null);  // for timer cleanup

    const [ DoStartChallengeWebcam, setDoStartChallengeWebcam ] = useState(0);  // delay to allow react to refresh
    const [ DoStartPracticeWebcam, setDoStartPracticeWebcam ] = useState(0);    // delay to allow react to refresh
    const [ EnableWebcam, setEnableWebcam ] = useState(false);    // delay to allow react to refresh

    // create drill
    const [ MakingDrillStart, setMakingDrillStart ] = useState(false);       // Analysis: Edit Mode to create drills

    useEffect(() => {
        console.log("learn.374: ######################### Start LEARN Mode.....  mode=", props.Mode, "  drill=",props.Drill, "    no_ai=",INFO.no_ai_mode);
        initAudio();

        setShowWait(false);
        setButtonText("START");
        setResultStyle(classes.results_container_h);
        //setButtonText("START SET "+NextSet);
        //adjustDisplayDiv();

        /* do we?
        var [swidth, sheight] = adjustDisplayDiv("learn.init.602");
        setPlayerVideoWidth(swidth);
        setPlayerVideoHeight(sheight);
        */

        setHideResults(false);
        setNoAI(INFO.no_ai_mode);

        INFO.setState = setState;   // SCREEN ORIENTATION need to set it here for the event handler calls to get back to React state
        INFO.State = State;

        INFO.show_cones = true;
        INFO.admin_mode = false;
        INFO.practice_mode = false;     // true
        INFO.perf_mode = false;
        INFO.game_mode = false;
        INFO.mock_mode = false;
        INFO.defender_mode = false;
        INFO.footage_mode = false;
        INFO.perf_running = false;
        INFO.show_home_zone = false;
        INFO.interrupted_mode = false;
        INFO.record_running = false;

        //INFO.webcam_owidth = null;
        //INFO.webcam_oheight = null;
        INFO.webcam_aspect = null;
        INFO.video_owidth = null;
        INFO.video_oheight = null;
        INFO.video_aspect = null;

        setMode(props.Mode);
        var history = TabHistory;
        history[props.Mode] = 0;
        setTabHistory(history);

        // init default limb selection state
        //
        setTLState(INFO.TL_state);
        setTRState(INFO.TR_state);
        setBLState(INFO.BL_state);
        setBRState(INFO.BR_state);
        setCHState(INFO.CH_state);
        setCBState(INFO.CB_state);

        // always set something to display
        var item = {name: "NONE"}
        setSelectedItem(item);

        // if direct drill play and state is loaded then start
        //     - otherwise wait for "has_user_state" signal
        //
        if ((INFO.direct_start_mode === true) && (INFO.has_user_state === true)) {
            console.log("learn.404:   ################  DETECT WAKEUP ALREADY SENT - Start Drill auto-play");
            setAutoDrillStart(Date.now());      // can't call handleAutoStartDrill() directly , need to do it on the next React refresh
        }

        GATag("Training", "Learn.Entry", "", 0);		 // (cat, act, lab, val)
        //window.addEventListener('resize', adjustDisplayDiv);
        //window.addEventListener("orientationchange", adjustDisplayDiv);
        window.addEventListener('resize', eventAdjustOrientation);
        window.addEventListener("orientationchange", eventAdjustOrientation);
        window.addEventListener('finished', storeStateCompleted, false); // Listen for the event.
        window.addEventListener('summary', updateDrillSummary, false); // Listen for the event.
        window.addEventListener('session_close', handleStopEvent, false); // For auto-stop
        window.addEventListener('show_warning', handleShowWarning, false); // Listen for the event.
        window.addEventListener('has_user_state', handleAutoStartDrillEvent, false); // 
        window.addEventListener('keydown', handleKeyDown, false); // 
        window.addEventListener('gesture_detected', handleGestureDetected, false); // process user gesture signals

        // TEST SCAFFOLD FOR VALIDATE
        if (false) {
            var outputs = [], out = {}, out1 = {}, m1;
            out1.title = "R00:";
            out1.value = "230 msec  (12)";
            out = {...out1};
            outputs.push(out);

            out1.title = "R01:";
            out1.value = "310 msec  (2)";
            out = {...out1};
            outputs.push(out);

            out.title = "T04:";
            out1.value = "42%  (4)";
            out1 = {...out};
            outputs.push(out1);
            setSummary(outputs);
            setOutcome("NEW RECORD!");
            setValidateRun(true);      // TEST ONLY
            setShowWaitSpinner(false);
            setShowWait(true);      // TEST ONLY
        }


        return function cleanup() {
            console.log("Learn.221:   CLEANUP LEARN Mode.....", Refresh);
            window.removeEventListener('resize', eventAdjustOrientation);
            window.removeEventListener("orientationchange", eventAdjustOrientation);
            window.removeEventListener('finished', storeStateCompleted, false);
            window.removeEventListener('summary', updateDrillSummary, false);
            window.removeEventListener('session_close', handleStopEvent, false);
            window.removeEventListener('show_warning', handleShowWarning, false); // Listen for the event.
            window.removeEventListener('has_user_state', handleAutoStartDrillEvent, false); // 
            window.removeEventListener('keydown', handleKeyDown, false); // 
            window.removeEventListener('gesture_detected', handleGestureDetected, false);
            INFO.sidebar_width = CONSTS.SIDEBAR_SMALL_WIDTH;
            setHideResults(true);
            setShowBugReport(false);
            setShowWait(false);
            setGameStarted(false);
            //setMockStarted(false);
            setMockStarted(0);
            setAnalyzeStarted(0);
            setShowWaitSpinner(true);
            setShowGraph(false);
            setShowTutorial(false);

            setShowDrill(false);
            setShowPerf(false);
            setShowGame(false);
            setShowMock(false);
            setShowDrill(false);
            setShowAnalyze(false);

            setShowAdminDialog(false);
            setShowDashboard(false);
            setShowPreFlight(false);
            INFO.admin_mode = false;
            INFO.perf_mode = false;
            INFO.practice_mode = false;
            INFO.game_mode = false;
            INFO.mock_mode = false;
            INFO.analyze_mode = false;
            INFO.defender_mode = false;
            INFO.footage_mode = false;

            //INFO.auto_run_mode = false;       // this is set by index
            INFO.train_model_mode = false;

            if (RampStartTimer !== null) {
                clearTimeout(RampStartTimer);      // get rid of old one
            }
            if (BotSlaveTimer) {
                clearTimeout(BotSlaveTimer);      // get rid of old one
            }
        };

    }, [1]);

    useEffect(() => {

		var output = document.getElementById('drill_output');
        console.log("Learn.804:     ~ ~ ~ ~ ~  USE_EFFECT   learn_player=",INFO.learn_player, " SlectedItem=",SelectedItem, " output=",output);

        var speed = (INFO.slowmo_mode == true) ? 0.5 : 1.0;
        if(INFO.learn_player !== null) {
            setPlayerSpeed(INFO.learn_player, speed);
        }

        /* NEED THIS?
        var [swidth, sheight] = adjustDisplayDiv("learn_refresh.752");
        setPlayerVideoWidth(swidth);
        setPlayerVideoHeight(sheight);
        console.log("Learn.62:   Display Refresh ", Refresh, "  width=",swidth, " sheight=",sheight, " vertical=",INFO.vertical_mode, " all_today=", INFO.all_today);
        */

        if((SelectedItem !== undefined) && (SelectedItem.width !== undefined) && (output !== null)) {
            if(INFO.no_ai_mode == true) {
                // test mode for devices too slow to do AI
                output.setAttribute("width", "640");
                output.setAttribute("height", "360");
            } else {
                output.setAttribute("width", SelectedItem.width);
                output.setAttribute("height", SelectedItem.height);
            }
        }

        if ((GameStarted === true)) {
            initVideoDisplay("drill_output", "effect_game_start.812");        // set it up for final result output
        }

        if ((MockStarted > 0)) {
            initVideoDisplay("mock_buffer0", "effect_mock_start.816");        // set it up for final result output
        }

        if ((AnalyzeStarted > 0)) {
            //initVideoDisplay("drill_output", "effect_analy_start.820");        // decide further down, don't always need it
        }

        setWebcamWidth(INFO.webcam_owidth);
        setWebcamHeight(INFO.webcam_oheight);

    }, [ Refresh, GameCnt, GameStarted, MockCnt, MockStarted, AnalyzeStarted ]);


    useEffect(() => {
        if (Mode) {
            console.log("Learn.836:  # # # # # # # # # #  START DRILL  Mode=",Mode, " db_drills=",INFO.db_drills);
            setupDrills(Mode, "effect.Mode.503");
            INFO.bot_slave_mode = false;
            INFO.tut_module = Mode;
            INFO.tut_op = "start";
            var show = getTutorial(INFO.tut_module, INFO.tut_op);
            if(show !== null) {
                setShowTut(show);
                setShowTutorial(true);
            }

            switch (Mode) {
                case "today":       // RUN TODAY AUTO-START DRILLS FROM DASHBOARD
                    INFO.drill_chain_mode = true;
                    INFO.drill_chain_abort = false;
                    INFO.disable_calibration = false;
                    processChainedTodayDrill("start", "dash_select.1862");   // Note: decide which drill to start and resume flow if needed
                    break;
            }

        }
    }, [Mode, ModeRefresh]);    // NOTE: Need refresh count to force mult same-mode visits


    useEffect(() => {
        if (AutoDrillStart > 0) {
            console.log("Learn.845:   REACT USE EFFECT!   DELAY AUTO DRILL START...", Date.now()%100000/1000);
            initVideoDisplay("vcanvas","auto_drill.846");        // render to intermediate canvas first
            handleAutoStartDrill("drill1", "effect.auto_drill.850");      // process user state and auto-start drill
            INFO.run_action("start");      // this actually kicks it off
        }
    }, [AutoDrillStart]);


    useEffect(() => {
        setWebcamWidth(INFO.webcam_owidth);
        setWebcamHeight(INFO.webcam_oheight);

        if (EnableWebcam === true) {
            // Note: need to decouple with React var because we hide the webcam in <Result> so need to wait 1 REACT update cycle
            //
            console.log("webcam_start.623:     @@@@@@@@@@@@@@@@@ DELAY WEBCAM START   width=",INFO.webcam_owidth, "  height=",INFO.webcam_oheight, " webcam_started=",INFO.webcam_started, " record_mode=",INFO.record_mode, " output_canvas=",INFO.output_canvas)
            INFO.webcam_started = true;

            initVideoDisplay("vcanvas", "webcam_start.856");        // Note: call this ONLY AFTER element is avail!
            if(INFO.record_mode == true) {
                //recordOutput(INFO.output_canvas, TIMES.start_run, true); // Note: should this be later after calibrate?
                recordOutput(INFO.output_canvas, INFO.file_name, true); // Note: should this be later after calibrate?
            }
            setEnableWebcam(false);    // reset it for repeat
            setRefresh(Date.now());    // signal <Result> to refresh
        }
    }, [EnableWebcam]);


    useEffect(() => {
        //console.log("Learn.311:   EXPAND,History,Fields   Refresh   NextSet",NextSet,"  ShowExpand=", ShowExpand, " vertical=",INFO.vertical_mode);
    }, [ShowExpand, History, Fields, NextSet, Progress, Summary, ShowTutorial, CountdownTime, CountdownName, CountdownMsg, CountdownList]);


    useEffect(() => {
        var [swidth, sheight] = adjustDisplayDiv("videolist.826");
        if ((swidth > 0) && (sheight > 0)) {
            setPlayerVideoWidth(swidth);
            setPlayerVideoHeight(sheight);
            console.log("Learn.597:   . . . . . . . . REFRESH  VideosList  width=",swidth, " height=",sheight);
        }
    }, [VideosList]);


    useEffect(() => {
        if(State.ai_avail == true) {
            console.log("Webcam.156:   ========= AI Models Avail =======");
            setButtonText("START");
        }
    }, [State.ai_avail]);

    useEffect(() => {
        // delayed action, for Perf mode adjustment after React enabled DOM
        //
        if (ShowPerf === true) {
            console.log("Learn.633:   DELAY PERF DISPLAY SETUP START...", Date.now()%100000/1000);
            initVideoDisplay("vcanvas","perf_type.892");        // render to intermediate canvas first

            /* do this in startUserMedia() when camera is ready?
            //
            var output = document.getElementById('drill_output');
            output.setAttribute("width", INFO.video_width);      // NOTE: CAN NOT RELY ON REACT VAR!!!
            output.setAttribute("height", INFO.video_height);
            setCanvasVideoWidth(INFO.video_width);      // NOTE: need to set canvas to actual video size
            setCanvasVideoHeight(INFO.video_height);
            */

            var [swidth, sheight] = adjustDisplayDiv("pertyoe.858");
            setPlayerVideoWidth(swidth);
            setPlayerVideoHeight(sheight);

            var dirs = [{ heading: "MEASURES COGNITIVE REACTION TIME, IMPROVES SPEED-TO-BALL AND ELUSIVE MANEUVER ABILITIES ",
                          value: "" },
                        { title: "SETUP", 
                          value: "Place device in horizontal mode on a tripod or on the ground (no cones needed)",
                         },
                        { title: "ARM",
                          value: "Press START, then stand on each green circle to start the drill" },
                        { title: "RUN",
                          value: "Move explosively to reach highlighted cone, target cone may change" },
                        { title: "HOME",
                          value: "Return to green circle and next round will start" },
                        { title: "TRIPOD",
                          value: "If you need a tripod, an inexpensive one like this will work from ",
                          label: "amazon",
                          link: "https://www.amazon.com/Aureday-Extendable-Adjustable-Smartphone-Compatible/dp/B081CF1DMM"
                        }]
            setUseDirections(dirs);
            console.log("Learn.548:   DELAY PERF DISPLAY SETUP END...", Date.now()%100000/1000);
        }
    }, [ShowPerf]);


    useEffect(() => {
        if(ShowGame === true) {
            var [swidth, sheight] = adjustDisplayDiv("gameset.2605");
            setPlayerVideoWidth(swidth);
            setPlayerVideoHeight(sheight);

            var dirs = [{ heading: "CREATE NEW NEURAL PATH WAYS THROUGH REPETITIVE EYE-FINGER STIMULATIONS, KEY TO IMPROVING COGNITION SPEED",
                            value: "" },
                        { title: "SETUP", 
                            value: "Place device in horizontal mode on a table or another stable surface " },
                        { title: "ARM",
                            value: "Press START then place one finger on the dot to start session" },
                        { title: "RUN",
                            value: "Lift finger ONLY AFTER a new dot appears, quickly press on new dot" },
                        { title: "LEFTIE",
                            value: "Rotate device upside down to orientat for left-handers" }]
            setUseDirections(dirs);
        }

    }, [ShowGame]);

    useEffect(() => {
        if(ShowMock === true) {
            var [swidth, sheight] = adjustDisplayDiv("mockset.997");
            setPlayerVideoWidth(swidth);
            setPlayerVideoHeight(sheight);

            var dirs = [{ heading: "INCREASE INTENT-GENERATION SPEED VIA REAL TIME IN-GAME DECISION MAKING",
                            value: "" },
                        { title: "SETUP", 
                            value: "Place device in horizontal mode on a table or another stable surface " },
                        { title: "ARM",
                            value: "Press START then follow the ball in the film" },
                        { title: "RUN",
                            value: "Press location of the passing target as quickly as possible " }]
            setUseDirections(dirs);
        }

    }, [ShowMock]);


    useEffect(() => {
        //if ((ShowAnalyzeVideo === true) && ((DevRunningAI === true) || (DevRecording === true))) {
        if (ShowAnalyzeVideo === true) {
            console.log("Learn.964:   DELAY ANALYE VIDEO DISPLAY SETUP START...", Date.now()%100000/1000);
            INFO.analysis_canvas = null;
            //initVideoDisplay("output","anal_type.video.969");        // render to intermediate canvas first
            initVideoDisplay("vcanvas","anal_type.video.969");        // render to intermediate canvas first
        }

        if (ShowAnalyzeWebcam === true) {
            console.log("Learn.968:   DELAY ANALYE WEBCAM DISPLAY SETUP START...", Date.now()%100000/1000);
            initVideoDisplay("vcanvas","anal_type.webcam.968");        // render to intermediate canvas first
        }
    }, [ShowAnalyzeVideo, ShowAnalyzeVideo, ShowAnalyzeWebcam, DevRunningAI, DevRecording]);


    useEffect(() => {

        if(SelectedItem.url) {
            //var is_vimeo = (SelectedItem.url.indexOf("vimeo") >= 0) ? true : false;
            //var is_vimeo = (SelectedItem.url.includes("youtu") === true) ? true : false;
            //var player_type = (SelectedItem.url.includes("youtu") === true) ? "youtube" : "vimeo";
            var iframe = document.querySelector("iframe");

            var player_type = findVideoType(SelectedItem.url);
            setPlayerType(player_type);
            console.log("video_ready.614:        ~~~~~~~~~~~~ <Learn> VIDEO IFRAME READY  url=", SelectedItem.url, " player_type=",player_type, " Item=",SelectedItem);
            //if ((INFO.game_mode == false) && (iframe !== null) && (iframe !== undefined)) 
            if (iframe && (INFO.game_mode == false)) {
                if (INFO.learn_player !== null) {

                    var [swidth, sheight] = adjustDisplayDiv("video_ready.899");
                    setPlayerVideoWidth(swidth);
                    setPlayerVideoHeight(sheight);

                    var speed = (INFO.slowmo_mode == true) ? 0.5 : 1.0;
                    setPlayerSpeed(INFO.learn_player, speed);
                    setRefresh(Date.now());    // signal <Result> to refresh
                }
            }
        }
    }, [VideoFrameReady]);


    // **** LOCAL: SCREEN ORIENTATION ADJUST *****
    //      - triggered by INFO.setState()
    //
    useEffect(() => {
        //console.log("learn.739:      .....DASHBORD ORIENTATION REFRESH", Orientation);
        configScreenOrientation();
    }, [Orientation]);


    useEffect(() => {
        //console.log("learn.739:      .....DASHBORD ORIENTATION REFRESH", Orientation);
    }, [ShowAnalyzeWebcam, ShowAnalyzeVideo ]);


    useEffect(() => {
        //console.log("learn.739:      .....DASHBORD ORIENTATION REFRESH", Orientation);
    }, [PlayerVideoWidth, PlayerVideoHeight ]);

    useEffect(() => {
        //console.log("learn.739:      .....DASHBORD ORIENTATION REFRESH", Orientation);
    }, [DevRunningAI, DevRecording, MakingDrillStart]);

    useEffect(() => {
        //console.log("learn.739:      .....DASHBORD ORIENTATION REFRESH", Orientation);
    }, [HideInstruction, HideResult]);

    useEffect(() => {
        //console.log("learn.739:      .....DASHBORD ORIENTATION REFRESH", Orientation);
    }, [HandsFree, ShowRaiseHand, BotSlaveNote, BotSlaveRanks]);

    useEffect(() => {
        if (ShowBotSlave === true) {
            if (INFO.bot_setup) {
                var slave_notes = getUserNames(INFO.bot_setup.users);
                setBotSlaveNote(slave_notes);
            }
            var slave_ranks = getUserPerfList(INFO.bot_all_stats, INFO.drill_hash, "effect_show_bot.1035");   // display peer stats in this class
            setBotSlaveDrillTitle(INFO.drill.name+" RANKING");
            setBotSlaveRanks(slave_ranks);
        }
    }, [ ShowBotSlave ]);

    useEffect(() => {
        console.log("webcam.1006:     USE_EFFECT   DoStartChallengeWebcam=",DoStartChallengeWebcam," webcam_started=",INFO.webcam_started);
        if ((DoStartChallengeWebcam > 0) && (INFO.webcam_running === false)) {
            startChallengeWebcam();      // sync up with React Update
        }
    }, [DoStartChallengeWebcam]);

    useEffect(() => {
        console.log("webcam.908:     USE EFFECT   DoStartPracticeWebcam=",DoStartPracticeWebcam, " webcam_started=",INFO.webcam_started);
        if ((DoStartPracticeWebcam > 0) && (INFO.webcam_running === false)) {
            startPracticeWebcam();      // sync up with React Update
        }
    }, [DoStartPracticeWebcam]);




    useEffect(() => {
        var player = INFO.learn_player;
        // create drill sequence
        //     - After create_drill is setup
        //     - auto play the video and set a auto-pause at the end
        //     - when video paused, stop mediaRecording and write video to vimeo
        //
        if ((AnalyzePlayerPaused === true) && player) {
            console.log("learn.907:     ! ! ! ! ! ! VIDEO PAUSED  AnalyzePlayerPaused=", AnalyzePlayerPaused, " PlayerPausedAutoSave=", PlayerPausedAutoSave, " PlayerPausedReplay=", PlayerPausedReplay, " AnalyzerAutoTrainAI=", AnalyzerAutoTrainAI, " DevRunningAI=",DevRunningAI);
            if (PlayerPausedAutoSave === true) {
                // start save video to vimeo
                console.log("learn.855:      ..... VIDEO PAUSED, STOP RECORDING AND WRITE TO VIMEO");
                setAnalyzePlayerPaused(false);
                setPlayerPausedAutoSave(false);
                setAnalyzerRefresh(AnalyzerRefresh+1);

                INFO.dev_video_stopped = true;      // signal to stop
                recordOutput(INFO.output_canvas, "stop.analyze.1135", false);

            } else if (PlayerPausedReplay === true) {
                // keep looping
                console.log("learn.862:      ..... VIDEO PAUSED, BUT KEEP LOOPING");
                player.setTime(VideoRecordStart);
                player.setStop(VideoRecordEnd);
                player.start();
                setAnalyzePlayerPaused(false);
                setAnalyzerRefresh(AnalyzerRefresh+1);
            }









            // If running AI and in auto train mode, run kluster and create pattern
            //    - this is where we do loop-repeat of footage to collect more data (rely on random AI variations)
            //
            if ((AnalyzerAutoTrainAI === true) && (DevRunningAI === true)) {
                var markers =  INFO.knn_player_markers;

                if ((INFO.knn_token_dictionary.length === 0) && (PlayerPausedReplay === false)) {
                    console.log("learn.956:   # # # # # # # # # START CRUNCH DRILL TRAINING DATA.... marker.len",markers.length, " paused=",player.paused );

                    processKnnData(markers);
                }

            }










        }
    //}, [AnalyzerRefresh, AnalyzePlayerPaused, PlayerPausedAutoSave, PlayerPausedReplay]);
    }, [AnalyzerRefresh]);

    // NOTE: THESE BINARY VARS REQUIRE STATE CHANGES TO TRIGGER, NOT WHEN SET!


    useEffect(() => {
        if ((HasVideoEnds === false) && (VideoRecordStart > 0) && (VideoRecordEnd > 0)) {
            setHasVideoEnds(true);
        }
    }, [VideoRecordEnd, VideoRecordEnd, HasVideoEnds]);

    useEffect(() => {
        console.log("learn.1090:      ..... LIMB STATE REFRESH: ",TLState, " ", TRState," ",  BLState," ",  BRState);
    }, [TLState, TRState, BLState, BRState, CHState, CBState]);



    /****************************************** END OF USE EFFECTS ********************************/




    // EVENT: **** LOCAL: SCREEN ORIENTATION ADJUST *****
    //      - call from EventListener()
    //      - WARNING: Event listeners do not have access to React STATE!!!
    //
    // NOTE: Once orientation chg detected, set a global State cnt, then chk window dimensions in React and make adjust
    function eventAdjustOrientation() {
        console.log("learn.556:    DASHBOARD ORIENTATION DETECTED  Orientation=",Orientation);
        //INFO.setState("adjust_orientation", INFO.State.adjust_orientation + 1);
        INFO.refresh_cnt = INFO.refresh_cnt + 1;
        setOrientation(INFO.refresh_cnt);
    }

    // **** LOCAL: SCREEN ORIENTATION ADJUST *****
    //      - call from userEffect()
    //      - MUST BE LOCAL
    function configScreenOrientation() {
            var wd = window.innerWidth;
            var ht = window.innerHeight;
            var [vertical_mode, screen] = setScreenOrientation(wd, ht, "DASH.INIT.589");
            INFO.vertical_mode = vertical_mode;
            setVerticalMode(vertical_mode);
            if((vertical_mode === true) && (INFO.enforce_horizontal_mode === true)) {
                setShowNeedHorizontal(true);      // : DISABLE FOR FLOOR TESTING
            } else {
                setShowNeedHorizontal(false);
            }

            console.log("learn.569:      ......ORIENTATION wd=",wd, "  ht=",ht, " veritical_mode=", vertical_mode);
            var [swidth, sheight] = adjustDisplayDiv("scrn_orientation.1077");
            setPlayerVideoWidth(swidth);
            setPlayerVideoHeight(sheight);
    }


    // EVENT:
    //
    const storeStateCompleted = event => {
        console.log("Learn.370:   WAIT SPINNER STOPPED!", " now=",(Date.now()%100000 / 1000));
        setOperationComplete(true);     // TODO
        setShowWaitSpinner(false);
        setConfirmation("Operation Completed!")






        // :   kick off next auto drill operation here
        //    - set a flag to say we are done, auto_drill keep checking until op is done
        INFO.db_store_completed = true;
        INFO.db_store_started = false;








    }



    function processTodayItems(mode, drills, today) {
        if ((today === undefined) || (today === null))  return;
        //console.log("learn_load.394:    GOT TODAY sequences=", today);
        //setAllToday(today);     // all the today sequences, moved down

        // return only unfinished drills assigned in the sequence flow
        //var ITEMS = ndrills.filter(drill => { return drill.type == mode });
        //var items = processDrills(ITEMS);
        var pitems = processDrillsFromSequence(drills, today);

        // group the similar drill items today to allow chaining
        //
        var items = [];
        var types = ["skill", "cond", "perf", "game", "mock" ];
        for (var t in types) {
            var type = types[t];
            var od = pitems.filter(item => { return item.type == type});
            console.log("learn_load.1189:       . . . ADDING  =",od);
            items = items.concat(od);
        }

        console.log("learn_load.410:  FINAL TODAY DRILLS    mode=",mode," today=",today.length, " today=",today, "  items=", items);  //.length);
        //setAllToday(pitems);            // today drills sorted by seq
        INFO.all_today = pitems;
        setTodayCatalogItems(items);    // grouped by type then sorted by seq
        if (mode == "today") {
            setCatalogItems(items);     // activate it now
        }
        setRefresh(Date.now());  
    }


    // select sections for a particular mode
    //    - old way: each drill -> section
    //    - new way: prog -> section -> sequence -> drill
    //    - for each mode we select the drills
    //    - how to go from drill -> section.... map it at the server
    //    - "today" is treated specially, since it goes across drill types
    //    - "event" is chain mode of "today", so treated the same way
    //
    function processSectionItems(mode, drillz, all_sections) {
        if ((all_sections === undefined) || (all_sections === null))  return;
        //var sections = all_sections.filter(section => { return section.type == mode });

        console.log("section.906:    SECTIONS  mode=",mode,"  all_sections=",all_sections);
        var sections = all_sections;
        sections.sort(arraySeqAscSort);


        // TODAY IS PROCESS IN processTodayItems()?
        if ((mode === "today") || (mode === "event")) {
            var sections = all_sections.filter(section => { return section.type == "today" });
            sections.sort(arraySeqAscSort);
            setCatalogGroups(sections);
            return;
        }


        var drills = drillz.filter(drill => { return drill.type == mode });
        var section_hashz = [];
        for (var i in drills)  {
            var drill = drills[i];
            var section_hash = drill.section_hash;

            // find sections used by these drills, dedup
            //
            if (section_hashz.includes(section_hash) === false) {
                section_hashz.push(section_hash);
            }
        }
        console.log("section.915:    SECTIONS  drills=",drills, " section_hashz=",section_hashz," mode=",mode);

        var sections = [];
        var items = [];
        for (var j in section_hashz) {
            var section_hash = section_hashz[j];
            var section = all_sections.filter(section => { return section.hash == section_hash });
            if(section.length > 0) {
                sections.push(section[0]);
                //sections = sections.concat(section[0]);
            }

            //var itemz = drillz.filter(drill => { return drill.section_hash == section_hash });
            var itemz = drills.filter(drill => { return drill.section_hash == section_hash });
            for (var i in itemz) {
                var item = itemz[i];
                if(item.drill_key !== undefined) {
                    // in case we got garbage items (like section from seq)
                    //
                    //console.log("section.925:          .  .  .  .  itemz=",itemz, " section_hash=",section_hash, " section=",section[0]," mode=",mode);
                    items = items.concat(item);
                } else {
                    console.error("section.947:          ! ! ! ! ! !  ERROR: BAD itemz=",item, " section_hash=",section_hash, " section=",section[0]," mode=",mode);
                }
            }
        }

        sections.sort(arraySeqAscSort);
        setCatalogGroups(sections);
        setAllSections(all_sections);
        console.log("section.287:  ********  SECTIONS mode=",mode," sections=", sections, " all_sections=",all_sections);


        setCatalogItems(items);     // only for browsing mode
        setRefresh(Date.now());  
        console.log("section.351:  LOADED SECTION   mode=",mode,"  items=", items.length, " sections=", sections.length);

    }


    // read in state from db if not already read
    //
    async function ReadUserStateInfo(mode) {
    // TODO: add caching and avoid additional db reads
    // TODO: read only drills eligible for this player

        console.log("learn.663:  ******** START READ_USER_STATE_INFO()  MODE=", mode, " org_key=",INFO.org_key);
        if(INFO.org_key === null) {
            console.log("learn.839:                 WAITING....NO INFO FROM DB YET!");
            return;
        }
        
        var drills = null;
        if(INFO.db_drills == null) {
            console.log("drill.674: !!!!!!!!!!!!!!! NO DRILLS DB YET");
            drills = await ReadDrillData()
            .then( drills0 => {
                var drills = processDrillItems(drills0);
                //INFO.db_drills = Object.assign({}, drills);
                setAllDrills(drills);
                return drills;
            });
        } else {
            drills = processDrillItems(INFO.db_drills);
            //INFO.db_drills = Object.assign({}, drills);
            setAllDrills(drills);
        }
        console.log("drill.664: ############### PROCESSED DRILL ITEMS", drills.length, " ", drills);


        // for finger games
        //
        if(INFO.db_motions == null) {
            ReadMotionData()
            .then( motions => {
                setAllMotions(motions);
                return motions;
            });
        } else {
            setAllMotions(INFO.db_motions);
        }


        var owner_hash = "usr:" + INFO.email;
        if (INFO.db_states === null) {
            ReadStateData(owner_hash)
            .then( states => {
                INFO.db_tutorials = processStateItems("tutorials", states);
            })
        } else {
            INFO.db_tutorials = processStateItems("tutorials", INFO.db_states);
        }


        if (INFO.db_today === null) {
            console.log("drill.715: !!!!!!!!!!!!!!! NO TODAY YET", INFO.db_today)
            ReadTodayData()
            .then( today => {
                processTodayItems(mode, drills, today);
            })
        } else {
            processTodayItems(mode, drills, INFO.db_today);
        }


        if (INFO.db_sections === null) {
            //for(var j = 0; j < drills.length; j++) {
            //    console.log("drill.605:           ",j,"   ",drills[j].seq);
            //}
            ReadSectionData()
            .then( all_sections => {
                processSectionItems(mode, drills, all_sections);
            });
        } else {
            processSectionItems(mode, drills, INFO.db_sections);
        }

        /* KLUDGE: **** ALREADY CALLED FROM loadUserState()
        if ((INFO.org_key !== null) && (INFO.drill_hash !== null)) {
            //ReadUserStateInfo(mode);
            console.log("ReadUserStateInfo.934:         SEND SIGNAL TO Read User State ");
            window.dispatchEvent(INFO.has_user_state_event);
        }
        /**/

        setRefresh(Date.now());
}



    // EVENT: process user gesture signals (dispatched by the lower analysis loop)
    //    - process new cmd, check for repetition
    //    - take action if not in cool down period
    //
    function handleGestureDetected() {
        var last_time = null, last_cmd = null;
        console.log("gesture.1767:           # # # # WAKEUP!   PROCESS GESTURE   ", INFO.knn_gestures, " last_gest_idx=", INFO.knn_last_gesture_idx, " INFO.max_sidebar=",INFO.max_sidebar, " allowed=",INFO.gesture_allowed, " now=",(Date.now()%100000 / 1000));
        if ((INFO.gesture_allowed === false)) { return };        // don't detect too early

        var gg = INFO.knn_gestures.length - 1;
        var lg = INFO.knn_last_gesture_idx;

        for (var g = gg; g >= lg; g--) {
            var gesture = INFO.knn_gestures[g];
            var cmd = gesture.cmd;
            var time = gesture.time;
            var same = gesture.same;
            console.log("gesture.1389:              . . . g=",g, " cmd=",cmd, " time=",time, " same=",same, "  gest_allowed=", INFO.gesture_allowed);

            if(INFO.gesture_allowed === false) break;       // KLUDGE: DO IT ONLY ONCE
            if (INFO.knn_last_gesture) { 
                last_time = INFO.knn_last_gesture.time;
                last_cmd =  INFO.knn_last_gesture.cmd;
            } else {
                last_time = 0;
                last_cmd = null;
            }
            var dt = time - last_time;

            // need to hold position, if same cmd again enforce cool off period
            //
            console.log("gesture.1122:           . . . dt=",dt, " last_time=",last_time, " same=",same, " cmd=",cmd, " last_cmd=",last_cmd);
            if ((same >= CONSTS.LIMB_MAX_SAME_POSE) && (!last_cmd || (last_cmd !== cmd) || ((last_cmd === cmd) && (dt > 200)))) {
                INFO.knn_gestures[g].used = true;
                INFO.knn_last_gesture = Object.assign({}, gesture);
                console.log("gesture.1806:          # # # # #   ACTING ON GESTURE  ", cmd, "   idx=",g, " now=",(Date.now()%100000 / 1000));

                // need to validate with repeats and scores
                //
                switch (cmd) {
                    case "RRAISE":
                    case "LRAISE":
                        if ((INFO.has_calibration === false)) {
                            setShowRaiseHand(false);
                            handleExpand("gesture_event.1773");       // keep drill video expanded



        INFO.gesture_allowed = false;       // KLUDGE: DO IT ONLY ONCE    XXCD
        INFO.disable_calibration = false;   // KLUDGE: WHERE SHOULD DO THIS RIGHT?




                            playAudio(CONSTS.MINOR_PROGRESS_PATH, "got_gesture.1436");
                        }
                        break;
                }
            }
        }
        INFO.knn_last_gesture_idx = gg;
    }



    // EVENT: FROM populateSTATSSummary() signal back to REACT so we can update display
    //     - collect relevent goal stats based on practice
    //     - display performance summary
    //
    function updateDrillSummary(from) {
        var outputs = [], acceptable = true, reason = "INCOMPLETE";
        var out = {}, out1 = {}, m1, new_record = false;
        var m0, m1, m2, m3;
        var next_rec = INFO.personal_record.next_rec;       // target to reach new record
        var limit_rec = INFO.personal_record.limit_rec;     // lower limit, below is invalid
        limit_rec = (INFO.drill_tot_rep_cnt > 6) ? limit_rec : 0;   // KLUDGE: return good stats for test mode

        if ((INFO.bug_report !== "") || (INFO.summary_created === true)) {
            return;     // no summary if aborted
        }
        if(INFO.auto_completed === false) {
            reason = "INCOMPLETE RUN"
            acceptable = false;     // did not finish
            console.log("train.720: XXXXXXXXXXXXX  UNACCEPTABLE RESULT, NOT Autocompete!");
        }

        if(INFO.practice_mode === true) {
            if (STATS.t00 < limit_rec) {
                reason = "DETECTION ERROR-1";     // outside possible range
                acceptable = false;
            }

            if (acceptable === false) {
                STATS.t00 = -STATS.t00;
            } else {
                INFO.session_completed = true;
                reason = "SUCCESS";
            }


            STATS.ss0 = calcSessionScore(INFO.drill, STATS);
            STATS.ss0_cnt = 1;

            out1.title = "SS0:";
            out1.value = (acceptable == false) ? "INCOMPLETE" : STATS.ss0 + " points";
            m0 = out1.title + " " + out1.value;
            out = {...out1};
            outputs.push(out);

            out1.title = "T00:";
            out1.value = (acceptable == false) ? "INCOMPLETE" : STATS.t00 + " sec" + "  (" + STATS.t00_cnt + ")";
            m1 = out1.title + " " + out1.value;
            out = {...out1};
            outputs.push(out);

            out1.title = "H00:";        // head UP %
            out1.value = (acceptable == false) ? "INCOMPLETE" : STATS.h00 + " %";
            m2 = out1.title + " " + out1.value;
            out = {...out1};
            outputs.push(out);

            console.log("train.918:  update PRACTICE STATS SUMMARY  best=",INFO.personal_record, " out=",outputs);

            //var rtype = INFO.personal_record.field;
            // TODO: need to check if low_is_best
            //
            next_rec = (next_rec === null) ? 99999999 : next_rec;
            if ((acceptable === true) && (STATS.t00 > 0) && (STATS.t00 <= next_rec)) {
                console.log("train.925: +++++++  NEW PRACTICE RECORD!  new_rec=",STATS.t00, "  thresh=",next_rec);
                new_record = true;
            }

            INFO.notify_messages = [];
            INFO.notify_messages.push(m0);
            INFO.notify_messages.push(m1);
            INFO.notify_messages.push(m2);
            INFO.webcam_started = false;
            setButtonText("START");
            //setINFO.webcam_started(false);
            //setGameStarted(false);

        } else if(INFO.defender_mode === true) {

            // TODO: standardize this with populateSTATSSummary() for perf and practice
            // TODO: need to account for both r00 & r01...means INFO.personal_best chg!
            acceptable = true;
            if (acceptable === false) {
                STATS.c01 = -STATS.c01;
                STATS.c02 = -STATS.c02;
            } else {
                INFO.session_completed = true;
                reason = "SUCCESS";
            }



            // need to reconcile with populateSTATSSummary() !!!!!



            STATS.ss0 = calcSessionScore(INFO.drill, STATS);
            STATS.ss0_cnt = 1;

            var outputs = [];
            var out = {}, out1 = {};

            out1.title = "SS0:";
            out1.value = (acceptable == false) ? "INCOMPLETE" : STATS.ss0 + " points";
            m0 = out1.title + " " + out1.value;
            out = {...out1};
            outputs.push(out);

            out1.title = "C01:";
            out1.value = (acceptable == false) ? "INCOMPLETE" : STATS.c01.toFixed(2) + "  (" + STATS.c01_cnt + ")";
            m1 = out1.title + " " + out1.value;
            out = {...out1};
            outputs.push(out);

            /* out1.title = "C02:";
            out1.value = (acceptable == false) ? "INCOMPLETE" : STATS.c02 + "  (" + STATS.c02_cnt + ")";
            m2 = out1.title + " " + out1.value;
            out = {...out1};
            outputs.push(out); */
            console.log("webcam.1538:  update DEFENDER STATS SUMMARY ",outputs);

            // TODO: need to check if low_is_best
            //
            next_rec = (next_rec === null) ? 99999999 : next_rec;
            if ((acceptable === true) && (STATS.c01 > 0) && (STATS.c01 > next_rec)) {
                console.log("train.970:  +++++++ NEW DEFENDER RECORD!  new_rec=",STATS.c01, "  thresh=",next_rec);
                new_record = true;
            }

            INFO.notify_messages = [];
            INFO.notify_messages.push(m0);
            INFO.notify_messages.push(m1);
            INFO.webcam_started = false;
            setButtonText("START");


        } else if(INFO.perf_mode === true) {

            // TODO: standardize this with populateSTATSSummary() for perf and practice
            // TODO: need to account for both r00 & r01...means INFO.personal_best chg!
            if (STATS.r00 < limit_rec) {
                reason = "DETECTION ERROR-2";     // outside possible range
                acceptable = false;
            }

            if (acceptable === false) {
                STATS.r00 = -STATS.r00;
                STATS.r01 = -STATS.r01;
            } else {
                INFO.session_completed = true;
                reason = "SUCCESS";
            }


            STATS.ss0 = calcSessionScore(INFO.drill, STATS);
            STATS.ss0_cnt = 1;

            var outputs = [];
            var out = {}, out1 = {};

            out1.title = "SS0:";
            out1.value = (acceptable == false) ? "INCOMPLETE" : STATS.ss0 + " points";
            m0 = out1.title + " " + out1.value;
            out = {...out1};
            outputs.push(out);

            out1.title = "R00:";
            out1.value = (acceptable == false) ? "INCOMPLETE" : STATS.r00 + " msec" + "  (" + STATS.r00_cnt + ")";
            m1 = out1.title + " " + out1.value;
            out = {...out1};
            outputs.push(out);

            out1.title = "R01:";
            out1.value = (acceptable == false) ? "INCOMPLETE" : STATS.r01 + " msec" + "  (" + STATS.r01_cnt + ")";
            m2 = out1.title + " " + out1.value;
            out = {...out1};
            outputs.push(out);
            console.log("webcam.742:  update PERF STATS SUMMARY ",outputs);

            // TODO: need to check if low_is_best
            //
            next_rec = (next_rec === null) ? 99999999 : next_rec;
            if ((acceptable === true) && (STATS.r00 > 0) && (STATS.r00 <= next_rec)) {
                console.log("train.970:  +++++++ NEW PERF RECORD!  new_rec=",STATS.r00, "  thresh=",next_rec);
                new_record = true;
            }

            INFO.notify_messages = [];
            INFO.notify_messages.push(m0);
            INFO.notify_messages.push(m1);
            INFO.notify_messages.push(m2);
            INFO.webcam_started = false;
            setButtonText("START");

        } else if(INFO.game_mode === true) {

            // TODO: move this up to populateSTATSSummary() for perf and practice?
            //
            var [ ravg, rcnt ] = removeOutliers(TIMES.game_perf_react, "GAME_REACT_R04");   // react data
            var [ gavg, gcnt ] = removeOutliers(TIMES.game_perf_good, "GAME_GOOD_T04");     // good runs (but not all are "good")
            var [ bavg, bcnt ] = removeOutliers(TIMES.game_perf_bad, "GAME_BAD");           // bad runs

            STATS.r04 = Math.floor(ravg);    // reaction time: from shown to finger lift
            STATS.r04_cnt = rcnt;
            STATS.t04 = Math.floor(gavg);
            STATS.t04_cnt = gcnt;
            STATS.a04 = Math.floor((gcnt / (gcnt + bcnt) * 100));
            STATS.a04_cnt = gcnt + bcnt;

            if (STATS.r04 < limit_rec) {
                reason = "DETECTION ERROR-3";     // outside possible range
                acceptable = false;
            }

            if (rcnt < CONSTS.GAME_MIN_VALID_DATA) {
                reason = "FAILED: LOW CNT"
                acceptable = false;
            }

            // poor accuracy, invalidate the run
            if (STATS.a04 < CONSTS.GAME_MIN_ACCURACY) {
                //reason = "LOW ACC"+STATS.a04+"%";
                reason = "FAILED: POOR ACC"
                acceptable = false;
            }

            if (acceptable === false) {
                STATS.r04 = -STATS.r04;
                STATS.t04 = -STATS.t04;
                STATS.a04 = -STATS.a04;
                console.log("train.769: XXXXXXXXXXXXX  UNACCEPTABLE RESULT!  accuracy=",STATS.a04, "  rcnt=", rcnt, " reason=", reason);
            } else {
                INFO.session_completed = true;
                reason = "SUCCESS";
            }
            console.log("drl_sum.755:  GAME  next_rec=",next_rec, " limit_rec=",limit_rec, " ravg=",ravg, " gavg=",gavg, " bavg", bavg, " a04=",STATS.a04, " rcnt=",rcnt, " accept=",acceptable, " reason=",reason);

            STATS.tt0 = Date.now() - TIMES.session_start;        // KLUDGE: DOES THIS WORK?
            STATS.tt0_cnt = 1;

            STATS.ss0 = calcSessionScore(INFO.drill, STATS);
            STATS.ss0_cnt = 1;

            var outputs = [];
            var out = {}, out1 = {};

            out.title = "SS0:";
            out.value = (acceptable == false) ? "INCOMPLETE" : STATS.ss0 + " points";
            m0 = out.title + " " + out.value;
            out1 = {...out};
            outputs.push(out1);

            out.title = "R04:";
            out.value = Math.abs(STATS.r04) + " msec  " + "("+rcnt+")";
            m1 = out.title + " " + out.value;
            out1 = {...out};
            outputs.push(out1);

            out.title = "T04:";
            out.value = Math.abs(STATS.t04) + " msec  " + "("+gcnt+")";
            m2 = out.title + " " + out.value;
            out1 = {...out};
            outputs.push(out1);

            out.title = "A04:";
            out.value = Math.abs(STATS.a04) + "%  " + "("+(gcnt + bcnt)+")";
            m2 = out.title + " " + out.value;
            out1 = {...out};
            outputs.push(out1);
            console.log("train.787:  update GAMES SUMMARY ",outputs, STATS);

            // in case we want to show on canvas
            INFO.notify_messages = [];
            INFO.notify_messages.push(m0);
            INFO.notify_messages.push(m1);
            INFO.notify_messages.push(m2);
            INFO.notify_messages.push(m3);

            // TODO: need to check if low_is_best
            //
            next_rec = (next_rec === null) ? 99999999 : next_rec;
            if ((acceptable === true) && (STATS.r04 > 0) && (STATS.r04 <= next_rec)) {
                console.log("train.1047:  +++++++ NEW GAMES RECORD!  new_rec=",STATS.r04, "  thresh=",next_rec);
                new_record = true;
            }

            INFO.webcam_started = false;
            setGameStarted(false);

        } else if(INFO.mock_mode === true) {
            // post process
            var [ ravg, rcnt ] = removeOutliers(TIMES.mock_perf_react, "MOCK_REACT_R05");   // react data
            var [ gavg, gcnt ] = removeOutliers(TIMES.mock_perf_good, "MOCK_GOOD_T05");     // good runs (but not all are "good")
            var [ bavg, bcnt ] = removeOutliers(TIMES.mock_perf_bad, "MOCK_BAD_R05");           // bad runs

            STATS.r05 = Math.floor(ravg);    // reaction time: from shown to finger lift
            STATS.r05_cnt = rcnt;
            STATS.a05 = Math.floor((gcnt / (gcnt + bcnt) * 100));
            STATS.a05_cnt = gcnt + bcnt;
            console.log("drl_sum.1215:  MOCK CALC  gcnt=",gcnt, " bcnt=",bcnt, " ravg=",ravg, " rcnt=",rcnt);

            if (STATS.r05 < limit_rec) {
                reason = "DETECTION ERROR-4";     // outside possible range
                acceptable = false;
            }

            //if (rcnt < CONSTS.GAME_MIN_VALID_DATA) 
            if (rcnt < 1) {
                reason = "FAILED: LOW CNT"
                acceptable = false;
                console.log("train.769: XXXXXXXXXXXXX  UNACCEPTABLE RESULT!  accuracy=",STATS.a05, "  rcnt=", rcnt, " reason=", reason);
            } else {
                INFO.session_completed = true;
                reason = "SUCCESS";
            }
            console.log("drl_sum.1231:  MOCK  next_rec=",next_rec, " limit_rec=",limit_rec, " ravg=",ravg, " gavg=",gavg, " bavg", bavg, " a05=",STATS.a05, " rcnt=",rcnt, " accept=",acceptable, " reason=",reason);

            STATS.ss0 = calcSessionScore(INFO.drill, STATS);
            STATS.ss0_cnt = 1;

            var outputs = [];
            var out = {}, out1 = {};

            out1.title = "SS0:";
            out1.value = (acceptable == false) ? "INCOMPLETE" : STATS.ss0 + " points";
            m0 = out1.title + " " + out1.value;
            out = {...out1};
            outputs.push(out);

            out.title = "R05:";
            out.value = Math.abs(STATS.r05) + " msec  " + "("+rcnt+")";
            m1 = out1.title + " " + out1.value;
            out1 = {...out};
            outputs.push(out1);

            out.title = "A05:";
            out.value = Math.abs(STATS.a05) + "%  " + "("+(gcnt + bcnt)+")";
            m2 = out1.title + " " + out1.value;
            out1 = {...out};
            outputs.push(out1);
            console.log("train.1255:  update MOCK SUMMARY ",outputs, STATS);

            // in case we want to show on canvas
            INFO.notify_messages = [];
            INFO.notify_messages.push(m0);
            INFO.notify_messages.push(m1);
            INFO.notify_messages.push(m2);

            // TODO: need to check if low_is_best
            //
            next_rec = (next_rec === null) ? 99999999 : next_rec;
            if ((acceptable === true) && (STATS.r05 > 0) && (STATS.r05 <= next_rec)) {
                console.log("train.1047:  +++++++ NEW MOCK RECORD!  new_rec=",STATS.r05, "  thresh=",next_rec);
                new_record = true;
            }

           INFO.webcam_started =false;
            //setMockStarted(false);
            setMockStarted(0);

        }

        if (INFO.bot_stats) {
            INFO.bot_stats["ss0"] = STATS.ss0;      // Note: is this the best way to do this?
            INFO.bot_stats["ss0_cnt"] = STATS.ss0_cnt;
        }

        // if a new personal best, show <ValidateRun>
        //
        if ((new_record === true) && (INFO.drill_chain_mode === false)) {
            setValidateRun(true);
            reason = "NEW RECORD!"
            INFO.validate_passed = false;
        } else {
            setValidateRun(false);
            setShowWaitSpinner(true);
            updateProgressStatus("20%");
            INFO.validate_passed = true;
        }

        INFO.notify_title = reason;
        INFO.summary_created = true;
        console.log("train.789:  UPDATE DRILL SUMMARY  from=",from, " reason=",reason, " outputs=",outputs, " chain=",INFO.drill_chain_mode);
        updateSessionCountCache(INFO.seq_hash);
        //timerDisplayResult("Update.Drill");

        setOutcome(reason);
        setSummary(outputs);
        setShowWait(true);
        setRefresh(Date.now());
        if (INFO.drill_chain_mode === true) {
            setTimeout(()=> { 
                setShowWait(false); 
                setRefresh(Date.now());
            }, 6000)
        }
    }


    // update today_cnt in cached object so we don't need to read from db
    //
    function updateSessionCountCache(seq_hash) {

        // update raw database copy (avoids a db read later)
        //
        for (var i = 0; i < INFO.db_today.length; i++) {
            var today = INFO.db_today[i];
            //console.log("sess_cnt.908:    CHECK UPDATE TODAY   today.hash=", today.hash,  "   seq_hash=",seq_hash);
            if(today.hash == seq_hash) {
                var cnt = today.today_cnt;   // could be " ", "", undefined, [0-9], ["0"-"9"]
                if ((cnt === undefined) || (cnt === "") || (cnt === " ")) cnt = 0;
                if (typeof(cnt) == "string") cnt = parseInt(cnt);
                today.today_cnt = cnt + 1;
                console.log("sess_cnt.909:   + + + + UPDATE TODAY today_cnt=", today.today_cnt);
            }
        }

        var store = false;
        var ctodays = JSON.parse(JSON.stringify(TodayCatalogItems));      // deep copy array of objects
        console.log("sess_cnt.1698:   + + + + EXISTING TODAY  seq_hash=",seq_hash, "  ctodays=", ctodays, "  catalog=",CatalogItems, " chain=",INFO.drill_chain_mode);
        for (var i = 0; i < ctodays.length; i++) {
            var today = ctodays[i];
            if(today.seq_hash === seq_hash) {
                var cnt = today.today_cnt;   // could be " ", "", undefined, [0-9], ["0"-"9"]
                    if ((cnt === undefined) || (cnt === "") || (cnt === " ")) cnt = 0;
                if (typeof(cnt) == "string") cnt = parseInt(cnt);
                today.today_cnt = cnt + 1;
                store = true;
            }
        }

        if (store === true) {
            setCatalogItems(ctodays);
            setTodayCatalogItems(ctodays);
            setCatalogRefresh(CatalogRefresh+1);
            console.log("sess_cnt.1715:   + + + + UPDATE TODAY today_cnt=", ctodays, " all_today=",INFO.all_today);
        }
    }



    // while WaitSpinner is on, periodic wakes up and update Progress
    //
    function updateProgressStatus(){
        if(ShowWaitSpinner === true) {
            console.log("progress.1834:   UPDATE PROGRESS.......",INFO.progress_message);
            setProgress(INFO.progress_message);
            setTimeout(()=> {
                updateProgressStatus();
            }, 1000)
        } else {
            setProgress("");
        }
    }




    // Notice: practice instructions, how many reps per set and how many sets
    //
    const handleDismissNotice = event => {
        console.log("train.262:  DISABLE STEPS event=",event);
        setShowNotice(false);
    }

    // Notice: practice instructions, how many reps per set and how many sets
    //
    const handleDashboardSelect = mode => {
        console.log("dash_select.967:  SELECT DASHBOARD MODE =",mode);
        INFO.disable_calibration = false;       // manual selection, always calibrate

        initAudio();
        /* switch (mode){
            case "today":       // RUN TODAY AUTO-START DRILLS FROM DASHBOARD
                INFO.drill_chain_mode = true;
                processChainedTodayDrill("start", "dash_select.1862");   // Note: decide which drill to start and resume flow if needed
                break;
        } */

        setMode(mode);
        setModeRefresh(ModeRefresh+1);  // for repeat of same Mode
        if(TabHistory[mode] !== undefined) {
            setTabSelected(TabHistory[mode]);
        } else {
            setTabSelected(0);
        }
        handleGoCatalog();
    }


    // process the validation submit where user approves the result
    //
    const handleSubmitWait = event => {
        console.log("train.2358:  VALIDATE SUBMIT  "); 
        setValidateRun(false);
        INFO.validate_passed = true;
        window.dispatchEvent(INFO.wakeup_db_event);    // History is writtent to db bucket

        //setConfirmation(null);
        //setShowWaitSpinner(true);
    }

    const handleDismissWait = event => {
        console.log("train.2458:  DISMISS <WAIT>   ShowGame=",ShowGame, "  ShowDrill=",ShowDrill,"  GameCnt=", GameCnt);
        setConfirmation(null);
        //if(ShowWaitSpinner == false) { }  // WAS: only able to dismiss when complete
        setShowWait(false);   // Dismiss display but may still run in background
        if(INFO.bug_report !== "") {
            setLearnRedirect(true);
            setLearnTarget("/menu");
            setRefresh(Date.now());
        }

        if(INFO.game_mode == true) {
            INFO.sidebar_width = CONSTS.SIDEBAR_SMALL_WIDTH;
            INFO.sidebar_height = CONSTS.SIDEBAR_HEIGHT;
            setGameStarted(false);      // stop this one
            GATag("Learning", "Game.Stop1", INFO.session_name, 0);		 // (cat, act, lab, val)
            setGameCnt(GameCnt + 1);
            setShowGame(true);
            setGameFingers(INFO.game_fingers);      // game mode
            setNextSet(NextSet + 1);
            //setButtonText("START SET "+(NextSet));
            setButtonText("START");
            console.log("train.360:  @Dismiss   GameCnt=", GameCnt);
        }

        if(INFO.mock_mode == true) {
            INFO.sidebar_width = CONSTS.SIDEBAR_SMALL_WIDTH;
            INFO.sidebar_height = CONSTS.SIDEBAR_HEIGHT;
            //setMockStarted(false);
            setMockStarted(0);
            GATag("Learning", "Mock.Stop1", INFO.session_name, 0);		 // (cat, act, lab, val)
            setMockCnt(MockCnt + 1);
            setShowMock(true);
            setButtonText("START");
            console.log("train.1378:  @Dismiss   MockCnt=", MockCnt);
        }

        if(INFO.analyze_mode == true) {
            INFO.sidebar_width = CONSTS.SIDEBAR_SMALL_WIDTH;
            INFO.sidebar_height = CONSTS.SIDEBAR_HEIGHT;
            GATag("Learning", "Analyze.Stop1", INFO.session_name, 0);		 // (cat, act, lab, val)
            setAnalyzeStarted(0);
            //setMockCnt(MockCnt + 1);
            setShowAnalyze(true);
            setButtonText("START");
            console.log("train.1842:  @Dismiss   no AnalyzeCnt");
        }


        if(INFO.practice_mode == true) {
            handleExpand("dismiss_wait.2008");       // keep drill video expanded
        }

        adjustDisplayDiv("dismiss_wait.2510");
    }



    function extractUserName(user) {
        if (!user) { return null};

        var bits0 = user.split(":");
        var bits1 = bits0[0].split("_");
        var bits2 = bits0[1].split("_");
        var first = bits1[0];
        var last = bits1[1];
        var team = bits2[1];
        if ((!first) || (!last) || (!team)) return user;

        var name = first.toUpperCase() + " " + last.substr(0,1).toUpperCase() + " ("+team.toUpperCase()+")";
        return name;
    }


    // bot mode: print out student user names assigned to the device
    //
    function getUserNames(users) {
        if (!users) { return ["NO USER FOUND"]}

        var slave_msgs = [];
        for (var u = 0; u < users.length; u++) {
            var user = users[u];

            if (!(user.done === true) && !(user.disabled === true)) {
                console.log("get_user_name.1937:        . . . GET USER NAME ",u,":   user=",user, " done=",user.done);
                var name = extractUserName(user.key);
                slave_msgs.push(name);
            }
        }
        return(slave_msgs);
    }


    // remove disabled users
    //
    function scrubUsers(users) {
        var out = [];
        //for (var u = 0; u < users.length; u++) {
        for (var u in users) {
            var user = users[u];
            console.log("2132:       . . . SCRUB USER   u=", u, " user=",user);
            if (!(user.done === true) && !(user.disabled === true)) {
                out.push(user);
            }
        }
        console.log("1961:    = = = SCRUB USER RETURN  old=",users, " NEW=",out);
        return(out);
    }


    // bot mode: print out all user with perf data
    //     - could have multiple sessions
    //
    function getUserPerfList(stats, drill_hash0, from) {
        var slave_list = [], drills = {};
        // var drills_idx = {}, drills_score = {}, drills_uid = {};
        var top = {}, topkey = {}, ranks0 = [], ranks1 = [], ranks = [];
        var drill_hash0 = drill_hash0 ? drill_hash0 : CONSTS.BOT_DRILL_MATCH_ALL;
        var total_mode = (drill_hash0 === CONSTS.BOT_DRILL_MATCH_ALL) ? true : false;
        var process = null;

        // A19-28_top:student_33  +  drl:axos:test-stot:1 +  1
        console.log("perf_list.2072:     # # # # #  PROCESS USER PEF STATS    from=",from, " drill_hash0=",drill_hash0);    //,":  stats=",stats);
        for (var key in stats) {
            var stat = stats[key];
            var uid = stat.uid;
            var ss0 = (stat.ss0) ? stat.ss0 : 0;
            var target = null;
            //var h00 = stat.h00;

            var drill_hash = stat.drill_hash;
            process = false;
            target = ss0;       // default
            if (drill_hash0) {
                if (drill_hash === drill_hash0) {
                    target = ss0;    // for a single drill
                    process = true;
                } else {
                    process = true;     // need to sum up all drills
                }
            } else {
                // find the total multi-drill summary
                //
                // TODO: NEED TO FIGURE THIS OUT
            }

            //console.log("perf_list.1988:              STATS    . . . ",key,":  drill_hash=",drill_hash, " drill_hash0=",drill_hash0," ss0=",ss0, " uid=",uid, " process=",process);
            if (process === true) {
                //if (drill_hash0 === CONSTS.BOT_DRILL_MATCH_ALL) {
                if (total_mode === true) {
                    var r = {};
                    r.score = target;
                    r.uid = uid;
                    r.key = key;
                    r.drill_hash = drill_hash;
                    ranks1.push(r);     // push everybody on
                    //console.log("perf_list.2147:                    ALL_STATS1    . . . ",key,": uid=",uid," drill_hash=",drill_hash, " r.score=",target, " r=",r);      //, " ranks1=",ranks1);
                } else {
                    if (!top[uid]) {
                        top[uid] = target;
                        topkey[uid] = key;

                        var r = {};
                        r.score = target;
                        r.uid = uid;
                        r.key = key;
                        r.drill_hash = drill_hash;
                        ranks1.push(r);
                        //console.log("perf_list.2127:                    ALL_STATS2    . . . ",key,": uid=",uid," drill_hash=",drill_hash, " r.score=",target," r=",r);      //, " ranks1=",ranks1);
                    } else {
                        if (target >= top[uid]) {
                            top[uid] = target;
                            topkey[uid] = key;
                        }
                    }
                }
            }
        }

        // de-dupe users, one entry per user per drill
        //
        ranks1.sort(arrayUidDesSort);
        console.log("perf_list.2144:           = = = = = RANKS1=",ranks1);
        var ranks0 = JSON.parse(JSON.stringify(ranks1))
        var last_uid = null;
        var best_idx = 0;
        var best_score = 0;
        //for (var i = ranks.length - 1; i >= 0; i--) {
        //for (var i = 0; i < ranks0.length; i++) {
        for (var i = ranks0.length - 1; i >= 0; i--) {      // reverse, so splice works
            var rank = ranks0[i];
            var uid = rank.uid;
            var key = rank.key;
            var score = rank.score;
            var drill_hash = rank.drill_hash;

            if (uid === last_uid) {
                if (score > best_score) {
                    best_score = score;     // overall best for this drill
                    best_idx = i;
                }

                if (!drills[uid]) { drills[uid] = {} };
                if (!drills[uid][drill_hash]) { drills[uid][drill_hash] = {} };
                var dscore = (drills[uid][drill_hash].score) ? drills[uid][drill_hash].score : 0;
                if (score > dscore) {
                    var obj = {}
                    obj.score = score;
                    obj.uid = uid;
                    drills[uid][drill_hash] = obj;
                    console.log("perf_list.2179:                           INSERT  . . . i=",i,"    uid=", uid, " drill_hash=", drill_hash, " score=",score, " best_score=",best_score, " drills[uid][drill_hash]=",drills[uid][drill_hash]);
                } else {
                    //console.log("perf_list.2168:                        NO_INSERT  . . . i=",i,"    uid=", uid, " drill_hash=", drill_hash, " score=",score, " dscore=",dscore, " drills[uid][drill_hash]=",drills[uid][drill_hash]);
                }
                ranks0.splice(i, 1);      // remove
            } else {
                if (i > 0) {
                    //var obj = Object.assign({}, ranks0[best_idx]);      // copy object
                    //ranks.push(obj);
                }
                //drills = {};        // reset for each user
                var obj = {}
                obj.score = score;
                obj.uid = uid;
                if (!drills[uid]) { drills[uid] = {} };
                if (!drills[uid][drill_hash]) { drills[uid][drill_hash] = {} };
                drills[uid][drill_hash] = obj;

                best_score = score;
                best_idx = i;
                console.log("perf_list.2193:                           INIT  . . . i=",i,"    uid=", uid, " drill_hash=", drill_hash, " score=",score, " best_score=",best_score, " drills[uid][drill_hash].score=",drills[uid][drill_hash].score);
            }

            //console.log("perf_list.2140:                 DEDUPE  - - - i=",i,"    uid=", uid, " score=",score, " best_score=",best_score, " drills[uid]=",drills[uid]);
            last_uid = uid;
        }

        ranks = ranks0.sort(arrayTargetDesSort);
        console.log("perf_list.2!96:    # # # # # # ALL_RANKS  ranks=", ranks, " drills=",drills);


        // get the best rec for each user
        //
        for (var i = 0; i < ranks.length; i++) {
            var rank = ranks[i];
            var uid = rank.uid;
            var score = rank.score;
            var drill_hash = rank.drill_hash;
            //var stat = stats[topkey[uid]];
            //var drill_hash = stat.drill_hash;

            var total = 0;
            var udrills = drills[uid];
            console.log("perf_list.2206:    # # # # # # TOTAL  uid=", uid, " drill_hash=",drill_hash," udrills=",udrills);
            for (var d in udrills) {
                var udrill = udrills[d];        // each drill top score for this user
                if (udrill && udrill.score) {
                    total = total + udrill.score;
                    console.log("perf_list.2209:               TOTAL     . . . i=",i,"   d=",d,"  uid=", uid, " drill_hash=",drill_hash," score=",udrill.score, " tot_score=",total);
                } else {
                    console.log("perf_list.2212:            NO TOTAL         . i=",i,"   d=",d,"  uid=", uid, " drill_hash=",drill_hash," udrill=",udrill, " tot_score=",total);
                }
            }


            //console.log("perf_list.2003:               RANK  - - - uid=",uid,"  topkey[t]=",topkey[uid], " stat=",stat);
            var name = extractUserName(uid);
            if (!name) { continue };

            //var entry = (i + 1)+".  "+name+"    "+stat.h00;
            //slave_list.push(entry.toUpperCase());
            var entry = {};
            entry.name = name.toUpperCase();
            if (total_mode === true) {
                entry.perf = total;
            } else {
                entry.perf = score;
            }
            slave_list.push(entry);
        }

        slave_list.sort(arrayPerfDesSort);
        for (var i = 0; i < slave_list.length; i++) {
            slave_list[i].rank = i + 1;
        }

        console.log("perf_list.1965:         . . .  BOT PERF LIST  drill_hash0=",drill_hash0, "  list=",slave_list); // " stats=",stats, 
        return(slave_list);
    }



/*
{A12-11_run:student_03b+drl:axos:test-stot:1+1+undefined=
    {h00_cnt=3.0,
 email=A12-11_run@student.03b,
 uid=A12-11_run:student_03b,
 version=0.1,
 drill_hash=drl:axos:test-stot:1,
 set=0.0,
 t00_cnt=3.0,
 h00=93.0,
 t00=15.0},

 john-1704_bob:student_02b+drl:axos:test-stot:1+1+undefined=
 {version=0.1,
 uid=john-1704_bob:student_02b,
 email=john-1704_bob@student.02b,
 t00_cnt=4.0,
 t00=15.0,
 h00=93.0,
 drill_hash=drl:axos:test-stot:1,
 set=1.0,
 h00_cnt=4.0},

 A12-11_run:student_03b+drl:axos:test-stot:1+0+undefined=
 {set=0.0,
 uid=A12-11_run:student_03b,
 h00=93.0,
 email=A12-11_run@student.03b,
 t00=15.0,
 h00_cnt=3.0,
 drill_hash=drl:axos:test-stot:1,
 t00_cnt=3.0,
 version=0.1}}
*/



    // *********************************** BOT SLAVE DRILL MANAGEMENT ROUTINES  ***********************************
    //


    // Bot Control SLAVE MODE
    //      - wake up and collect the latest Msg from backend
    //      - if got setup then process it right away, load the drills
    //      - keep the Msg until Slave is ready to process it by calling processSlaveLastMsg()
    //
    const processSlaveTimer = async () => {
            var now = new Date();
            var slave_msgs = [];

            var msg = await GetMsg("device", INFO.bot_active_device_hash, INFO.bot_last_msg, INFO.bot_group_id);
            if (msg && msg.msg_id) {
                console.log("slave_timer.2003:       = = = CHECK SLAVE TIMER . . . msg.issued=",msg.issued, " DRILL=",msg.drill_hash, " msg_id=",msg.msg_id, " bot_setup_msg_id=",INFO.bot_setup_msg_id,"  msg=",msg, " chain_run=",INFO.chain_running);

                //var last_msg_id = (INFO.bot_last_msg) ? INFO.bot_last_msg.msg_id : null;
                //if ((msg.drill_hash === "_start-sync-session_") && (msg.msg_id !== last_msg_id)) 
                //if (msg.msg_id !== last_msg_id) 
                var last_msg_issued = (INFO.bot_last_msg) ? INFO.bot_last_msg.issued : null;
                console.log("slave_timer.875:    # # # # # # # SLAVE TIMER GOT SERVER CMD=",msg.cmd, " mode=",msg.mode, " DRILL=",msg.drill_hash, " group_id",msg.group_id," msg.timestamp=",msg.issued, " last_msg_timestamp=", last_msg_issued," bot_setup_msg_id=",INFO.bot_setup_msg_id,"  msg=",msg);
                //if (!last_msg_timestamp || (msg.timestamp > last_msg_timestamp)) 
                if (!last_msg_issued || (msg.issued > last_msg_issued)) {

                    // if new setup in the msg
                    //
                    console.log("slave_timer.1611:        GOT 1: NEW CMD  msg.cmd=",msg.cmd, " last_msg_issued=", last_msg_issued, " msg=",msg, " group_id=",msg.group_id);
                    if (msg.stats) {
                        INFO.bot_all_stats = JSON.parse(JSON.stringify(msg.stats));
                        //var slave_ranks = getUserPerfList(INFO.bot_all_stats, null, "proc_slave_timer.2267");   // display peer stats in this class
                        //setBotSlaveDrillTitle("OVERALL RANKING");
                        //setBotSlaveRanks(slave_ranks);
                        console.log("slave_timer.2144:        GOT 2:  LOAD all_stats   bot_all_stats=",INFO.bot_all_stats);
                    }

                    if (msg.setup) {
                        if (INFO.bot_setup_msg_id !== msg.setup.msg_id) {
                            var setup = msg.setup;
                            INFO.bot_active_class_hash = setup.users_hash;

                            /* MOVE THIS TO AFTER WE PROCESS THE MSG
                            //
                            var osetup = JSON.parse(JSON.stringify(INFO.bot_setup));
                            INFO.bot_setup = JSON.parse(JSON.stringify(msg.setup));     // for slave
                            INFO.bot_group_id = INFO.bot_setup.group_id;

                            if (INFO.bot_setup.users) 
                                // WHAT IF CHAIN IS RUNNING?  CAN'T CHG USER!

                                var users0 = map2Array(INFO.bot_setup.users);
                                var users1 = scrubUsers(users0);
                                INFO.bot_setup.users = users1;
                             else 
                                if (osetup && osetup.users) 
                                    INFO.bot_setup.users = JSON.parse(JSON.stringify(osetup.users));     // KLUDGE: keep the old one if setup has no users
                                }
                             */


                            console.log("slave_timer.1611:        GOT 3:  setup_msg_id", msg.setup.msg_id, " setup",setup, " group_id=", INFO.bot_group_id);

                            // if new config, load the drills from db
                            //
                            var drills = (setup.content) ? setup.content.drills : null;
                            if (drills) {
                                var raw_drills = JSON.parse(JSON.stringify(drills));
                                drills = processDrillItems(raw_drills);
                                drills.sort(arraySeqAscSort);
                                setAllDrills(drills);
                                INFO.bot_all_drills = JSON.parse(JSON.stringify(drills));       // processed
                                console.log("slave_timer.1539:        GOT 4:  LOADING ALL DRILLS  msg.cmd=",msg.cmd, " msg.mode=",msg.mode, " drill.len=",INFO.bot_all_drills.length, "  msg_id=",msg.setup.msg_id, " chain_run=",INFO.chain_running," drills=",drills);

                                /*
                                var slave_notes = getUserNames(INFO.bot_setup.users);
                                setBotSlaveNote(slave_notes);
                                */

                                INFO.bot_last_msg = JSON.parse(JSON.stringify(msg));
                                INFO.bot_setup_msg_id = msg.setup.msg_id;

                                // prog mode:  start if first time, or nothing is running
                                // drill mode: always interrupt if there is a new setup (?)
                                //
                                //if ((msg.mode !== "prog") || ((INFO.drill_running === false) && (INFO.chain_running === false))) {
                                if (!last_msg_issued || !(msg.cmd === "prog") || ((INFO.drill_running === false) && (INFO.chain_running === false))) {
                                    playAudio(CONSTS.CONFIG_LOADED_PATH, "slave_timer_setup.1992");     // session starting
                                    processSlaveLastMsg(true);      // start if not in prog mode, OR nothing is running
                                }
                            }
                        }
                    } 
                }


                if (msg.cmd === "abort") {
                    console.log("slave_timer.1785:    ! ! ! ! !  ABORT MSG DETECTED    msg=",msg, " group_id=",msg.group_id, " DrillActive=",DrillActive);
                    //if (DrillActive === true) handleGoCatalog();

                    INFO.drill_hash =null; 
                    if (INFO.practice_mode === true) stopPracticeWebcam("interrupt", "slave.timer.abort.2007");    // needed this
                    if (INFO.perf_mode === true) stopChallengeWebcam("interrupt", "slave.timer.abort.2008");    // needed this
                    if (INFO.game_mode === true) handleStopGame("interrupt", "slave.timer.abort.2058");    // needed this
                    if (INFO.mock_mode === true) handleStopMock("interrupt", "slave.timer.abort.2067");    // needed this
                    setShowDrill(false);
                    setShowPerf(false);

                    setShowBotSlave(true);
                    playAudio(CONSTS.SESSION_ABORT_PATH, "slave_timer_abort.2011");     // aborted

                    INFO.bot_last_msg = JSON.parse(JSON.stringify(msg));
                    INFO.chain_running = false;
                    processSlaveLastMsg(true);
                }

                INFO.bot_all_stats = (msg.stats) ? JSON.parse(JSON.stringify(msg.stats)) : {};      // load it right away
                INFO.bot_last_msg = JSON.parse(JSON.stringify(msg));
                //INFO.bot_all_stats = (msg.stats) ? JSON.parse(JSON.stringify(msg.stats)) : {};
                console.log("slave_timer.1667:        . . . .  END_TIMER   msg.cmd=",msg.cmd, " LAST_MSG= ",INFO.bot_last_msg.msg_id, 
                        "  setup_msg_id=", INFO.bot_setup_msg_id, " abort=",INFO.drill_chain_abort, " all_stats=",INFO.bot_all_stats);   //, " msg.stats=",msg.stats);
            }

            var timer = setTimeout(()=> {
                //console.log("time.871:   # # # #  WAKEUP!  Check Slave Timer processTime()   time=",Date.now(), " today=",now);
                if (INFO.bot_slave_mode === true) {
                    processSlaveTimer();     // wait then check again
                } else {
                    var now = new Date();
                    console.log("slave_timer.892:   ! ! ! ! ! ! ! WAKEUP!  Check BOT SLAVE Timer MODE STOPPED!   time=",Date.now()%100000/1000, " today=",now);
                }
            },  CONSTS.BOT_SLAVE_CHECK_INTERVAL);

            setBotSlaveTimer(timer);
    }



    // call this after drill is done
    //    - if wait b4 started, then wait for "sync" then return
    //    - if wait and has_config, then wait for new drill then return
    //    - if msg.mode === "prog", then run entire prog b4 switch user and don't wait
    //
    // Note: "add_user" is phased out, replaced by "setup", use msg.mode == "prog"
    //
    const processSlaveLastMsg = async (wait) => {
        var repeat = true, sync_only = false;       // start 
        var has_config = (INFO.drill_hash) ? true : false;      // KLUDGE:
        var msg = INFO.bot_last_msg;
        console.log("time.2081:        # # # # # # # # # # # # #  PROCESSING LAST SLAVE MSG   chain_run=",INFO.chain_running, " bot_processed_msg=",INFO.bot_processed_msg, " msg=",msg);

        //if (!INFO.bot_processed_msg || (msg && (msg.msg_id !== INFO.bot_processed_msg.msg_id))) {     // for repeat timer process
        if (!INFO.bot_processed_msg || (msg && (msg.issued > INFO.bot_processed_msg.issued))) {     // Note: chk issued not just msg_id!
            if (msg) {
                INFO.bot_processed_msg = Object.assign({}, msg);  // copy object


                // load the users from setup
                //
                if (msg.setup) {
                    var osetup = JSON.parse(JSON.stringify(INFO.bot_setup));
                    INFO.bot_setup = JSON.parse(JSON.stringify(msg.setup));     // for slave
                    INFO.bot_group_id = INFO.bot_setup.group_id;

                    if (INFO.bot_setup.users) {
                        var user_str = INFO.bot_setup.users;
                        INFO.bot_setup.users = JSON.parse(JSON.stringify(user_str));     // users may still be a string
                        console.log("last_slave_msg.entry.2525:    . . . . BOT_SET.users=", INFO.bot_setup.users);
                        var users0 = map2Array(INFO.bot_setup.users);
                        var users1 = scrubUsers(users0);
                        INFO.bot_setup.users = users1;

                        var slave_notes = getUserNames(INFO.bot_setup.users);
                        setBotSlaveNote(slave_notes);
                    } else {
                        if (osetup && osetup.users) {
                            INFO.bot_setup.users = JSON.parse(JSON.stringify(osetup.users));     // KLUDGE: keep the old one if setup has no users
                        }
                    }
                }


                repeat = false;
                console.log("last_slave_msg.entry.2478:    . . . . PROCESS NEW   msg=", msg, " cmd=",msg.cmd, " group_id=",msg.group_id, " msg.msg_id=",msg.msg_id, "  last_proc.msg_id=", INFO.bot_processed_msg, " mode=",INFO.bot_run_mode);
                INFO.drill_chain_abort = false;
                if (msg.cmd === "abort") {
                    // Note: actual abort is done in processSlaveTimer()
                    //
                    console.log("last_slave_msg.1707:    ! ! ! ! !  PROCESS ABORT msg=",msg);
                    sync_only = true;       // wait for next cmd
                    wait = true;
                    INFO.drill_chain_abort = true;
                    INFO.chain_running = false;



                    var slave_ranks = getUserPerfList(INFO.bot_all_stats, INFO.drill_hash, "proc_slave_msg.2556");   // display peer stats in this class
                    setCountdownList(slave_ranks);
                    setBotSlaveDrillTitle(INFO.drill.name+" RANKING");
                    setBotSlaveRanks(slave_ranks);




                    setShowCountdown(false);        // in case waiting for countdown
                    INFO.countdown_time = null;
                } else 

                if ((msg.cmd === "add_user") || (msg.cmd === "prog") || (msg.mode === "prog")) {
                    var setup = msg.setup;
                    if(setup && setup.users) {
                        var users0 = map2Array(setup.users);
                        var users1 = JSON.parse(JSON.stringify(users0));     // for slave
                        var users2 = scrubUsers(users1);
                        INFO.bot_setup.users = users2;     // for slave
                        console.log("last_slave_msg.prog.2105:    ! ! ! ! !  RECEIVED NEW USERS  msg=",INFO.bot_setup.users, " mode=",INFO.bot_run_mode);
                        var slave_notes = getUserNames(INFO.bot_setup.users);
                        setBotSlaveNote(slave_notes);
                        //var slave_ranks = getUserPerfList(INFO.bot_all_stats, INFO.drill_hash);   // display peer stats in this class
                        var slave_ranks = getUserPerfList(INFO.bot_all_stats, null, "proc_slave_last_msg.2454");   // display peer stats in this class
                        setBotSlaveRanks(slave_ranks);
                        setBotSlaveDrillTitle("OVERALL RANKING");

                        playAudio(CONSTS.CONFIG_LOADED_PATH, "slave_setup.1992");     // session starting
                    }

                    INFO.drill_chain_abort = false;
                    INFO.bot_active_user_idx = null;
                    INFO.bot_run_mode = "prog";
                    INFO.chain_running = true;
                    processSlaveAutoProgram(msg);        // start in program mode

                    /*
                    if (INFO.bot_run_mode === "prog") {
                        // SPECIAL MODE:  immediate start the new user on prog
                        //
                        processSlaveAutoProgram(msg);        // start in program mode
                    } else {
                        sync_only = true;       // wait for next cmd
                        wait = true;
                    }*/
                } else 

                /*
                if (msg.cmd === "prog") {
                    // per-prog mode, do not wait for master
                    //    - Note: prog mode does NOT have "start" for each drill!  So nned to store stats in sync!!!
                    //    - Need to accume we collect stats for prog mode?
                    //
                    INFO.drill_chain_abort = false;
                    INFO.bot_active_user_idx = null;
                    INFO.bot_run_mode = "prog";
                    processSlaveAutoProgram(msg);        // start in program mode
                */

                {
                    // regular per-drill mode, wait for master
                    //
                    console.log("last_slave_msg.1611:        GOT B:  msg.cmd=", msg.cmd);
                    INFO.bot_run_mode = "drill";    // all users do one drill at a time
                    if (has_config === true) {
                        if (msg.drill_hash === INFO.drill_hash) {
                            repeat = true;      // runing the same drill again
                        }
                    } 

                    if ((msg.drill_hash === CONSTS.BOT_DRILL_START_HASH) || (!msg.drill_hash)) {
                        sync_only = true;   // not starting yet
                    }

                    console.log("last_slave_msg.1611:        GOT C:  sync_only=",sync_only, " repeat=",repeat, " msg.drill_hash=",msg.drill_hash, " bot_all_drills=",INFO.bot_all_drills);
                    //console.log("last_slave_msg.1552:    . . .PROCESS:   drill_hash=",msg.drill_hash, " has_config=",has_config," sync_only=",sync_only, " repeat=",repeat, " bot_all_drills=",INFO.bot_all_drills, " HandsFree=", HandsFree);
                    if ((sync_only === false) && (repeat === false) && msg.drill_hash && INFO.bot_all_drills) {

                        var uidx = 0;
                        if (INFO.bot_setup.users) {
                            var next_user = INFO.bot_setup.users[uidx]
                            INFO.bot_active_user_idx = uidx;
                            if (next_user)  AdminSwitchUser(next_user);     // assume first user identity 

                            INFO.drill_chain_abort = false;
                            //INFO.bot_processed_msg = Object.assign({}, msg);  // copy object
                            INFO.chain_running = true;
                            processSlaveAutoDrill(msg);        // auto start the drill

                        } else {
                            console.error("last_slave_msg.2629:      ! ! ! ! ! ! ! ! ! ERROR: NO bot_setup.users[]  bot_setup=",INFO.bot_setup);
                        }
                    }
                }
            }
        }

        if (wait === true) {
            if (!msg || (sync_only === true) || (repeat === true)) {
                // keep checking msgs until we got the GO
                //    - Note: Switch to push notification later
                //
                if (INFO.bot_slave_mode === true) {
                    var timer = setTimeout(async ()=> {
                        while ((INFO.db_store_started === true) && (INFO.db_store_completed === false)) {
                            await sleep (250);      // poll until all data is writtnen to db
                            console.log("last_slave_msg.2165:      . . . WAITING FOR DB STORE TO COMPLETE (slaveLastMsg):  ",INFO.db_store_completed);
                        };
                        
                        if (INFO.drill_running === false) {
                            var last_group_id = (INFO.bot_last_msg) ? INFO.bot_last_msg.group_id : null;
                            // (!INFO.bot_processed_msg || (msg && (msg.msg_id !== INFO.bot_processed_msg.msg_id))
                            console.log("last_slave_msg.1605:                . . . WAKEUP!  slaveLastMsg  CHECK AGAIN TO START DRILL    group_id=",last_group_id); // ," setup=", INFO.bot_setup, " group_id=",INFO.bot_processed_msg.group_id, " last_msg_id=",last_msg_id, " db_started=",INFO.db_store_started);
                            INFO.chain_running = false;
                            processSlaveLastMsg(true);
                        }

                    },  5000);
                }
            }

        }
    }







    // handles logistics of starting a drill for Slave bot
    //    - if mode === "prog" then switch user after run thru all prog drills
    //    - make sure webcam has started before running drill
    //
    const processSlaveAutoDrill = async (msg) => {

        INFO.drill_hash = msg.drill_hash;
        INFO.drill_chain_mode = true;
        INFO.auto_run_mode = true;        // noly set in index?
        INFO.drill_tot_set_cnt = null;   // clear it for the next drill
        INFO.notify_messages = [];
        //INFO.drill_set_cnt = 0;   // clear it for the next drill

        var drills = INFO.bot_all_drills.filter(drill => { return drill.hash == INFO.drill_hash });
        if (!drills[0]) return;

        INFO.drill = Object.assign({}, drills[0]);  // copy object
        INFO.session_name = drills[0].name;
        var type = drills[0].type;
        console.log("last_msg.1275:    # # # # STARTING SINGLE DRILL IN SLAVE MODE  msg=",msg, "  cmd=",msg.cmd, " msg.drill=",msg.drill_hash, " group_id=",msg.group_id," drill_name=",drills[0].name," drill=",drills[0]," type=",type, "  all_drills=", INFO.bot_all_drills, " now=",Date.now()%100000/1000);    //,"  msg=",msg);
        switch (type) {
            case "perf":
                INFO.run_action = handleRunChallengeWebcam;
                break;
            case "game":
                INFO.run_action = handleRunGame;
                break;
            case "mock":
                INFO.run_action = handleRunMock;
                break;
            case "drill":
            case "skill":
            case "cond":
            case "condition":
            default:
                INFO.run_action = handleRunPracticeWebcam;
                break;
        }

        setShowBotSlave(false);
        setHandsFree(true);
        setTimeout(()=> {
            console.log("auto_drill.2148:    # # # # WAKEUP AUTO START SINGLE DRILL!   type=",type,"  drill_hash=",INFO.drill_hash, " abort=",INFO.drill_chain_abort," now=",Date.now()%100000/1000);
            //INFO.webcam_started = false;    // need delay so video canvas sticks around for the db write
            handleAutoStartDrill("slave", "wakeup_runaction.2199");
            setTimeout(()=> { 
                if (INFO.drill_chain_abort === false) {
                    console.log("auto_drill.2632:    # # # # EXECUTE AUTO START SINGLE DRILL!   drill_hash=",INFO.drill_hash, " now=",Date.now()%100000/1000);
                    INFO.run_action("start") 
                } else {
                    console.log("auto_drill.2727:    ! ! ! ! AUTO RUN_ACTION ABORTED!!!   drill_hash=",INFO.drill_hash, " now=",Date.now()%100000/1000);
                }
            }, 3000);   // KLUDGE: HARD CODING DELAY
            //}, 6000);   // KLUDGE: HARD CODING DELAY
        }, 800);        // wait for webcam to start
    }



    // handles logistics of running the whole program 
    //    - load user state
    //    - if mode === "prog" then switch user after run thru all prog drills
    //
    const processSlaveAutoProgram = async (msg) => {

        if ((msg.cmd !== "prog") && (msg.cmd !== "add_user")) {
            console.error("auto_prog.1553:    ! ! ! ! ! ! BAD MSG: NOT PROGRAM MODE msg=",msg);
            return;
        }

        INFO.drill_tot_set_cnt = null;
        INFO.drill_set_cnt = 0;   // clear it for the next drill
        INFO.drill = null;
        INFO.drill_hash = null;     // get it from nextAutoDrill()
        INFO.drill_chain_mode = true; 

        console.log("auto_prog.1637:   # # # # # # # # # START SLAVE AUTO PROG # # # # # # # # # # ");
        processChainedTodayDrill("start", "slave_prog.1638");

    }







    // *********************************** GENERAL DRILL MANAGEMENT ROUTINES  ***********************************
    //

    function setupDrills(mode0, from) {
        var mode = null, cat_mode;
        if(!mode0 || (mode0 == "auto1")) {
            if(INFO.db_drills === null) { return; }     // need to wait more

            INFO.auto_run_mode = true;
            var drills = INFO.db_drills.filter(drill => { return drill.hash == INFO.drill_hash });
            if(drills[0] === undefined) {
                console.log("setupDrill.696:      SKIP DRILL SETUP mode0=",mode0, "  drill_key=",INFO.drill_hash, " from=",from);
                return;
            }
            mode = drills[0].type;
            console.log("setupDrill.2699: ==================  SETUP SPECIAL DRILL  mode=",mode, "  drill_key=",INFO.drill_hash, " mode0=",mode0, " drill.type=",drills[0].type," from=",from);
        } else {
            mode = mode0;
            console.log("setupDrill.686: ==================  SETUP NORMAL DRILL  mode=",mode, "  drill_key=",INFO.drill_hash, " mode0=",mode0, " from=",from);
        }

        setDashboardMode(false);
        setPerfMode(false);
        setSkillsMode(false);
        setAgilityMode(false);
        setConditioningMode(false);
        setTodayMode(false);        // customized per player flow, read from Sequence
        setAnalyzeMode(false);        // customized per player flow, read from Sequence
        setOperationComplete(false);
        //setDrillMode(false);        // youtube direct to single drill mode

        setShowDashboard(false);
        setShowCatalog(true);
        //setMode(mode);        // don't do this here
        //switch(props.Mode){
        switch(mode){
            case "dashboard":
                setDashboardMode(true);
                setCatalogTitle("SKILLS DRILLS");
                cat_mode = "dashboard";
                setCatalogType(null);
                INFO.bot_slave_mode = false;        // exit controlled slave mode

                setShowDashboard(true);
                setShowCatalog(false);
                break;
            case "skill":
            case "skills":
                setSkillsMode(true);
                setCatalogTitle("SKILLS DRILLS");
                cat_mode = "skill"
                //setShowDrill(true);
                break;
            case "agility":
            case "game":
                setAgilityMode(true);
                setCatalogTitle("AGILITY DRILLS");
                cat_mode = "game"
                //setShowGame(true);      // Useless across game sessions
                break;
            case "mock":
                //setMockMode(true);
                setCatalogTitle("GAME SIMULATIONS");
                cat_mode = "mock"
                break;
            case "condition":
                setConditioningMode(true);
                setCatalogTitle("CONDITIONING DRILLS");
                cat_mode = "condition"
                //setShowDrill(true);
                break;
            case "today":
                setTodayMode(true);
                setCatalogTitle("MY DRILLS");
                cat_mode = "today"
                break;
            case "challenge":
            case "perf":
                setPerfMode(true);
                setCatalogTitle("CHALLENGES");
                cat_mode = "perf"
                //setShowPerf(true);      // triggers a react refresh to update div
                break;
          case "analyze":
                setAnalyzeMode(true);
                setCatalogTitle("ANALYSIS");
                setVideoStarted(false);
                cat_mode = "analyze"
                //setShowPerf(true);      // triggers a react refresh to update div
                break;

            case "drill":       // NOTE: IS THIS STILL USED?
                // run just a single drill from youtube
                console.log("learn.740:  ----------------   ENTER SINGLE DRILL MODE!  ", props.Drill);
                //setDrillMode(true);
                setCatalogTitle("YOUTUBE DRILLS");
                cat_mode = "drill1"
                break;

            default:
                console.log("learn.341:  ******** UNKNOWN MODE!  mode=", mode);
                setCatalogTitle("UNKNOWN DRILLS");
                break;
        }

        setShowExpand(false);     
        setShowGraph(false);
        setShowBugReport(false);
        setCatalogType(cat_mode);
        INFO.catalog_type = cat_mode;
        
        if(INFO.db_drills === null) {
            setTimeout((mode) => {
                ReadUserStateInfo(mode);
            }, 300);
        } else {
            ReadUserStateInfo(mode);
        }

    }


    // called from low level (dashboard) to run a drill, need to return to dash
    //    - need init to clean up last drill
    //
    const handleDrillSelect = target_hash => {
        if ((target_hash === null) || (target_hash === undefined)) { return }
        var drill_hash = target_hash.split("+")[0];

        // KLUDGE: dupe processing
        if (INFO.bot_slave_mode === true) {
            //var all_items = processDrillItems(INFO.bot_all_drills);
            var all_items = INFO.bot_all_drills;        // already processed
        } else {
            var all_items = processDrillItems(INFO.db_drills);
        }
        //var drills = AllDrills.filter(drill => { return drill.hash == drill_hash });
        //var drills = INFO.db_drills.filter(drill => { return drill.hash == drill_hash });
        var drills = all_items.filter(drill => { return drill.hash == drill_hash });
        var input = drills[0];

        if (input !== undefined) {
            console.log("learn.dash.935:  DASHBOARD SELECT RUN DRILL =",drill_hash, "  drill=",input, "  Mode=",Mode, "  AllDrills=",AllDrills.length);
            setReturnToDashboard(true);
            handleItemSelect(0, input, "handle.drill.sel.2325");     // need to simulate an input from catalog...maybe do a search
            //playAudio(CONSTS.START_RUN_PATH, "run_new_drill.2318");     // Note: move this down
        } else {
            console.error("learn.dash.1273:   !!!!!!!! UNRECOGNIZED DRILL =",drill_hash, "  all_drills=",all_items, "  Mode=",Mode, "  AllDrills=",AllDrills);
        }
    }


    // Event wrapper
    //
    const handleAutoStartDrillEvent = () => {
        handleAutoStartDrill("event", "event.wrapper.2833");      // called after has_user_state event is triggered
    }



    // EVENT: call after receiving user_state from db
    //    - simulate a item click CatalogItems
    //    - mode:
    //         "event": called from has_user_state event
    //         "drill1": called url auto drill, do not display slave rank stuff
    //         "first": called from first today click
    //         "slave": auto chained drills 
    //
    const handleAutoStartDrill = async (mode, from) => {
        var delay = null, all_items = [];

        setShowCountdown(false);     // remove delay notice
        INFO.countdown_time = null;       // BAD

        var selected = false;
        var show_notice = true;     // show slave notice
        switch (mode){
            case "event":
                show_notice = false;
                break;
            case "drill1":
                selected = false;
                //show_notice = false;
                break;
            case "first":
                selected = true;
                break;
            case "slave":
                selected = false;
                break;
        }

        setSummary([]);
        setOutcome("");
		INFO.notify_title = "";
        INFO.notify_messages = [];
        console.log("train.2251:          DRILL AUTO START    mode=",mode," from=", from, " selected=",selected, "  drill_running=", INFO.drill_running, "  drill_hash=",INFO.drill_hash, " setup=",INFO.bot_setup, " idx=",INFO.bot_active_user_idx, " db_drills=",INFO.db_drills," now=",Date.now()%100000/1000);
        if (!INFO.drill_hash) return;

        //if ((DrillActive === false) && (INFO.drill_hash !== undefined)) {
        if (INFO.drill_running === false) {
            var name = ""
            if (INFO.bot_slave_mode === true) {
                var uidx = INFO.bot_active_user_idx;
                if (INFO.bot_setup) {
                    console.log("train.2264:              uidx=",uidx, " setup.users=", INFO.bot_setup.users);
                    var full_name = INFO.bot_setup.users[uidx].name;
                    var name = full_name.split(" ")[0] + ": ";

                    var user = INFO.bot_setup.users[uidx].key;
                    var bits0 = user.split(":");
                    var bits1 = bits0[0].split("_");
                    var user_name = bits1[0].toUpperCase() + " " + bits1[1].substr(0,1).toUpperCase();
                }
                all_items = INFO.bot_all_drills;        // already processed

            } else {
                // auto start drill from youtube
                //
                ReadUserStateInfo("event");     // treated same as "today" mode
                all_items = processDrillItems(INFO.db_drills); // KLUDGE: dupe processing
                //setupDrills(props.Mode);      // try again?
            }


            var items = all_items.filter(drill => { return drill.hash == INFO.drill_hash });
            var msg = null;
            INFO.knn_last_gesture = null;
            INFO.knn_gestures = [];
            INFO.gesture_allowed = false;
            msg = name.toUpperCase()+" RAISE HAND WHEN READY"
            if (items && items[0]) {
                var trigger_action = null;
                switch (items[0].type) {
                    case "skill":
                    case "cond":
                    case "condition":
                        INFO.run_action = handleRunPracticeWebcam;
                        INFO.gesture_allowed = true;
                        trigger_action = setDoStartPracticeWebcam;
                        break;
                    case "perf":
                        INFO.run_action = handleRunChallengeWebcam;
                        INFO.gesture_allowed = true;
                        trigger_action = setDoStartChallengeWebcam;
                        break;
                    case "game":
                        INFO.run_action = handleRunGame;
                        break;
                    case "mock":
                        INFO.run_action = handleRunMock;
                        break;
                    default:
                        msg = name.toUpperCase()+" START WHEN READY"
                        break;
                }
            }

            if ((INFO.direct_start_mode === true) && (trigger_action)) {
                setTimeout(()=> { 
                    console.log("train.2982:          WAKEUP!   WAITED FOR <DIV> NOW TRIGGER DIRECT URL WEBCAM  drill_hash=",INFO.drill_hash, " now=",NOW);
                    trigger_action(Date.now());     // wait for <div> then signal single drill auto start
                }, 600)
            }

            setShowRaiseHand(true);
            if (show_notice === true) {
                var outputs = [];
                var out1 = {};
                out1.title = msg;
                out1.value = ""
                outputs.push(out1)
                setNotices(outputs);        // slave notice
            }

            console.log("train.1207:          WAKEUP!   SETUP DRILL AFTER USER STATE item=",items[0], " selected=",selected, "  DrillActive=",DrillActive, " gesture=",INFO.gesture_allowed);
            if (selected === false) {

                // keep sidebar (webcam) small
                INFO.sidebar_width = CONSTS.SIDEBAR_SMALL_WIDTH;
                INFO.max_sidebar = false;
                setExpandIcon(faAngleLeft);
                //setShowDrill(false);      // done somewhere else

                var [swidth, sheight] = adjustDisplayDiv("auto_drill_start.1660");
                setPlayerVideoWidth(swidth);
                setPlayerVideoHeight(sheight);

                resetSession();     // in case of repeat runs
                //await sleep(delay);      // delay to let thing settle

                setShowBotSlave(false);     // need this here?
                setSelectedItem(items[0]);  // do not select if this is the first one (already selected)
                handleDrillSelect(INFO.drill_hash);   // calls handleItemSelect(0, input)  to simulate an input from catalog...maybe do a search
            }

            setDrillActive(true);       // don't restart same one until done
            INFO.drill_running = true;
            //setMode(props.Mode);     // BAD: this breaks auto-play!
        } else {
            console.log("train.1232:          NO NEED TO WAKEUP ALREADY RUNNING ",INFO.drill_hash, " drill_running=",INFO.drill_running, "  DrillActive=",DrillActive);
        }
    }



    //  Central drill & user dispatcher for AUTO mode
    //     - Today Mode:   go through prog & set  (INFO.all_today)
    //     - AI_Train mode:  Collect timed data for all in (VideoList)
    //     - Bot_Prog Mode:  One user go throuh the prog & set, then next user (INFO.bot_all_prog)
    //     - Bot_Drill Mode:  All user go through Msg-start drill & set, then stop (processSlaveLastMsg)
    //
    //      * Determine next user & drill
    //
    function nextAutoDrill(mode) {
        var next_drill = null, next_user = null, all_drills = null;

        switch(mode) {
            case "today":
                // finish the list and end
                var failed = true;
                //if ((INFO.all_today) && (INFO.all_today.length > 0)) {
                console.log("next_auto.2918:        all_today=",INFO.all_today, " db_today=",INFO.db_today, " AllDrills=",AllDrills);
                if (!INFO.all_today || (INFO.all_today.length === 0)) { 
                    if (INFO.db_today && AllDrills) {
                        processTodayItems(mode, AllDrills, INFO.db_today);
                        failed = false;
                    } 
                } else {
                    failed = false;
                }

                if (failed === true) {
                    console.error("next_auto.2558:     ! ! ! ! ! ! ERROR: NO DB_TODAY DETECTED!  ", INFO.db_today);
                    return;         /// SOMETHING SERIOUSLY WRONG
                }

                all_drills = INFO.all_today;
                next_user = INFO.current_user;
                break;

            case "ai_train":
                // finish the list and end
                all_drills = VideosList;
                next_user = INFO.current_user;
                break;

            case "bot_prog":
                // if end of prog then get next user and start drill from top
                all_drills = INFO.bot_all_drills;
                next_user = INFO.bot_setup.users[0];
                break;

            case "bot_drill":
                // get next user, if no more then wait for msg to start next drill
                next_drill = "get_msg";
                var uidx = INFO.bot_active_user_idx + 1;
                INFO.bot_active_user_idx = uidx;
                next_user = INFO.bot_setup.users[uidx]
                if (next_user) {
                    AdminSwitchUser(next_user);
                    next_drill = "repeat";
                    console.log("chain.1318:       . . . .  DRILL MODE: SWITCH TO NEW USER  uidx=",uidx, " user=",next_user,"  this.drill=",INFO.drill_hash);
                } else {
                    next_user = null;
                    console.log("chain.1318:       ! ! ! !  DRILL MODE:  ALL USERS DONE  uidx=",uidx,"  WAIT FOR NEXT MSG START  this.drill=",INFO.drill_hash);
                }
                return [ next_drill, next_user ];
        }
        console.log("next_auto.2551:       NEXT AUTO DRILL. . . .  mode=",mode, "  next_user=",next_user, " all_drills=",all_drills," drill_hash=",INFO.drill_hash);

        if ((INFO.drill_hash === null) && (all_drills[0])) {
            next_drill = all_drills[0];      // go to first one
            console.log("chain.1318:       . . . . SELECT FIRST DRILL: ",next_drill.hash);
            return [ next_drill, next_user ];
        }


        //INFO.drill_tot_set_cnt = null;   // clear it for the next drill
        for (var i = 0; i < all_drills.length; i++) {
            var drill = all_drills[i];
            console.log("chain.1318:                   . . AUTO CHECK NEXT DRILL ",i,"  hash=", drill.hash, "  drill_hash=",INFO.drill_hash, "  all_drills=",all_drills);
            if (drill.hash === INFO.drill_hash) {
                next_drill = all_drills[i + 1];      // go to next one in Today

                if (!next_drill || (next_drill && (next_drill.special === true))) {
                    next_drill = null;      // skip sync
                    console.log("chain.1318:       ! ! ! !  ALL DRILLS DONE  mode=",mode);
                }
                console.log("chain.2531:            + + + NEXT DRILL =     hash=", next_drill);
                break;
            }
        }

        if (!next_drill){
            // reached the end of the list
            if (mode === "bot_prog") {
                //var uidx = (INFO.bot_active_user_idx) ? INFO.bot_active_user_idx + 1 : 0;
                var uidx = INFO.bot_active_user_idx + 1;        // has to be valid
                INFO.bot_active_user_idx = uidx;
                next_user = INFO.bot_setup.users[uidx];
                next_drill = all_drills[0];      // start with the first drill
                if (next_user && next_drill) {
                    AdminSwitchUser(next_user);
                    console.log("chain.1318:       . . . .  PROG MODE: SWITCH TO NEW USER  uidx=",uidx, " user=",next_user,"  this.drill=",next_drill.hash);
                } else {
                    next_user = null;
                    console.log("chain.1318:       ! ! ! !  PROG MODE:  ALL USERS DONE  uidx=",uidx,"  WAIT FOR NEXT MSG START  this.drill=",next_drill);
                }
            } else {
                console.log("chain.2998:       ! ! ! !  TODAY MODE:  ALL DRILLS FINISHED      this.drill=",next_drill);
            }
        }

        console.log("next_auto.2626:       RETURN NEXT AUTO DRILL. . . .  mode=",mode, "  next_user=",next_user, " next_drill=",next_drill, " chain=",INFO.drill_chain_mode);
        return [ next_drill, next_user ];
    }



    // MAIN: chain mode, determine what to run next
    //     - if called at start of the drill, so expects set_cnt is good
    //     - need to also call at end of drill for auto-chaining, since there is only "one click"
    //
    //  xxchain
    const processChainedTodayDrill = async (mode, from) => {
        var msg = null, delay = null, selected = null;
        var next_user = null;
        console.log("proc_chain.2638:  #######  START CHAIN_TODAY  mode=",mode, " from=",from, " chain=",INFO.drill_chain_mode," chain_run=",INFO.chain_running,
                    " abort=",INFO.drill_chain_abort," slave=",INFO.bot_slave_mode," set=",INFO.drill_set_cnt, " tot_set_cnt=",INFO.drill_tot_set_cnt, " tot_set=",INFO.drill_tot_set_cnt," now=",Date.now()%100000/1000);
        if(INFO.drill_chain_abort === true) return;

        //INFO.drill_chain_mode = true; // Note: BAD
        var run_mode = "today";
        if (INFO.ai_train_set && (INFO.ai_train_set === true)) {
            run_mode = "ai_train";
        } else if (INFO.bot_slave_mode === true) {
            run_mode = (INFO.bot_run_mode === "prog") ? "bot_prog" : "bot_drill";
        }

        var user_name = null;
        if (INFO.bot_slave_mode === true) {

            setShowBotSlave(true);   // show slave bot background
            //if (!INFO.bot_active_user_idx) { return };        this is bad

            // Note: Should we to do this after drill started?  Is this the global wait?
            //
            next_user = null;
            if (INFO.bot_setup.users) {
                if (!INFO.bot_active_user_idx) {
                    INFO.bot_active_user_idx = 0;    // in case this is first time
                    var next_user0 = INFO.bot_setup.users[0]
                    if (next_user0) {
                        AdminSwitchUser(next_user0);     // assume first user identity
                    }
                }

                var uidx = INFO.bot_active_user_idx;
                next_user = INFO.bot_setup.users[uidx]
            }

            while ((INFO.db_store_started === true) && (INFO.db_store_completed === false)) {
                await sleep (250);      // poll until all data is writtnen to db
                console.log("chain.3048:      . . . WAITING FOR DB STORE TO COMPLETE (proc_chain_today):  completed=",INFO.db_store_completed);
            };


            if (!next_user) {
                INFO.chain_running = false;
                console.log("proc_chain.2689:   ! ! ! ! ! NO MORE USERS...Keep waiting   group_id=", INFO.bot_group_id, " from=",from);
                processSlaveLastMsg(true);      // have to keep listening
                return 
            };         // no more user

            console.log("proc_chain.2525:  * * * *  START TODAY SLAVE MODE     mode=",mode, " from=",from, " drill_hash=",INFO.drill_hash, " set=",INFO.drill_set_cnt ," user_name=",user_name, " delay=",delay, " next_user=",next_user, " now=",Date.now()%100000/1000);
        } 

        if (next_user) {
            var full_name = next_user.name;
            user_name = full_name.split(" ")[0];
        }



        if (delay_kludge) { INFO.drill_chain_delay = CONSTS.KLUDGE_BIG_DELAY;  }       // total kludge
        if (delay_kludge) { delay = CONSTS.KLUDGE_BIG_DELAY;  }       // total kludge



        if (mode === "start") {
            delay = (run_mode === "today") ? 0 : 8000;       // start first user, if bot mode add pause
            selected = true;
            INFO.drill_chain_delay = (INFO.drill_chain_delay) ? INFO.drill_chain_delay : CONSTS.DEFAULT_CHAIN_DELAY;
            msg = (user_name) ? "START USER: " + user_name.toUpperCase() : null;
        } else {
            selected = false;
            INFO.drill_set_cnt = INFO.drill_set_cnt + 1;   // clear it for the next drill
            var drill_chain_delay = (INFO.drill_chain_delay) ? INFO.drill_chain_delay : CONSTS.DEFAULT_CHAIN_DELAY;
            delay = drill_chain_delay * 1000;       // drill delay timer

            TIMES.start_timer_run = null;   // NOTE: critical reset, are there other inits needed?
            msg = null;
        }


        // already running, always finish the set first with same user and same drill
        //
        //if (INFO.drill_tot_set_cnt && (INFO.drill_set_cnt >= INFO.drill_tot_set_cnt)) {
        if (INFO.drill_tot_set_cnt && (INFO.drill_set_cnt <= INFO.drill_tot_set_cnt)) {
            console.log("proc_chain.2522:  CHAIN START NEXT *SET*    mode=",mode, " from=",from, " drill_hash=",INFO.drill_hash, " bot_all_stats=",INFO.bot_all_stats, " tot_set=",INFO.drill_tot_set_cnt ," auto_run_mode=",INFO.auto_run_mode, " user_name=",user_name, " delay=",delay, " now=",Date.now()%100000/1000);

            if (INFO.bot_slave_mode === true) {
                var slave_ranks = getUserPerfList(INFO.bot_all_stats, INFO.drill_hash, "proc_chain_drill.2957");   // display peer stats in this class
                setCountdownList(slave_ranks);
                setBotSlaveDrillTitle(INFO.drill.name+" RANKING");
            }

            setShowWait(false);
            INFO.countdown_time = null;
            setCountdownTime(delay / 1000);     // show there is a delay
            setShowCountdown(true);     // show there is a delay
            setCountdownMsg(msg)
            setCountdownName(user_name);
            playAudio(CONSTS.NEW_USER_START_PATH, "chain_set.2556");     // ready chime

            if (INFO.drill && INFO.drill.type) {
                switch (INFO.drill.type) {
                    case "perf":
                        setEnableWebcam(true);    // Note:  need to wait React to show b4 turn on INFO.webcam_started
                        break;
                    case "drill":
                    case "skill":
                    case "cond":
                        setEnableWebcam(true);    // Note:  need to wait React to show b4 turn on INFO.webcam_started
                        break;
                    case "game":
                        //handleRunGame();      // set this to INFO.run_action?
                        break;
                    default:
                        break;
                }
            }

            setTimeout(async ()=> {
                while ((INFO.db_store_started === true) && (INFO.db_store_completed === false)) {
                    await sleep (250);      // poll until all data is writtnen to db
                    console.log("proc_chain.2560:      . . . WAITING FOR DB STORE TO COMPLETE (autoStartDrill):  ",INFO.db_store_completed);
                };
                console.log("proc_chain.1419:  *************** SAME USER, SAME DRILL WAKE UP!  AFTER @DELAY ",delay, " set=",INFO.drill_set_cnt," drill_hash=",INFO.drill_hash, " ************ now=", Date.now()%100000 /1000)
                INFO.countdown_time = null;

                var mode = (selected === true) ? "first" : "slave";
                handleAutoStartDrill(mode, "chain_runaction.2696");
                INFO.run_action("start");      // auto "start"
            }, delay+200);
            return;
        }
        INFO.drill_tot_set_cnt = null;   // done with this set

        // this drill set is done, find next drill & user to run
        //
        if (run_mode === "bot_prog") {
            // update display:  hide the completed user from this device
            INFO.bot_setup.users[INFO.bot_active_user_idx].done = true;       // mark user as done
            //var slave_notes = getUserNames(INFO.bot_setup.users);   // display users on this station
            //setBotSlaveNote(slave_notes);
            //var slave_ranks = getUserPerfList(INFO.bot_all_stats, INFO.drill_hash, "proc_chain_bot_prog.3016");   // display peer stats in this class
            //var slave_ranks = getUserPerfList(INFO.bot_all_stats, null, "proc_chain_bot_prog.3016");   // display peer stats in this class
            //setBotSlaveRanks(slave_ranks);
            //setBotSlaveDrillTitle("OVERALL RANKING");
        }

        var [ next_drill, next_user ] = nextAutoDrill(run_mode);    // 

        if (!next_user) {
            INFO.chain_running = false;
            console.log("proc_chain.2740:     . . . . . All DONE, keep checking in background  now=",Date.now()%100000/1000);
            processSlaveLastMsg(true);      // after program done, keep checking, make sure it's not doubled
            return;         // finished program mode
        } else {
            var full_name = next_user.name;
            user_name = full_name.split(" ")[0];
        }

        if (!next_drill) return;        // KLUDGE: catch bad processChainedTodayDrill() call
        
        if (next_drill.type) {
            INFO.gesture_allowed = false;
            switch (next_drill.type) {
                case "perf":
                    INFO.knn_last_gesture = null;
                    INFO.knn_gestures = [];
                    INFO.gesture_allowed = true;
                    INFO.run_action = handleRunChallengeWebcam;
                    break;
                case "drill":
                case "skill":
                case "cond":
                case "condition":
                    INFO.knn_last_gesture = null;
                    INFO.knn_gestures = [];
                    INFO.gesture_allowed = true;
                    INFO.run_action = handleRunPracticeWebcam;
                    break;
                case "game":
                    INFO.run_action = handleRunGame;
                    break;
                case "mock":
                    INFO.run_action = handleRunMock;
                    break;
                default:
                    break;
            }
        }
        console.log("proc_chain.2765:  # # # # # # # # # # #  CHAIN TODAY  mode=",mode.toUpperCase(), " from=",from, " abort=",INFO.drill_chain_abort," delay=", delay, " drill_hash=",next_drill.hash, " drill_type=",next_drill.type," sets_LEFT=",INFO.drill_set_cnt ," auto_run_mode=",INFO.auto_run_mode, " bot_slave=",INFO.bot_slave_mode, " next_user=",next_user," now=",Date.now()%100000/1000);
        debugFemurStats();       // DEBUG ONLY

        switch (next_drill) {
            // process special types
            //
            case "get_msg":
                setTimeout(()=> {
                    console.log("proc_chain.1290:  *************** WAKEUP!  SLAVE MODE - WAIT FOR NEXT DRILL");
                    processSlaveLastMsg(true);
                }, 500);
                return;

            case "repeat":
                // bot mode: run same drill for next user
                //
                setShowWait(false);
                console.log("proc_chain.2592:  *************** DISPLAY SWITCH USER MSG ",next_user.name, " bot_all_stats=",INFO.bot_all_stats,"  now=", Date.now()%100000/1000)
                delay = 5000;       // 33325000;
                INFO.countdown_time = null;


                if (delay_kludge) { delay = CONSTS.KLUDGE_BIG_DELAY; }


                if (INFO.bot_slave_mode === true) {
                    var slave_list = getUserPerfList(INFO.bot_all_stats, INFO.drill_hash, "proc_chain_repeat.3080");   // display peer stats in this class
                    setCountdownList(slave_list);
                    setBotSlaveDrillTitle(INFO.drill.name+" RANKING");
                }

                setCountdownTime(delay / 1000);     // show there is a delay
                setShowCountdown(true);     // show there is a delay
                setCountdownMsg("SWITCH USER: "+next_user.name.toUpperCase())
                setCountdownName(next_user.name.toUpperCase());
                playAudio(CONSTS.NEW_USER_START_PATH, "chain_new_user.2622");     // switch user alert

                setTimeout(async ()=> {
                    while ((INFO.db_store_started === true) && (INFO.db_store_completed === false)) {
                        await sleep (250);      // poll until all data is writtnen to db
                        console.log("proc_chain.2700:      . . . WAITING FOR DB STORE TO COMPLETE (processChainToday):  ",INFO.db_store_completed);
                    };
                    console.log("proc_chain.1458:  *************** WAKEUP!  NEW USER, SAME DRILL, AFTER @DELAY ",delay, " from=",from, " set=",INFO.drill_set_cnt," ************ now=", Date.now()%100000/1000)
                    INFO.countdown_time = null;
                    setShowBotSlave(false);

                    var mode = (selected === true) ? "first" : "slave";
                    handleAutoStartDrill(mode, "repeat_runaction.2774");
                    INFO.run_action("start");      // auto "start"
                }, delay+200);
                return;
        }


        // every drills used must be in All Drills
        //
        if (next_drill) {
            INFO.auto_run_mode = true;
            INFO.train_model_mode = true;       // KLUDGE: do not record AI overlay, use timer based (not loop)
            INFO.drill = Object.assign({}, next_drill);  // copy object
            INFO.drill_hash = next_drill.hash;
            console.log("proc_chain.1041:  AUTO START NEXT DRILL    chain_run=",INFO.chain_running,"  drill_hash=",INFO.drill_hash, " drill_name=",INFO.drill.name, " sets=", next_drill.min_sets,"  auto_run_mode=",INFO.auto_run_mode, " now=", Date.now()%100000/1000); //" bot_all_stats=", INFO.bot_all_stats, 


            if (delay_kludge) { delay = CONSTS.KLUDGE_BIG_DELAY; }


            setShowWait(false);
            if (INFO.bot_slave_mode === true) {
                var slave_list = getUserPerfList(INFO.bot_all_stats, INFO.drill_hash, "proc_chain_next_drill.3120");   // display peer stats in this class
                setCountdownList(slave_list);
                setBotSlaveDrillTitle(INFO.drill.name+" RANKING");
                console.log("proc_chain.2886:     . . . . slave_list=",slave_list);     //, " bot_all_stats=",INFO.bot_all_stats);
            }

            INFO.countdown_time = null;
            setCountdownTime(delay / 1000);     // show there is a delay
            setShowCountdown(true);     // show there is a delay
            setCountdownMsg(msg)
            setCountdownName(user_name);
            playAudio(CONSTS.NEW_USER_START_PATH, "chain_next.2722");     // ready chime

            setTimeout(async ()=> {
                while ((INFO.db_store_started === true) && (INFO.db_store_completed === false)) {
                    await sleep (250);      // poll until all data is writtnen to db
                    console.log("proc_chain.2728:      . . . WAITING FOR DB STORE TO COMPLETE:  db=",INFO.db_store_completed,"  now=", Date.now()%100000/1000)
                };
                console.log("proc_chain.2025:  *************** WAKEUP!  CHAIN AUTO START NEW DRILL ",next_drill.name," AFTER @DELAY ",delay,"  from=",from, " chain=",INFO.drill_chain_mode," chain_run=",INFO.chain_running, "   ************  now=", Date.now()%100000/1000)
                INFO.countdown_time = null;
                setShowCountdown(false); 
                setShowBotSlave(false);

                handleAutoStartDrill("slave", "new_drill_runaction.2812");        // always not selected when auto switch to new drill
                if(INFO.run_action) {
                    INFO.run_action("start");    // auto "start"
                } else {
                    console.error("proc_chain.2871:     ! ! ! ! ! !  ERROR: INFO run_action() IS NOT SET!!!",Date.now()%100000/1000);
                }
            }, delay+200);

        } else {
            // end of Today drills
            //
            console.log("proc_chain.2022:  # # # # # # AUTO END CHAIN DRILLS, NO MORE   TodayCatalogItems=",TodayCatalogItems, " now=", Date.now()%100000/1000)

        }

    }



    // *********************************** PRACTICE WEBCAM ROUTINE  ***********************************
    //
    function startPracticeWebcam() {
        GATag("Practice", "Webcam.Start", INFO.session_name, 0);		 // (cat, act, lab, val)
        // enable RUN collection right away without home activation
        //INFO.disable_calibration = true;    // wait until player is ready to go
        INFO.has_calibration = false;
        INFO.pose_top = null;
        INFO.pose_bot = null;

        INFO.interrupted_mode = false;    //setState("interrupted", false);   NOT THIS!  SMOKING GUN!
        INFO.rep_run_cnt = 0;
        INFO.perf_running = false;

        TIMES.timer_restart_cooldown = 0;   // ready to start
        TIMES.timer_stop_display = 0;       // display previous result display
        INFO.notify_messages = [];      // KLUDGE: This should be init earlier
        INFO.auto_completed = false;

        resetSession();     // clear it up for repeat runs
        INFO.session_name = SessionName;

        var warnings = getPersonalTarget();
        if (warnings !== null) {
            setShowPreFlight(true);
            setWarningText(warnings);
            setTimeout(()=>{ setShowPreFlight(false) }, 3000)
        }

        if(INFO.vertical_mode == false) {
            setShowExpand(true);     // display expand button
        }

        setConfirmation(null);
        setSummary([]);
        setOutcome("");
        setButtonText("STOP");
        setShowNotice(true);     // display sets and reps
        setRefresh(Date.now());

        //INFO.drill_tot_rep_cnt = parseInt(SelectedItem.reps);     // did it earlier
        //INFO.practice_tot_rep = parseInt(SelectedItem.reps);
        INFO.practice_degree_log = [];
        INFO.reps_running = false;
        INFO.practice_turn_idx1 = null;
        INFO.practice_turn_idx2 = null;

        INFO.summary_created = false;
        INFO.notify_title = "";
        INFO.notify_messages = [];

        INFO.webcam_started = true;
        setEnableWebcam(true);  //INFO.webcam_started =true;     // need this set to init webcam
        setWebcamWidth(INFO.webcam_owidth);
        setWebcamHeight(INFO.webcam_oheight);
        setTimeout(()=> { 
            initWebcamAI(guiState.net, true, "start_practice.2077");
            console.log("webcam_start.1615:     @@@@@@@@@@@@@@@@@ PRACTICE WEBCAM ISSUED  width=",INFO.webcam_owidth, "  height=",INFO.webcam_oheight)
        }, 600)

        /* do we?
        var [swidth, sheight] = adjustDisplayDiv("start_pract_cam.2037");
        setPlayerVideoWidth(swidth);
        setPlayerVideoHeight(sheight);
        */
        return;
    }

    function stopPracticeWebcam(mode, from) {
        TIMES.webcam_stop = Date.now();
        TIMES.session_stop = Date.now();
        var time = ((TIMES.session_stop - TIMES.session_start) / (1000 * 60)).toFixed(1);
        GATag("Practice", "Webcam.Stop", "", time);		 // (cat, act, lab, val)
        console.log("cam.2024:  # # # # STOP PRACTICE WEBCAM  from=", from, " mode=",mode," now=",Date.now()%100000/1000);

        if(mode !== "auto") initWebcamAI(guiState.net, false, "stop_practice.2093");
        setButtonText("START");
        setShowNotice(false);
        setShowExpand(false);
        setDrillActive(false);
        INFO.drill_running = false;
        INFO.show_cones = true;
        //initWebcamAI(guiState.net, false);
        //setINFO.webcam_started(false);
        //setNextSet(NextSet + 1);

        switch (mode) {
            case "save":
                // normal save and exit
                GATag("Practice", "Drill.Saved", INFO.session_name, 0);		 // (cat, act, lab, val)
                INFO.interrupted_mode = false;
                INFO.validate_passed = true;        // manual stop, no new record possible
                //setNextSet(NextSet + 1);
                stopRun(true, "stop.pract.cam.save.2842");
                stopSession("stopPractice.save.1950");
                setShowWait(true);
                setValidateRun(false);      // only if there is a new record
                setShowWaitSpinner(true);
                break;
            case "abort":
                GATag("Practice", "Drill.aborted", INFO.session_name, 0);		 // (cat, act, lab, val)
                // bot mode: reaceived abort command
                INFO.interrupted_mode = true;
                disableWebcamStream();
                stopRun(false, "stop.pract.cam.abort.2854");    // do not save, do not stop session
                ShowBotSlave(true);
                break;
            case "interrupt":
                GATag("Practice", "Drill.Interrupted", INFO.session_name, 0);		 // (cat, act, lab, val)
                // user don't not want to finish, abandon
                INFO.interrupted_mode = true;
                INFO.db_store_started = false;
                disableWebcamStream();
                stopRun(false, "stop.pract.cam.intrp.2861");    // do not save, do not stop session
                break;
            case "debug":
                // user stuck, submited a bug
                GATag("Practice", "Drill.HasBug", INFO.session_name, 0);		 // (cat, act, lab, val)
                INFO.interrupted_mode = false;
                stopRun(false, "stop.pract.cam.debug.2867");    // do not save, do not stop session

                stopSession("stopPractice.debug.1972");
                setShowWait(true);
                setShowWaitSpinner(true);
                break;
            case "auto":
                GATag("Practice", "Drill.AutoCompleted", INFO.session_name, 0);		 // (cat, act, lab, val)
                console.log("train.2743:   AUTO-COMPLETED ...", INFO.rep_run_cnt, " set_cnt=",INFO.drill_set_cnt);
                INFO.interrupted_mode = false;
                INFO.auto_completed = true;     // only if called up from lower level
                stopRun(true, "stop.pract.cam.auto.2879");
                stopSession("stopPractice.auto.1984");
                setNextSet(NextSet + 1);

                setShowWait(true);
                updateDrillSummary("Practice.Auto");

                if (INFO.drill_chain_mode === true) {
                    if (INFO.drill_chain_abort === false) {
                        setTimeout(()=> { 
                            console.log("runv.3202:  CONTINUE CHAIN FROM PRACTICE_STOP_CAM... mode=", mode, " now=",Date.now()%100000/1000);
                            setShowWait(false); 
                            processChainedTodayDrill("end", "skill_stop_cam.2675");
                        }, 6000)
                    }
                } else {
                    // show this when not chaining
                    //
                    setShowWaitSpinner(true);
                }
                break;
        }

        setTimeout(()=> {
            console.log("train.1548:   TURN OFF PRACTICE WEBCAM STARTED... now=",Date.now()%100000/1000);
            INFO.webcam_started = false;    // need delay so video canvas sticks around for the db write
        }, 800)

        setRefresh(Date.now());
    }




    // *********************************** CHALLENGE (PERF) WEBCAM ROUTINE  ***********************************
    //

    function startChallengeWebcam() {
        GATag("Training", "Webcam.Start", "", 0);		 // (cat, act, lab, val)
        INFO.has_calibration = false;
        INFO.pose_top = null;
        INFO.pose_bot = null;

        INFO.interrupted_mode = false;    //setState("interrupted", false);   NOT THIS!  SMOKING GUN!
        TIMES.webcam_start = Date.now();
        INFO.rep_run_cnt = 0;

        var video_container = document.getElementById('video_container');
        if(video_container)
            video_container.style.display = "flex";
        var analysis_container = document.getElementById('results_container');
        if (analysis_container)
            analysis_container.style.display = "flex";

        resetSession();     // in case of repeat runs
        INFO.session_name = SessionName;

        var warnings = getPersonalTarget();
        if (warnings !== null) {
            setShowPreFlight(true);
            setWarningText(warnings);
            setTimeout(()=>{ setShowPreFlight(false) }, 3000)
        }

        if(INFO.vertical_mode == false) {
            setShowExpand(true);     // display expand button
        }

        setConfirmation(null);
        setSummary([]);
        setOutcome("");
        setButtonText("STOP"); 
        setRefresh(Date.now());

        INFO.summary_created = false;
        INFO.notify_title = "";
        INFO.notify_messages = [];

        INFO.webcam_started = true;
        setEnableWebcam(true);  //INFO.webcam_started =true;     // need this set to init webcam
        setWebcamWidth(INFO.webcam_owidth);
        setWebcamHeight(INFO.webcam_oheight);
        setTimeout(()=> { 
          initWebcamAI(guiState.net, true, "start_perf.3692");
          console.log("webcam_start.3713:     @@@@@@@@@@@@@@@@@ CHALLENGE WEBCAM ISSUED  width=",INFO.webcam_owidth, "  height=",INFO.webcam_oheight)
          //playAudio(CONSTS.XXXX);     // hard chime
        }, 600)

    }



    function stopChallengeWebcam(mode, from) {
        GATag("Training", "Webcam.Stop", "", time);		 // (cat, act, lab, val)
        TIMES.webcam_stop = Date.now();
        TIMES.session_stop = Date.now();
        var time = ((TIMES.session_stop - TIMES.session_start) / (1000 * 60)).toFixed(1);
        console.log("cam.2985:  # # # # STOP PERF WEBCAM  from=", from, " mode=",mode, " now=",Date.now()%100000/1000);

        initWebcamAI(guiState.net, false, "stop_perf.3724");        // turn off camera
        setButtonText("START");
        setRunStopped(true);        // tell Result (need to refactor this?)
        setDrillActive(false);
        INFO.drill_running = false;
        //setTimeout(() => {initWebcamAI(guiState.net, false)}, 1000);
        //setTimeout(() => {setINFO.webcam_started(false)}, 400);       // slight delay for HTML

        switch (mode) {
            case "save":
                GATag("Perf", "Drill.save", INFO.session_name, 0);		 // (cat, act, lab, val)
                // normal save and exit
                INFO.interrupted_mode = false;
                INFO.validate_passed = true;        // manual stop, no new record possible
                stopRun(true, "stop.perf.cam.save.3767");
                stopSession("stopChallenge.save.3405");
                setShowWait(true);
                setShowWaitSpinner(true);
                break;
            case "abort":
                GATag("Perf", "Drill.aborted", INFO.session_name, 0);		 // (cat, act, lab, val)
                // bot mode: reaceived abort command
                INFO.interrupted_mode = true;
                disableWebcamStream();
                stopRun(false, "stop.perf.cam.abort.3009");     // do not save, do not stop session
                ShowBotSlave(true);
                break;
            case "interrupt":
                GATag("Perf", "Drill.interrupt", INFO.session_name, 0);		 // (cat, act, lab, val)
                // user don't not want to finish, abandon
                INFO.interrupted_mode = true;
                INFO.db_store_started = false;
                disableWebcamStream();
                stopRun(false, "stop.perf.cam.intrpt.3016");     // do not save, do not stop session
                break;
            case "debug":
                GATag("Perf", "Drill.debug", INFO.session_name, 0);		 // (cat, act, lab, val)
                // user stuck, submited a bug
                INFO.interrupted_mode = false;
                stopRun(false, "stop.perf.cam.debug.3032");     // do not save, do not stop session
                stopSession("stopChallenge.debug.3419");
                //setShowWait(true);
                setShowWaitSpinner(true);
                break;

            case "auto":
                GATag("Perf", "Drill.AutoCompleted", INFO.session_name, 0);		 // (cat, act, lab, val)
                console.log("challenge.1006:   AUTO-COMPLETED ...", INFO.rep_run_cnt, " set_cnt=",INFO.drill_set_cnt, " mode=",mode, " chain=",INFO.drill_chain_mode);
                INFO.interrupted_mode = false;
                INFO.auto_completed = true;     // only if called up from lower level
                stopRun(true, "stop.perf.cam.auto.3033");
                stopSession("stopChallenge.auto.3506");
                console.log("runv.3509:  WEBCAM STOP ISSUED... ", mode, "  now=",Date.now()%100000/1000);

                setShowWait(true);
                updateDrillSummary("Perf.Auto");

                if (INFO.drill_chain_mode === true) {
                    if (INFO.drill_chain_abort === false) {
                        setTimeout(()=> { 
                            console.log("runv.3202:  CONTINUE CHAIN FROM PERF_STOP_CAM... mode=", mode, " now=",Date.now()%100000/1000);
                            setShowWait(false); 
                            processChainedTodayDrill("end", "perf_stop_cam.4357");
                        }, 6000)
                    }
                } else {
                    //setShowWait(true);
                    setShowWaitSpinner(true);
                }
                break;
        }

        setTimeout(()=> {
            console.log("perf.2912:   TURN OFF CHALLENGE WEBCAM STARTED...  now=", Date.now()%100000/1000);
            INFO.webcam_started = false;    // need delay so video canvas sticks around for the db write
        }, 800)

        setRefresh(Date.now());
    }



    // *********************************** MAIN ITEM STARTING HANDLER ROUTINE  ***********************************
    //
    //
    const handleItemSelect = (tab, input, from) => {
        var handsfree = false;

        if (tab == 999) {
            // special hidden button for debug;
            setLearnRedirect(true);
            setLearnTarget("/dash")
            return;
        }

        setShowNeedHorizontal(false);
        if((VerticalMode === true) && (INFO.enforce_horizontal_mode === true)) {
            console.log("item_select.1227: !!!!!!!!! MUST FIRST ROTATE TO HORIZONTAL");
            setShowNeedHorizontal(true);
        }
        lockScreenHorizontal();

        console.log("item_select.851: ----->  REACHED HANDLE_SELECT  from=",from, " tab=", tab, " item=", input.name, " type=",input.type, "  ", input);
        // KLUDGE: input.fields should be array, need to fix it in DB
        if (typeof(input.field) == "string") {
            input.field = [input.field];
        }

        // KLUDGE: input.goals should be array, need to fix it in DB
        if (typeof(input.goals) == "string") {
            input.goals = [input.goals];
        }
        setSelectedItem(input);
        setShowDashboard(false);
        setShowCatalog(false);
        setShowPreFlight(false);

        setTabSelected(tab);        // remember
        var history = TabHistory;
        history[Mode] = tab;      // remember mode.tab setting
        setTabHistory(history);
        //console.log("item_select.1792:    . . . . .  TabHistory=", TabHistory, " tab=",tab);

        setConfirmation(null);
        INFO.auto_completed = false;
        INFO.bug_report = "";
        INFO.session_name = input.name;
        INFO.drill = Object.assign({}, input);  // copy object
        INFO.drill_hash = input.hash;
        INFO.seq_hash = input.seq_hash;
        INFO.notify_title = "";
        INFO.notify_messages = [];
        setSessionName(input.name);
        updateDrillHistory(input.hash, input.name, input.goals);
        setHistory([]);              // clear graph
        setSummary([]);              // clear summary

        var player_type = findVideoType(input.url);
        setPlayerType(player_type);
        console.log("item_select.1894:        ~~~~~~~~~~~~ <Learn> VIDEO IFRAME url=", input.url, " tab", tab, " player_type=",player_type, " input=",input);

        INFO.practice_mode = false;
        INFO.game_mode = false;
        INFO.mock_mode = false;
        INFO.perf_mode = false;
        INFO.analyze_mode = false;
        INFO.record_running = false;
        INFO.perf_running = false;
        INFO.interrupted_mode = false;
        INFO.session_completed = false;
        INFO.dev_analyze_mode = false;
        INFO.bot_master_mode = false;
        INFO.drill_running = false;
        INFO.defender_mode = false;
        //INFO.auto_run_mode = false;

        INFO.show_defender = false;
        INFO.defend_gave_up = false;
        INFO.femur_home_px = null;      // perf: femur lock @home

        //INFO.db_store_completed = false;     // turned off by storeStateCompleted()
        //INFO.db_store_started = false;       // turned on in initWebCamAI(off)
        //INFO.bot_slave_mode = false;      // NEED to do this explicitly!!!


        setShowDrill(false);
        setShowGame(false);
        setShowMock(false);
        setShowPerf(false);
        setShowAnalyze(false);
        setShowBotMaster(false);
        setShowBotSlave(false);
        setHideInstruction(false);
        setHideResult(false);
        setDrillActive(false);
        setEnableWebcam(false);    // Note:  need to set it to false so UseEffect() will register on true

        INFO.show_cones = false;
        INFO.show_home_zone = false;
        INFO.youtube_player = (input.url === null) ? false : input.url.includes("youtu");       // KLUDGE: for youtube height work around

        INFO.custom_min_loop_px = CONSTS.TURN_MIN_LOOP_TRAVEL;      // Note: switch to INFO.drill_param1?
        INFO.custom_min_loop_msec = CONSTS.TURN_MIN_ANCHOR_TIME;

        INFO.drill_param1 = parseSliceParams(input.param1);     // custom param overrides
        INFO.drill_param2 = parseSliceParams(input.param2);     // custom param overrides
        console.log("item_select.1886:  * * * * * *  DRILL  drill_name=",INFO.drill.name, "  param1=", INFO.drill_param1, " param2=",input.param2, " type=",input.type, " defender=",INFO.show_defender);

        if (INFO.drill_param1.auto_run) {
            setTimeout(()=> { 
                console.log("learn.3862:   ################  WAKEUP - Simulate Drill auto-play");
                INFO.disable_calibration = true;   // KLUDGE: force a disable so we can film the intro
                setAutoDrillStart(Date.now());      // simulated auto mode, need to give it a kick
            }, 3000)
        }


        /*
        if (INFO.drill_param1.show_ratio) {
            console.log("item_select.2402:               DRILL PARAM1 show_ratio=", INFO.override.show_ratio);
            INFO.override.show_ratio = INFO.drill_param1.show_ratio;
        } else {
            INFO.override.show_ratio = false;
        } */

        var rez =  (INFO.drill_param1.rez) ? INFO.drill_param1.rez : "low";
        var [ vwidth, vheight ] = set_webcam_resolution(rez);

        function init_set_info () {
            // Learn unique
            //setNextSet(1);
            //setButtonText("START SET 1");     << SET INFO SHOULD BE PASSED IN!!!!!!
            // setup instructions for this drill
            var outputs = [];
            var out1 = {};

            if (input.sets === 0) {
                // special training mode
                //
                out1.title = "1 SET:";
                out1.value = "60 SECONDS";
            } else {
                out1.title = input.sets+" SETS:";
                out1.value = input.reps+" REPS EACH";
            }
            outputs.push(out1)
            setInstrns(outputs);
        }


        INFO.drill_mode = input.type;
        switch (input.type) {
            case "drill":       // KLUDGE: For analyze new drill (NEED TO RETHINK)
            case "skill":
            case "condition":
                setShowDrill(true);
                INFO.drill_mode = "practice";
                INFO.practice_mode = true;
                INFO.reps_running = false;
                INFO.show_cones = true;

                INFO.practice_degree_log = [];
                INFO.practice_turn_idx1 = null;
                INFO.practice_turn_idx2 = null;

                setHideResults(false);

            /*  TODO:  NEED TO INIT THE CANVAS AFTER WEBCAM IS ON!!! */
                initVideoDisplay("vcanvas", "item_skill.3249");      // no analysis canvas

                if (INFO.drill_tot_set_cnt === null) {
                    INFO.drill_tot_set_cnt = parseInt(input.sets);   // NOTE: set to null to force new set
                }
                INFO.drill_tot_rep_cnt = parseInt(input.reps);

                init_set_info();
                initKnnState();     // setup motion and gesture token detection

                INFO.practice_run_mode = "reps";        // need this here
                if ((INFO.drill_param1.mode === "timer")) {
                    INFO.practice_run_mode = "timer";       // need this here
                    //INFO.timer_run_duration = parseInt(INFO.drill_param1.duration);

                    //var delay = parseInt(INFO.drill_param1.delay);      // timer mode
                    //INFO.drill_chain_delay = (delay) ? delay : CONSTS.DEFAULT_CHAIN_DELAY;      // Note: should this be generalized?
                    TIMES.start_timer_run = 0;       // reset so it won't trigger immediately
                    console.log("item_select.2353:      START DRILL TIMER MODE:  duration=", INFO.timer_run_duration, " delay=",INFO.drill_chain_delay);
                }

                // invoke chain auto-start if in Today mode
                //
                //if (((INFO.catalog_type === "today") || (INFO.bot_slave_mode === true)) && (INFO.drill_chain_mode === true)) 
                if (((INFO.catalog_type === "today") && (INFO.drill_chain_mode === true)) || (INFO.auto_run_mode === true) || (INFO.direct_start_mode === true)) {
                    console.log("item_select.2347:      START SKILL DRILL    handsfree=",handsfree, " type=",input.type, " abort=",INFO.drill_chain_abort,"  drill=",input.hash," set_cnt=", INFO.drill_set_cnt," rep_cnt=", INFO.drill_tot_rep_cnt, " chain_mode=",INFO.drill_chain_mode, " catalog_type=",INFO.catalog_type);
                    handsfree = true;
                }  else {
                    // testing
                    var outputs = [];
                    var out1 = {};
                    out1.title = "PRESS START THEN STAND ON GREEN CIRCLE"
                    out1.value = ""
                    outputs.push(out1)
                    setInstrns(outputs);
                    setShowNotice(true);
                    setSlowMo(INFO.slowmo_mode);
                    if (INFO.bot_slave_mode === false) {
                        handsfree = false;
                        setShowRaiseHand(false);
                    }
                    console.log("item_select.2324:     REGULAR DRILL MODE, NOT Today:  chain=",INFO.drill_chain_mode);
                }
                break;

            case "perf":
                    setShowPerf(true);      // triggers a react refresh to update div
                    INFO.drill_mode = "perf";
                    INFO.perf_mode = true;
                    INFO.show_cones = true;

                    INFO.show_home_zone = true;
                    INFO.perf_running = false;
                    INFO.interrupted_mode = false;

                    INFO.webcam_aspect = null;
                    INFO.video_owidth = null;
                    INFO.video_oheight = null;
                    INFO.video_aspect = null;
                    INFO.video_width = input.width;      // NOTE: CAN NOT RELY ON REACT VAR!!!
                    INFO.video_height = input.height;

                    setHideResults(false);
                    initVideoDisplay("vcanvas", "item_perf.4223"); 
                    if (INFO.drill_tot_set_cnt === null) {
                        INFO.drill_tot_set_cnt = parseInt(input.sets);   // NOTE: set to null to force new set
                    }
                    INFO.drill_tot_rep_cnt = parseInt(input.reps);

                    initKnnState();     // setup motion and gesture token detection

                    var btn = document.getElementById('start_btn');
                    if ((INFO.no_ai_mode == false) && (btn !== null)) {
                        btn.style.display = "none";
                        btn.style.display = "flex";
                        //setButtonText("LOADING...");
                    }


                    // DEFENDER SPECIAL CASE:
                    //
                    INFO.drill_param1 = parseSliceParams(input.param1);     // custom param overrides
                    //if (INFO.drill_param1.defend_cog) {
                    if (INFO.defend_cog) {
                        INFO.drill_mode = "defender";
                        INFO.defender_mode = true;      // show defender once calibrated
                        initDefender();
                        //INFO.defend_cog = parseInt(INFO.drill_param1.defend_cog);
                        //INFO.defend_acc =  (INFO.drill_param1.defend_acc) ? parseFloat(INFO.drill_param1.defend_acc) : CONSTS.DEFENDER_ACCELERATION;
                        //INFO.defend_gap = (INFO.drill_param1.defend_gap) ? parseFloat(INFO.drill_param1.defend_gap) : CONSTS.DEFENDER_GIVE_UP_GAP_PCT;
                        //INFO.override.show_ht = (INFO.drill_param1.show_ht == true) ? true : false;

                        TIMES.start_timer_run = 0;       // reset so it won't trigger immediately
                        INFO.timer_run_duration = CONSTS.DEFENDER_DEFAULT_TIME;     // max duration to shake the defender
                        console.log("item_select.3348:         PARAM1  DEFENDER   defend_cog=",INFO.defend_cog, "  defend_acc=",INFO.defend_acc, " defend_gap=",INFO.defend_gap); //, " max_dx_psec=",INFO.defend_max_dx_psec);
                    } 

                    if (((INFO.catalog_type === "today") && (INFO.drill_chain_mode === true)) || (INFO.auto_run_mode === true) || (INFO.direct_start_mode === true)) {
                        handsfree = true;
                    } else {
                        if (INFO.bot_slave_mode === false) {
                            handsfree = false;
                            setShowRaiseHand(false);
                        }
                    }

                    console.log("item_select.2020:  SELECT PERF MODE!!!   ",input.name, " handsfree=",handsfree, " auto_run=",INFO.auto_run_mode,"  params=",input.param1, " chain=",INFO.drill_chain_mode, " defender=",INFO.show_defender, " reps=",INFO.drill_tot_rep_cnt);
                    GATag("Training", "Challenge.Select", input.name, 0);		 // (cat, act, lab, val)
                    break;


            case "game":
                setShowGame(true);      // Useless across game sessions
                INFO.drill_mode = "game";
                INFO.game_mode = true;

                var schemes = [], speed1, speed2;
                if(INFO.drill_param1.speed1) {
                    speed1 = INFO.drill_param1.speed1;
                    speed2 = INFO.drill_param1.speed2;
                }
                //var schemes = setupScheme(input.motion_hash, input.param1, input.param2);
                var schemes = setupScheme(input.motion_hash, speed1, speed2);
                setGameScheme(schemes);              // target sequence
                console.log("item_select.1938:       GAME   speed1=",speed1, "  fingers=",input.fingers, " schemes=",schemes, " INFO.drill_param1=",INFO.drill_param1);

                var fingers = (input.fingers) ? input.fingers : 1;
                INFO.game_fingers = fingers;
                setGameFingers(fingers);      // game mode

                INFO.max_reps = input.reps;     // NOTE: reuse drill_tot_set_cnt?
                setGameCnt(GameCnt + 1);
                TIMES.session_start = Date.now();   // each finger run is a session
                INFO.sidebar_width = CONSTS.SIDEBAR_SMALL_WIDTH;
                init_set_info();

                //if ((INFO.catalog_type === "today") && (INFO.drill_chain_mode === true)) 
                if (((INFO.catalog_type === "today") && (INFO.drill_chain_mode === true)) || (INFO.auto_run_mode === true) || (INFO.direct_start_mode === true)) {
                    handsfree = true;
                } else {
                    if (INFO.bot_slave_mode === true) {
                        handsfree = true;
                    }
                }

                console.log("item_select.1971:  SELECT GAME   ShowGame=",ShowGame, "  Fingers=",input.fingers,"  GameCnt=", GameCnt, "  schemes=", schemes.length, " handsfree=",handsfree);
                break;


            case "mock":
                setShowMock(true);      // Useless across mock sessions
                INFO.drill_mode = "mock";
                INFO.mock_mode = true;
                INFO.mock_type = input.subtype;
                setNoDetect(false);         // don't know until we read from db
                handsfree = false;        // auto start has no meaning here?

                TIMES.session_start = Date.now();   // each finger run is a session
                INFO.sidebar_width = CONSTS.SIDEBAR_SMALL_WIDTH;
                //init_set_info();

                var dirs = [{ heading: "SIMULATE REAL GAME FOOTAGE, CLICK TO REACT",
                              value: "" },
                            { title: "SETUP", 
                              value: "Rotate device upside down to orientat for left-handers" }]
                setUseDirections(dirs);

                console.log("item_select.3810:  SELECT MOCK   mock_type=",INFO.mock_type, " mock_mode=",INFO.mock_mode, " drill_mode=",INFO.drill_mode);

                if (((INFO.catalog_type === "today") && (INFO.drill_chain_mode === true)) || (INFO.auto_run_mode === true) || (INFO.direct_start_mode === true)) {
                    handsfree = true;
                } else {
                    if (INFO.bot_slave_mode === true) {
                        handsfree = true;
                    }
                }
                break;

            case "analyze":
                    var outputs = [];
                    setShowAnalyze(true);
                    INFO.drill_mode = "analyze";
                    INFO.analyze_mode = true;

                    INFO.video_owidth = null;
                    INFO.video_oheight = null;
                    INFO.video_aspect = null;

                    console.log("item_select.1585:   DELAY PERF DISPLAY SETUP END...", Date.now()%100000/1000);
                    console.log("item_select.2036:   SELECT ANALYZE   key=", input.key, input, " width=",input.width, " height=",input.height);

                    // KLUDGE: input.fields should be array, need to fix it in DB
                    if (typeof(input.field) == "string") {
                        input.field = [input.field];
                    }
                    setSelectedItem(input);

                    INFO.sidebar_width = CONSTS.SIDEBAR_SMALL_WIDTH;
                    INFO.sidebar_height = CONSTS.SIDEBAR_HEIGHT;
                    INFO.dev_video_stopped = true;
                    INFO.dev_record_mode = "";        // always override "original"
                    INFO.dev_analyze_mode = false;
                    INFO.dev_webcam_mode = false;
                    INFO.validate_passed = false;
                    INFO.record_running = false;
                    INFO.dev_ai_running = false;
                    INFO.dev_recording = false;
                    setDevAnalyzeRunning(false);
                    setDevRecording(false);
                    setDevRunningAI(false);
                    setShowDevButton(false)
                    setDevMarkerTrace(INFO.knn_debug_mode);
                    setDevMarkerReset(INFO.knn_reset_mode);

                    setButtonText("ENABLE AI");
                    setRefresh(Date.now());

                    var bits = input.key.split("-");
                    var key = bits[0];      // e.g. "replay-drill", "collect-cond"
                    var subtype = bits[1];
                    setDevSubKey(key);
                    setDevAnalyzeLive(false);        // use video clip as source
                    //initVideoDisplay("vcanvas", "item_analyze.4430");        // draw to output canvas
                    switch (key) {
                        case "flm":
                            var dirs = [{ heading: "VIDEOS FROM YOUR SESSSION WILL SHOW UP HERE",
                                value: "" },
                                { title: "WHEN",
                                value: "Video will show up around 15 minutes after you finish a session"}]

                            INFO.session_name = "player-session";
                            GATag("Training", "Film.Show", "", 0);		 // (cat, act, lab, val)
                            fetchSessionVideoLinks()
                            .then(res => {
                                for (var i = 0; i < res.length; i++) {
                                    var data = res[i];
                                    var out = {};
                                    out.action = "video";
                                    out.type = "session";
                                    out.title = data.name.toUpperCase() + " " + data.date;
                                    out.value = data.video;
                                    out.width = data.width;
                                    out.height = data.height;
                                    //console.log("item_select.299:            REVIEW VIDEO   ",i,"  title=", out.title);
                                    outputs.push(out);
                                }

                                if(outputs.length == 0) {
                                    var out = {};
                                    out.title = "NO DATA FOUND"
                                    out.value = "";
                                    outputs.push(out);
                                }

                                console.log("item_select.166:   ====>  REVIEW VIDEO RESULT  videos.len=",outputs.length);
                                setPlayerType("vimeo");     // ALWAYS
                                setVideosList(outputs);
                                setLinks(outputs);
                                setRefresh(Date.now());
                                setDevAnalyzeMode(false);
                                setShowDevDrillCreate(false);
                            })
                            break;

                        case "edit":
                        case "footage":
                            var dirs = [{ heading: "EDIT MOCK FOORTAGE",
                                value: "" },
                                { title: "WHEN",
                                value: "Edit past game footage to create Mock sessions"}]

                            INFO.session_name = "game-footage";
                            console.log("item_select.2106:  = = = = = = = = = READY MOCK FOOTAGE LIST   subtype=",subtype);
                            fetchFootageLinks("footage", subtype)
                            .then(res => {
                                for (var i = 0; i < res.length; i++) {
                                    var data = res[i];
                                    var out = {};
                                    //console.log("vid.299:   ",i,"  data=", data);
                                    out.action = "video";
                                    out.type = data.type;
                                    out.subtype = data.subtype;
                                    out.title = (data.title) ? data.title : data.video_id;
                                    out.value = data.hash;
                                    out.video_id = data.video_id;
                                    out.width = data.width;
                                    out.height = data.height;
                                    outputs.push(out);
                                }

                                if(outputs.length == 0) {
                                    var out = {};
                                    out.title = "NO DATA FOUND"
                                    out.value = "";
                                }

                                // consumed in handleShowAnalyzeVideo()
                                //console.log("select.166:  videos.len=",outputs.length);

                                setVideosList(outputs);
                                setLinks(outputs);
                                setRefresh(Date.now());
                                setDevAnalyzeMode(false);   // IMPORTANT!
                                setButtonText("PROCESS");
                            })
                            break;

                        case "raw":
                        case "replay":
                            var dirs = [{ heading: "VIEW AI OVERLAY ON VIDEOS",
                                value: "" },
                                { title: "WHAT",
                                value: "Run AI overlay on video to extract motion tokens and sequences"}]

                            // AI analysis of drill for dev, or raw footage to make new drills
                            //
                            INFO.session_name = "replay-video";
                            //console.log("item_select.4561:  = = = = = = = = = READY ",key,"  FOOTAGE LIST   subtype=",subtype);
                            fetchFootageLinks(key, subtype)
                            .then(res => {
                                for (var i = 0; i < res.length; i++) {
                                    var data = res[i];
                                    var out = {};
                                    out.action = "video";
                                    out.title = data.title;
                                    out.type = data.type;
                                    out.subtype = data.subtype;
                                    out.value = data.hash;
                                    out.video_id = data.video_id;
                                    out.enabled = data.enabled;
                                    out.width = data.width;
                                    out.height = data.height;
                                    outputs.push(out);
                                    //console.log("item_select.2178:     . . . . ",i,"  out=", out);
                                }

                                if(outputs.length == 0) {
                                    var out = {};
                                    out.title = "NO DATA FOUND"
                                    out.value = "";
                                }

                                // consumed in handleShowAnalyzeVideo()
                                console.log("item_select.166:  ",key," videos.len=",outputs.length);
                                outputs.sort(arrayTimestampDesSort)
                                setVideosList(outputs);
                                setLinks(outputs);
                                setRefresh(Date.now());
                                setDevAnalyzeMode(true);
                                setButtonText("ENABLE AI");
                            })
                            break;

                        case "collect":
                            var dirs = [{ heading: "COLLECT POSE MOTION DATA",
                                value: "" },
                                { title: "WHAT",
                                value: "Test Pilot players create motion data for new drills, used for AI model training"}]

                            // run new drills that does not have motion markers
                            //
                            INFO.session_name = "collect-motion";
                            console.log("item_select.2140:  = = = = = = = = = READY ",key,"  DRILL LIST   subtype= new");
                            fetchNewDrillLinks()
                            .then(res => {
                                var drills = processDrillItems(res);

                                var outputs = [];
                                for (var i = 0; i < drills.length; i++) {
                                    var data = drills[i];
                                    var out = Object.assign({}, data);  // copy object
                                    //out.subtype = data.subtype;
                                    out.action = "train";
                                    out.type = data.type;
                                    out.title = data.drill_key;
                                    out.value = data.hash;
                                    out.hash = data.hash;
                                    out.video_id = data.video_hash;
                                    out.drill_video = data.video_hash;      // consumed by processDrillItems() later
                                    out.width = data.width;
                                    out.height = data.height;
                                    out.sets = 1;        // HARD CODE: TRAINING MODE, FIXED TO 10 per session
                                    out.reps = 1;        // HARD CODE: TRAINING MODE, USE TIME
                                    out.param1 = JSON.stringify({"mode": "timer", "duration": 15, "delay":10, "train_set": 10});     // every drill 60 seconds
                                    out.enabled = true;

                                    outputs.push(out);
                                    console.log("item_select.2178:     . . . . ",i,":   out=", out, " data=",data);
                                }

                                if(outputs.length == 0) {
                                    var out = {};
                                    out.title = "NO DATA FOUND"
                                    out.value = "";
                                }

                                // consumed in handleShowAnalyzeVideo()
                                //INFO.db_drills = JSON.parse(JSON.stringify(outputs));       // deep copy array of objects, this allows reloading later
                                INFO.db_drills = INFO.db_drills.concat(outputs);       // deep copy array of objects, this allows reloading later
                                console.log("select.2519:  ",key," new_drills.len=",outputs.length, " ",INFO.db_drills);
                                outputs.sort(arrayTimestampDesSort)
                                setVideosList(outputs);
                                setLinks(outputs);
                                setRefresh(Date.now());
                                setDevAnalyzeMode(true);
                                setButtonText("TRAIN");

                            });
                            break;

                        case "webcam":
                            var dirs = [{ heading: "LIVE WEBCAM FOR TRAINING",
                                value: "" },
                                { title: "WHAT",
                                value: "Run Webcam with AI layer to extract motion tokens from custom pose in real time"} ];

                            // Show webcam for interactive session
                            //
                            console.log("item_select.2872:     WEBCAM INTERACTIVE SESSION");
                            setVideosList([]);
                            setDevAnalyzeMode(true);
                            setShowAnalyzeWebcam(true);     // show webcam
                            setShowAnalyzeVideo(false);
                            setDevAnalyzeLive(true);        // use webcame as source
                            INFO.dev_webcam_mode = true;
                            INFO.session_name = "live-webcam";

                            setDevAIControlOpen(true);
                            setShowDevDrillCreate(true);
                            setShowDevButton(true);
                            initVideoDisplay("vcanvas", "item_ai_train.3638");        // render to intermediate canvas first

                            setButtonText("ENABLE AI");
                            setRefresh(Date.now());
                            handleAnalyzeWebcam();        // turn on webcam automatically, but not AI layer
                            break;

                        case "bot":
                            // slave device control
                            //
                            var dirs = [{ heading: "CONTROL SLAVE DEVICES",
                                value: "" },
                                { title: "WHAT",
                                value: "Control Group of Slave device for group instruction at clinics"}]

                            console.log("item_select.2964:     SLAVE DEVICE CONTROL  key=",key, " subtype=",subtype, " input=",input);
                            INFO.bot_slave_mode = false;
                            INFO.bot_master_mode = false;
                            INFO.bot_last_msg = null;
                            INFO.bot_setup_msg_id = null;
                            INFO.bot_all_drills = null;
                            INFO.drill_hash = null;
                            switch (subtype) {
                                case "setup":
                                    INFO.bot_master_mode = true;
                                    setShowBotMaster(true);
                                    setHideInstruction(true);
                                    setHideResult(true);
                                    break;

                                case "slave3":
                                case "slave2":
                                case "slave":
                                    INFO.bot_slave_mode = true;
                                    setShowBotSlave(true);
                                    setHideInstruction(true);
                                    setHideResult(true);
                                    handsfree = true;


                                    // MEGA KLUDGE: NEED TO LOGIN VIA LINK
                                    if(subtype === "slave") INFO.bot_active_device_hash = "arena1:device_lamo";
                                    if(subtype === "slave2") INFO.bot_active_device_hash = "arena2:device_lamo";
                                    if(subtype === "slave3") INFO.bot_active_device_hash = "arena3:device_lamo";





                                    // align to every 15 secs and start listen mode
                                    //
                                    //setBotSlaveBackground(INFO.splash_image);
                                    setBotSlaveBackground("lamo-512.png");      // KLUDGE HANDCODE
                                    var time = Date.now();
                                    var min0 = time % CONSTS.BOT_SLAVE_CHECK_INTERVAL;
                                    console.log("item_select.858:    ! ! ! !  BOT SLAVE    time=",time, "  min0=",min0, " now=", new Date());

                                    setTimeout(()=> {
                                        var now = new Date();
                                        console.log("item_select.863:   . . .   WAKEUP!  BOT SLAVE TIME ALIGNMENT   time=",Date.now()%100000/1000, " today=",now);
                                        processSlaveTimer();     // wait then check again
                                    },  (CONSTS.BOT_SLAVE_CHECK_INTERVAL - min0));
                                    break;
                            }
                            break;
                    }
                    setUseDirections(dirs);

                    INFO.tut_module = "analyze";
                    INFO.tut_op = input.id;
                    var show = getTutorial(INFO.tut_module, INFO.tut_op);
                    if(show !== null) {
                        setShowTut(show);
                        //setShowTutorial(true);
                    }
                    break;
            }


            INFO.tut_module = input.type;
            INFO.tut_op = input.hash;
            var show = getTutorial(INFO.tut_module, INFO.tut_op);
            if(show !== null) {
                setShowTut(show);
            }
            if ((INFO.bot_slave_mode === true) || (INFO.auto_run_mode === true)) {
                handsfree = true;
            }

            console.log("item_select.4746:     # # # # #  END SELECT   handsfree=",handsfree, " from=",from, " auto_mode=",INFO.auto_run_mode,
                        " abort=",INFO.drill_chain_abort, " tab=", tab, " item=", input.name, " type=",input.type, "  ", input);
            setHandsFree(handsfree);
            setButtonText("START");
            setRefresh(Date.now());
        }


        // analyze: record video and send to vimeo
        //     - Turn on & off AI alone will only AI analyze (no recording)
        //     - Turn on Recording with AI will force sync AI to the video
        //     - Stop Recording will stop Video recording AND AI (if running)
        //
        const handleRecordAnalyzeVideo = () => {
            INFO.dev_analyze_mode = true;
            //if (DevRecording === false) 
            if (INFO.dev_recording === false) {

                // start video recording (AI needs to run b4)
                //
                setDevRecording(true);
                INFO.dev_recording = true;
                INFO.dev_video_stopped = false;

                //if (DevRunningAI === false) 
                if ( INFO.dev_ai_running === false) {
                    setTimeout(() =>{

                        if (INFO.dev_webcam_mode === true) {
                            TIMES.start_run = Date.now();
                        } else {
                            TIMES.start_run = (INFO.learn_player.getTime() * 1000);     // needs to be in msecs
                        }
                        TIMES.webcam_start = TIMES.start_run;

                        INFO.dev_record_mode = "original";
                        initVideoDisplay("output", "record_anal.3745");        // draw directly to output
                        drawVideoScreen("original", "record.anal.4751");      // do not start multiple loops
                        console.log("item_select.2241:     # # # # #  TURN ON LOOP FOR RAW RECORDING");

                        // NOTE: need better file name
                        recordOutput(INFO.output_canvas, "test_recording", true);
                        INFO.record_running = true;     // need this?
                        INFO.dev_recording = true;
                        console.log("item_select.2233:     # # # # #  START RECORDING RAW-ONLY VIDEO");
                    }, 100);        // slight delay for React to turn out <canvas>
                } else {

                    // AI is running, so reset the HISTORY and time to sync up with video
                    //
                    setTimeout(() =>{
                        if (INFO.dev_webcam_mode === true) {
                        } else {
                            TIMES.start_run = Date.now();
                        }
                        TIMES.webcam_start = TIMES.start_run;

                        //initHistory();
                        //search hist.56
                        setFrameEvent("START");     // mark the start instead of clear HISTORY

                        recordOutput(INFO.output_canvas, "test_double_ai:dev", true);
                        INFO.record_running = true;
                        INFO.dev_recording = true;
                        console.log("item_select.2233:     # # # # #  START RECORDING RAW + AI VIDEO");
                    }, 100);        // slight delay for React to turn out <canvas>

                    if(INFO.dev_webcam_mode === true) {
                        setTimeout(() =>{
                            resetSession();     // in case of repeat runs
                            handleAnalyzeWebcam();  // start raw webcam again
                        }, 4000);        // turn webcam back on after save to vimeo
                    }
                }


            } else {

                // stop recording
                //
                INFO.record_running = false;
                INFO.dev_recording = false;
                handleStopAnalyze("save")

            }
            var player = document.getElementById('vimeo_player_container');
            if (player) player.focus();
        }




    // *********************************** GAME ROUTINES  ***********************************
    //

    const handleStopGame = (mode) => {
        console.log("stop_game.1918:  GAME STOPPED  mode=", mode, " drill_running=",INFO.drill_running," recording=",INFO.record_output," chain=",INFO.drill_chain_mode, " abort=",INFO.drill_chain_abort," now=",Date.now()%100000/1000);
        setGameStarted(false);
        setRunStopped(true);        // tell Result (need to refactor this?)
        if (INFO.drill_running === true) {
            INFO.drill_running = false;
        } else {
            return;     // already called once
        }



        // TODO: NEED TO MERGE <canvas drill_output> to a new <canvas output>
        //



        if(false || (INFO.record_output === true)) {
            //INFO.output_canvas = "output";
            recordOutput(INFO.out_canvas, "stop.game_intro", false); // stop recording
        }/**/






        setDrillActive(false);
        INFO.sidebar_width = CONSTS.SIDEBAR_SMALL_WIDTH;
        INFO.sidebar_height = CONSTS.SIDEBAR_HEIGHT;     // rungame in full screen
        //adjustDisplayDiv("stop_game.2663");       // don't do here, it skips the result
        if (mode == "save") {
            INFO.auto_completed = true;     // only if called up from lower level
        }
        switch (mode) {
            case "interrupt":
                GATag("Game", "Game.Interrupted", INFO.session_name, 0);		 // (cat, act, lab, val)
                INFO.interrupted_mode = true;
                INFO.db_store_started = false;
                setNextSet(1);
                break;
            case "error":
            case "save":
                GATag("Game", "Game.Saved", INFO.session_name, 0);		 // (cat, act, lab, val)
                INFO.interrupted_mode = false;
                INFO.validate_passed = true;        // manual stop, no new record possible
                //setShowGame(false);     // turn off game display
                //updateGameSummary();
                setNextSet(NextSet + 1);
                setShowWait(true);
                setShowWaitSpinner(true);
                updateDrillSummary("Game.Save");
                CreateVirtualSession(INFO.email, INFO.uid, "game");        // write it out
                break;
            case "debug":
                GATag("Game", "Game.HasBug", INFO.session_name, 0);		 // (cat, act, lab, val)
                INFO.interrupted_mode = false;
                setNextSet(1);
                setShowWait(true);
                setShowWaitSpinner(true);
                updateDrillSummary("Game.Debug");
                CreateVirtualSession(INFO.email, INFO.uid, "bug");        // write it out
                break;
            case "auto":
                break;
        }

        if (INFO.drill_chain_mode === true) {
            if (INFO.drill_chain_abort === false) {
                setTimeout(()=> { 
                    setShowWait(false); 
                    processChainedTodayDrill("end", "game_stop.3267");
                }, 6000);     // wait for session write
            }
        } else {
            //setShowWait(true);
            setShowWaitSpinner(true);
        }

        setGameCnt(GameCnt + 1);    // start another one
    }



    // *********************************** MOCK (SIMULATION) ROUTINE  ***********************************
    //

    const handleStopMock = (mode) => {
        console.log("stop_game.516:  SIMULATION STOPPED  mode=", mode);
        //setMockStarted(false);
        setMockStarted(0);
        setRunStopped(true);        // tell Result (need to refactor this?)
        setDrillActive(false);
        INFO.drill_running = false;

        INFO.sidebar_width = CONSTS.SIDEBAR_SMALL_WIDTH;
        if (mode == "save") {
            INFO.auto_completed = true;     // only if called up from lower level
        }
        switch (mode) {
            case "interrupt":
                GATag("Mock", "Mock.Interrupted", INFO.session_name, 0);		 // (cat, act, lab, val)
                INFO.interrupted_mode = true;
                INFO.db_store_started = false;
                setNextSet(1);
                break;
            case "error":
                GATag("Mock", "Mock.Error", INFO.session_name, 0);		 // (cat, act, lab, val)
                INFO.interrupted_mode = true;
                setNextSet(1);
                setNoDetect(true);
                break;
            case "save":
                GATag("Mock", "Mock.Saved", INFO.session_name, 0);		 // (cat, act, lab, val)
                INFO.interrupted_mode = false;
                INFO.validate_passed = true;        // manual stop, no new record possible
                setNextSet(NextSet + 1);
                setShowWait(true);
                setShowWaitSpinner(true);
                updateDrillSummary("Mock.Save");
                CreateVirtualSession(INFO.email, INFO.uid, "mock");        // write it out

                setMockCnt(MockCnt + 1);    // start another one
                //updateGameSummary();
                //setShowGame(false);     // turn off game display
                break;
            case "debug":
                GATag("Mock", "Mock.HasBug", INFO.session_name, 0);		 // (cat, act, lab, val)
                INFO.interrupted_mode = false;
                setNextSet(1);
                setShowWait(true);
                setShowWaitSpinner(true);
                updateDrillSummary("Mock.Debug");
                CreateVirtualSession(INFO.email, INFO.uid, "bug");        // write it out
                break;
        }

        if (INFO.drill_chain_mode === true) {
            if (INFO.drill_chain_abort === false) {
                setTimeout(()=> { 
                    setShowWait(false); 
                    processChainedTodayDrill("end", "mock_stop.3326");
                }, 6000);     // wait for session write
            }
        } else {
            //setShowWait(true);
            setShowWaitSpinner(true);
        }
    }




    // *********************************** ANALYZE (VIEW VIDEO) ROUTINE  ***********************************
    //

    const handleStopAnalyze = (mode) => {
        console.log("stop_analyze.1933:  ANALYZE SESSION STOPPED  mode=", mode);
        setRunStopped(true);        // tell Result (need to refactor this?)
        setDrillActive(false);
        setDevAnalyzeRunning(false);      // to force create a virtual session to store log to db
        setDevRunningAI(false);
        setDevRecording(false);
        setDrillActive(false);
        setButtonText("ENABLE AI");
        setAnalyzeStarted(0);
        INFO.dev_ai_running = false;
        INFO.dev_recording = false;
        INFO.drill_running = false;

        if (INFO.learn_player) INFO.learn_player.pause();
        INFO.dev_video_stopped = true;      // key to turn off AI or video canvas processing
        TIMES.session_stop = Date.now();

        switch (mode) {
            case "interrupt":
                GATag("Anal", "Anal.Interrupted", INFO.session_name, 0);		 // (cat, act, lab, val)
                INFO.interrupted_mode = true;
                disableWebcamStream();
                break;
            case "error":
                GATag("Anal", "Anal.Error", INFO.session_name, 0);		 // (cat, act, lab, val)
                INFO.interrupted_mode = true;
                disableWebcamStream();
                break;
            case "save":
                GATag("Anal", "Anal.Saved", INFO.session_name, 0);		 // (cat, act, lab, val)
                INFO.interrupted_mode = false;
                setShowWait(true);
                setShowWaitSpinner(true);

                recordOutput(INFO.output_canvas, "stop.analyze.4739", false);        // stop video recording
                console.log("learn.2225:     # # # # #  STOP RECORDING DEV VIDEO  canvas=", INFO.analysis_canvas);

                INFO.validate_passed = true;
                var fake_email = "study@dev.test";
                var fake_uid = "99999";
                CreateVirtualSession(fake_email, fake_uid, "replay");        // write it out
                console.log("learn.2236:    . . . . .  STOP DEV AI ANALYZE :  mode=", mode);

                disableWebcamStream();
                setMockCnt(MockCnt + 1);    // start another one
                break;
            case "debug":
                GATag("Anal", "Anal.HasBug", INFO.session_name, 0);		 // (cat, act, lab, val)
                INFO.interrupted_mode = false;
                setShowWait(true);
                setShowWaitSpinner(true);
                disableWebcamStream();
                //CreateVirtualSession(INFO.email, INFO.uid, "bug");        // write it out
                break;
        }
    }


    // process selected tab
    //     - return to the last selected tab
    //
    const handleTabSelect = (tab) => {
        setTabSelected(tab);        // remember
        var history = TabHistory;
        history[Mode] = tab;      // remember mode.tab setting
        setTabHistory(history);
        INFO.drill_chain_mode = false;      // KLUDGE: BREAK AUTO MODE, DO IT SOMEWHERE ELSE?

        console.log("learn.1792:    . . . . .  TabHistory=", TabHistory, " tab=",tab, " chain=",INFO.drill_chain_mode);
    }

        // analyze: developer processing of footage
        //     - use this to conduct study of AI algo
        //     - Could use video or webcam (handleAnalyzeWebcam)
        //     - only affect AI layer, does not control video source here
        //
        const handleDevActionProcess = () => {
            var canvas = null;

            INFO.dev_analyze_mode = true;
            console.log("dev_action.2975:     # # # # #  HANDLE DEV ACTION   DevAnalyzeRunning=", DevAnalyzeRunning, " DevRunningAI=",DevRunningAI, " knn_tokens=",INFO.knn_drill_tokens.length, " knn_dict=",INFO.knn_token_dictionary);
            if (DevAnalyzeRunning === false) {

                // start ai
                //
                INFO.dev_ai_running = true;
                setDevAnalyzeRunning(true);
                setDevRunningAI(true);
                resetSession();

        // WORKING TOKENS
        //
        //INFO.knn_drill_tokens = [['CF00220', 'CE00221'], ['DH00221', 'DG01221']];       // s2sr working
        //INFO.knn_drill_tokens = [ ['CF00221', 'DH00220', 'DH10111'], ["CF21330", "DG22441", "DH22441"], ['CE00111', 'DG00221']];     // elastico working
        //INFO.knn_drill_tokens = [['DH31221','DH22230', 'CE22230'], ['CF22230', 'DG31420']];        // lateral lunge
        //INFO.knn_drill_tokens = [['CE02220', 'DG11220'], ['CF02221']];        // yoyo
        //INFO.knn_drill_tokens = [['DG14340', 'CE01221'], ['CF01220', 'DH02231'], ['DG01221', 'CF12330'], ['CF01220', 'DH02231']];     // golem cruff combo


                if(INFO.dev_webcam_mode === true) {
                    canvas = "vcanvas";    //output";
                    console.log("dev_action.2996:       Start DEV LIVE AI WEBCAM  ai_running=",INFO.dev_ai_running, " vid_stopped=",INFO.dev_video_stopped)
                } else {
                    setPlayerPausedReplay(true);        // keep looping
                    canvas = "output";
                    console.log("dev_action.2187:     # # # # #  START DEV ANALYZE RUN for ",VideoItem.video_hash);
                }


                if(true) {
                    // smart init
                    //    - if has drill vector, extract the dict from the vector (could be from db) and do real time loop detect (normal mode)
                    //    - if no drill vector but has dict, allow single step AI, this is to debug the vector
                    //    - if no drill vector & no dict, set both to zero and start extract from via training
                    //
                    if ((INFO.knn_drill_tokens.length > 0) || (Object.keys(INFO.knn_static_tokens).length > 0)) {
                        // normal run mode
                        //
                        //knnLoadMarkers(INFO.knn_drill_tokens, INFO.knn_static_tokens);        // TODO: This should come from db
                        knnLoadMarkers(INFO.knn_drill_tokens, {});        // TODO: This should come from db
                        setValidLimbs(INFO.knn_token_dictionary);

                    } else {

                        // no pre-loaded tokens, build the dict from training
                        //
                        if (INFO.knn_token_dictionary.length === 0) {
                            INFO.knn_drill_tokens = [[]];       // NOTE: Load this from db
                            INFO.knn_token_dictionary = [];     // collect this from drill video using frequency analysis
                            //knnLoadMarkers(INFO.knn_drill_tokens, INFO.knn_static_tokens);        // TODO: This should come from db
                            knnLoadMarkers(INFO.knn_drill_tokens, {});        // TODO: This should come from db
                        } else {
                            // allow single AI step to see the effect of loop detection
                            //
                            var dict = INFO.knn_token_dictionary;
                            for (var d in dict) {
                                var m = dict[d];
                                INFO.knn_drill_tokens.push([m]);        // KLUDGE: each one is by itself
                            }
                            //knnLoadMarkers(INFO.knn_drill_tokens, INFO.knn_static_tokens);        // TODO: This should come from db
                            knnLoadMarkers(INFO.knn_drill_tokens, {});        // TODO: This should come from db
                            setValidLimbs(INFO.knn_token_dictionary);
                        }
                    }
                    setTLState(INFO.TL_state);
                    setTRState(INFO.TR_state);
                    setBLState(INFO.BL_state);
                    setBRState(INFO.BR_state);
                    setCHState(INFO.CH_state);
                    setCBState(INFO.CB_state);

                    INFO.knn_player_markers = [];
                    INFO.knn_last_marker = 0;
                    INFO.rep_run_cnt = 0;
                }


                setDevMarkerTrace(INFO.knn_debug_mode);
                setDevMarkerReset(INFO.knn_reset_mode);
                setButtonText("STOP AI");      // to force create a virtual session to store log to db

                //if (INFO.dev_ai_running === false) {
                    INFO.dev_video_stopped = true;  // NOTE: ALWAYS first stop the previous non-AI run!!!

                    // if not already recoding, start it
                    //
                    // ...ALSO DONE IN handleAnalyzeWebcam()
                    setTimeout(() =>{
                        INFO.dev_video_stopped = false;     // restart again
                        INFO.dev_record_mode = "ai";          // state for signal callback to remember
                        //initVideoDisplay("output", "dev_action.3923");        
                        console.log("dev_action.2289:     # # # # #  TURN ON DRAW LOOP FOR AI canvas=",canvas, " vid_stopped=",INFO.dev_video_stopped, " now=", Date.now()%100000/1000);
                        drawVideoScreen("ai", "dev.action.4929");      // do not start multiple loops
                    }, 1800);        // slight delay for React to turn on <canvas>
                //}

            } else {
                // stop ai
                //
                setDevAnalyzeRunning(false);      // to force create a virtual session to store log to db
                setDevRunningAI(false);
                INFO.dev_ai_running = false;


                var markers =  INFO.knn_player_markers;
                processKnnData(markers);

                console.log("dev_action.2192:     # # # # #  STOP DEV ANALYZE MODE");
                setButtonText("ENABLE AI");
                INFO.dev_video_stopped = true;
                TIMES.session_stop = Date.now();
                if (INFO.knn_reset_mode === true) {
                    INFO.knn_drill_tokens = [[]];       // NOTE: Load this from db
                    INFO.knn_static_tokens = {};        // NOTE: Load this from db
                    INFO.knn_token_dictionary = [];     // collect this from drill video using frequency analysis
                }

                if(INFO.dev_webcam_mode === true) {
                    resetSession();     // in case of repeat runs
                    handleAnalyzeWebcam();  // start raw webcam again
                }
                // NOTE: NEED TO ADD BETTTER SESSION METADATA FOR DEBUG

            }
            var player = document.getElementById('vimeo_player_container')
            if (player) player.focus();
        }





        // Handle All <Result> Side Bar Icon Selections from video list
        //   - i.action = "train":  run the drill
        //   - i.action = "video": 
        //        - i.type = "session": replay session video
        //        - i.type = "replay": replay existing drills for AI analysis
        //        - i.type = "raw": unprocessed video, the basis for new drills
        //        - i.type = "footage":
        //            - i.subtype = "mock": actual game footage for edit into mock
        //
        // TODO: Have a centralized switch to replace item.action & item.subtype
        // REPLACES: handleRunAnalyze()
        //
        const handleAnalyzeSidebarSelection = async (item) => {
            var url = item.value;
            var vurl = null, xurl = null, path = null, out = null, type;
            GATag("Learn", "ReviewVideo.Show", url, 0);  // (cat, act, lab, val)

            if (item.action === "train") {
                // train model: run player drill with AI to collect motion markers (to setup new drills)
                //    - try to auto collect motion markers
                //
                INFO.auto_run_mode = true;
                INFO.train_model_mode = true;       // KLUDGE: do not record AI overlay, use timer based (not loop)
                INFO.drill = Object.assign({}, item);  // copy object
                INFO.drill_hash = item.hash;
                handleAutoStartDrill("first", "analyze_sidebar.4380");
                return;
            }

            // if another video is running
            if (INFO.dev_video_stopped === false) {
                setAnalyzeStarted(0);
                handleStopAnalyze("interrupt");   // reset previous analyze session
            }

            if (url) var [ video_id, video_start, video_end, vtype ] = decodeVideoHash(url);
            console.log("learn.5173:   # # # # # #  ENTER ANALYZE SIDEBAR SELECT  url=", url, " i.type=",item.type, " v.vtype=",vtype, " i.subtype=",item.subtype, " i.action=",item.action, " video_id=", video_id," item=",item);

            // from <Gif>
            if (DevAnalyzeMode === true) {
                setPlayerType("native");        // AI NEEDS NATIVE PLAYER TO PROCESS
                if (vtype == "vimeo") {
                    type = "v";
                    //vurl = "https://axos.cc/bucket/video/v:"+video_id;
                    vurl = BUCKET_API_SERVER + "/video/v:"+video_id;
                } else {
                    type = "y";
                    //vurl = "https://axos.cc/bucket/video/y:"+video_id;
                    vurl = BUCKET_API_SERVER + "/video/y:"+video_id;
                }
                xurl = await GetBucketVideoLink(type+":"+video_id);
            } else {
                if (vtype == "vimeo") {
                    setPlayerType("vimeo");
                    type = "v";
                    xurl = await makeVideoLink("v:"+video_id, "show_anal_vid.2298");       // review videos are always vimeo
                } else {
                    setPlayerType("youtube");
                    type = "y";
                    xurl = await makeVideoLink("y:"+video_id, "show_anal_vid.2298");       // review videos are always vimeo
                }
            }


            setReviewVideo(xurl);
            INFO.session_name = item.title;

            // INIT ANALYZE STATES!!!
            //
            setVideoWidth(item.width);       // won't be avail until click on videolist!
            setVideoHeight(item.height);
            INFO.video_width = item.width;      // NOTE: CAN NOT RELY ON REACT VAR!!!
            INFO.video_height = item.height;
            setCanvasVideoWidth(item.width);      // NOTE: need to set canvas core to actual video size
            setCanvasVideoHeight(item.height);
            //setHasAllCreateInfo(false);     // to show "create"
            //setShowDevDrillCreate(false);    // developer running test AI

            setShowAnalyzeVideo(false);
            setShowEditMockVideo(false);
            setShowDevDrillCreate(false);
            setDevDrillCreateOpen(false);    // developer running test AI
            setUseDirections(false);
            INFO.footage_mode = false;      // review mock footagein analyze

            switch (item.type) {
                case "footage":     // mock
                    setShowEditMockVideo(true);
                    setUseDirections(false);
                    setHideInstruction(true);
                    setEditMockFootage(item);       //xxcd: use this to start the edit path
                    INFO.footage_mode = true;

                    var [swidth, sheight] = adjustDisplayDiv("edit_mock.4996");
                    setPlayerVideoWidth(swidth);
                    setPlayerVideoHeight(sheight);
                    console.log("learn.5173:       * * * * * HANDLE ANALYZE MOCK EDIT url=", url, " vtype=",vtype," video_id=",video_id,"  vurl=", vurl," xurl=",xurl, " wd=",item.width, " ht=",item.height, "item=", item);
                    break;

                case "session":
                    setShowAnalyzeVideo(true);
                    console.log("learn.5201:       * * * * * HANDLE SESSION REPLAY   url=", url, " vtype=",vtype," video_id=",video_id,"  vurl=", vurl," xurl=",xurl, " wd=",item.width, " ht=",item.height, "item=", item);
                    break;

                case "replay":      // replay drill to get token AI
                case "raw":
                    setShowAnalyzeVideo(true);
                    setShowDevDrillCreate(true);        // allow new drill creation

                    setVideoRecordStart('USE "S"');    // developer running test AI
                    setVideoRecordEnd('USE "E"');    // developer running test AI
                    setHasVideoEnds(false);            // both video end points have been set
                    setPlayerPausedAutoSave(false);    // create drill: auto save video to vimeo once video play stops
                    setAnalyzePlayerPaused(null);      // create drill: auto save video to vimeo once video play stops
                    setPlayerPausedReplay(null);      // create drill: loop video to preview
                    console.log("learn.2154:       * * * * * HANDLE ANALYZE REPLAY VIDEO   url=", url, " vtype=",vtype," video_id=",video_id,"  vurl=", vurl," xurl=",xurl, " wd=",item.width, " ht=",item.height, item);
                    break;
            }

            setAnalyzerRefresh(AnalyzerRefresh+1);
            setAnalyzeStarted(AnalyzeStarted + 1);

            INFO.current_hidx = null;
            INFO.detection_mark = [];       // segment the time to help AI (use SHIFT [1, 2, 3, 4])

            var oitem={}
            oitem.video_hash = type+":"+video_id;
            oitem.name = item.title;
            setVideoItem(oitem);
            setVideoStarted(true);
            setDrillNotes(item.title+" "+video_id);

            if(DevSubKey !== "flm") {
                setShowDevButton(true);      // display only after a video is chosen
            }
        }





        // wrapper: Manually clicked goto catalog
        //
        const handleManualGoCatalog = () => {
            console.log("catalog.5094: =====>  REACHED   *MANUAL*    GO_CATALOG  from_dashbd=", ReturnToDashboard, " CatalogItems=",CatalogItems, " bot_group_id=",INFO.bot_group_id);
            INFO.drill_chain_mode = false;        // Note: manual click means clear the chain_mode
            INFO.dev_analyze_mode = false;

            INFO.bot_slave_mode = false;
            INFO.bot_master_mode = false;
            INFO.drill_chain_abort = true;
            INFO.auto_run_mode = false;          // stop auto run: could be today, chian, slave, direct
            INFO.direct_start_mode = false;      // cancel direct run from url
            INFO.bot_read_from_db = null;        // buffer
            INFO.bot_group_id = null;            // buffer
            INFO.bot_all_users = null;           // buffer
            INFO.bot_all_drills = null;           // buffer
            INFO.bot_last_msg = null;             // last read (may not be processed)
            INFO.bot_processed_msg = null;             // last read (may not be processed)

            INFO.bot_stats = null;                // player stats for this run
            INFO.bot_all_stats = null;            // all other player stats in this class
            INFO.bot_processed_msg = null;        // buffer, last processed
            INFO.bot_setup = null;                // buffer
            INFO.bot_setup_msg_id = null;
            INFO.bot_active_user_idx = null;
            handleGoCatalog();
        }


        // process selected item
        const handleGoCatalog = () => {
            console.log("catalog.2587: ----->  REACHED HANDLE_GO_CATALOG  from_dashbd=", ReturnToDashboard, " CatalogItems=",CatalogItems, " bot_group_id=",INFO.bot_group_id);
            GATag("Learning", "Catalog.Show", INFO.session_name, 0);		 // (cat, act, lab, val)

            initAudio();
            setShowDashboard(false);
            setShowExpand(false);     
            setShowGraph(false);
            setShowBugReport(false);
            setShowPreFlight(false);

            setShowCatalog(true);
            //setTabSelected(0);          // restore instead: TAB start with 0... TODO: Remember last setting by type?

            INFO.max_sidebar = false;
            setExpandIcon(faAngleLeft);
            setShowDrill(false);
            INFO.sidebar_width = CONSTS.SIDEBAR_SMALL_WIDTH;

            if(VideoPlayer !== null) {
                console.log("home.1919: ------- VIDEO PLAYBACK STOPPED");
                //VideoPlayer.stopVideo();
                VideoPlayer.stop();
                setVideoPlayer(null);     // until next set
                //YoutubePlayer.destroy();
            }

            if(INFO.webcam !== null) {
                INFO.webcam.stopCamera();
            }

            //if (INFO.record_running == true) { recordOutput(INFO.analysis_canvas, null, false);        // stop video recording }
            console.log("home.3657:  ! ! ! ! ! !  handleGoCatalog()  auto_completed=",INFO.auto_completed, "webcam=",INFO.webcam, " INFO.webcam_started=",INFO.webcam_started);
            unlockScreenOrientation();

            // Process Interruption
            //    - If a run still active, need to stop it
            //
            if (INFO.auto_completed === false) {
                if (INFO.webcam_started == true) {
                    INFO.interrupted_mode = true;
                    if(INFO.perf_mode === true) {
                        stopChallengeWebcam("interrupt", "handle.catalog.4384");
                        console.log("home.1599: ------- CHALLENGE RUN INTERRUPTED -------- ");
                    } else {
                        stopPracticeWebcam("interrupt", "handle.catalog.4387");
                        console.log("home.1324: ------- PRACTICE RUN INTERRUPTED -------- ");
                    }
                    //INFO.webcam_started = false;        // NOTE: Can we stop it here?
                    setTimeout(()=> {
                        console.log("home.4329:   TURN OFF WEBCAM STARTED...");
                        INFO.webcam_started = false;    // need delay so video canvas sticks around for the db write
                    }, 800)

                }
                if (ShowGame == true) {
                    INFO.interrupted_mode = true;
                    handleStopGame("interrupt");
                    console.log("home.582: ------- GAME RUN INTERRUPTED -------- ");
                }
                if (ShowMock == true) {
                    INFO.interrupted_mode = true;
                    handleStopMock("interrupt");
                    //setMockStarted(false);
                    console.log("home.2014: ------- MOCK RUN INTERRUPTED -------- ");
                }
                if (ShowAnalyze == true) {
                    INFO.interrupted_mode = true;
                    handleStopAnalyze("interrupt");
                    //setMockStarted(false);
                    console.log("home.2994: ------- ANALYZE RUN INTERRUPTED -------- ");
                }
            }


            // Note: Need to have a standard process for init/reset vars
            //INFO.drill_chain_mode = false;        // Note: Can not clear it here!  Auto-run goes thru here too
            setDevAnalyzeMode(false);
            setReviewVideo(null);
            setVideoItem({});
            setVideoStarted(false);
            //setVideosList([]);
            //setLinks([]);

            // reset all modes
            //
            INFO.practice_mode = false;
            INFO.game_mode = false;
            INFO.mock_mode = false;
            INFO.perf_mode = false;
            INFO.analyze_mode = false;
            INFO.record_running = false;
            INFO.perf_running = false;
            INFO.interrupted_mode = false;
            INFO.session_completed = false;
            setShowDrill(false);
            setShowGame(false);
            setShowMock(false);
            setShowPerf(false);
            setShowAnalyze(false);

            // if reached drill from dashboard (via leaderboard) then go back to dashbd
            //
            if (ReturnToDashboard === true) {
                GATag("Learn", "Dashboard.Return", INFO.session_name, 0);  // (cat, act, lab, val)
                setReturnToDashboard(false);
                setShowDashboard(true);
                setShowCatalog(false);
                return;
            }

        }


        // return to menu
        const handleGoBack = () => {
            console.log("learn.995: ----->  REACHED HANDLE_GO_BACK");
            setShowExpand(false);     

            //setLearnRedirect(true);
            //setLearnTarget("/menu")
            setShowCatalog(false);
            setShowDashboard(true);
            setShowBotSlave(false);
        }






    // *********************************** MISC HANDLER ROUTINES  ***********************************
    //

    const handleShowBug = event => {
        console.log("learn.1003:  SHOW BUG_REPORT event=",event);
        INFO.bug_report = "";
        if(ShowBugReport == false) {
            setShowBugReport(true);
        }
    }

    const handleDismissBug = event => {
        console.log("learn.396:  DISMISS BUG_REPORT event=",event);
        INFO.bug_report = "";
        if(ShowBugReport == true) {
            setShowBugReport(false);
        }
    }

    const handleSubmitBug = (text) => {
        var out = {}, out1 = {}, outputs = [];
        console.log("learn.2275:  HANDLE BUG SUBMIT text=", text);
        INFO.bug_report = text;

        // STORE USER FEEDBACK IN DB
        if(ShowBugReport == true) {
            GATag("Learn", "Bug.Submit", INFO.session_name, 0);  // (cat, act, lab, val)
            setShowBugReport(false);
            GATag("Learning", "Send.Bug", INFO.session_name, 0);		 // (cat, act, lab, val)
            stopPracticeWebcam("debug", "handle.submit.bug.4495");

            out1.title = "SUBMIT BUG:";
            out1.value = INFO.bug_report;
            out = {...out1};
            //outputs.push(out);

            console.log("train.263:  update BUG REPORT SUMMARY ",outputs);
            //setSummary(outputs);
            setReport(out);
            setShowWait(true);
            setShowWaitSpinner(true);
            INFO.webcam_started = false;
            setRefresh(Date.now());

            CreateVirtualSession(INFO.email, INFO.uid, "bug");        // write it out
        }
    }

    const handleShowTutorial = () => {
        
        GATag("Learn", "Tutorial.Show", INFO.tut_op, 0);  // (cat, act, lab, val)
        INFO.tut_op = "start";      // KLUDGE: FORCE THE START MSG
        var show = getTutorial(INFO.tut_module, INFO.tut_op, "manual");     // force display

        console.log("train.5232: ----->  REACHED HANDLE_SHOW_TUTORIAL  module=",INFO.tut_module, " op=",INFO.tut_op, " show=",show);
        if(show !== null) {
            setShowTut(show);
            setShowTutorial(true);
        }
    }


    const handleDismissTutorial = () => {
        GATag("Learn", "Tutorial.Stop", INFO.tut_op, 0);  // (cat, act, lab, val)
        console.log("train.5242: ----->  REACHED HANDLE_DISMISS_TUTORIAL");
        setShowTutorial(false);
    }

    const handleDismissCountdown = () => {
        GATag("Learn", "Countdown.hide", INFO.tut_op, 0);  // (cat, act, lab, val)
        console.log("train.3358: ----->  REACHED HANDLE_DISMISS_COUNTDOWN");
        setShowCountdown(false);
        INFO.countdown_time = null;
    }



    const handleDismissGraph = () => {
        console.log("train.633: ----->  REACHED HANDLE_DISMISS_GRAPH");
        setShowGraph(false);
        //setHistory([]);              // clear graph
        //setFields(null);         
    }


    // EVENT: overloading <Wait> to show System Warning Message
    //     - triggered by disptach.event("show_warning")
    //
    const handleShowWarning = event => {
        GATag("Learn", "Game.Warning", INFO.warning_message, 0);  // (cat, act, lab, val)
        console.log("train.490:  SHOW WARNING event=",event);
        setWarning(INFO.warning_message)
        INFO.bug_report = "";
        if(ShowWait == false) {
            if (INFO.drill_chain_mode === false) {
                setShowWait(true);      // do not show dialog if in auto chain mode
            }
        }
    }


// ***********************************  MAJOR HANDLER ROUTINES  ***********************************
//
const handleRunChallengeWebcam = (mode) => {
        var start = false;
        if(!mode) {
            start = !INFO.webcam_started
        } else {
            start = (mode === "start") ? true : false;
        }


        //console.log("run_webcam.4252:    RUN WEBCAM ENTERED!      INFO.webcam_started=",INFO.webcam_started," chain_mode=",INFO.drill_chain_mode);
        //if (INFO.webcam_started == false) {
        if (start === true) {
            GATag("Learn", "Challenge.Start", INFO.session_name, 0);  // (cat, act, lab, val)
            INFO.countdown_time = null;
            setCountdownTime(null);     // clear the timer
            setCountdownMsg(null)
            playAudio(CONSTS.START_RUN_PATH, "run_perf_cam.2875");

            TIMES.webcam_start = Date.now();
            INFO.webcam_started = true;         // blocking flag
            //INFO.disable_calibration = false;    // never disable for perf
            setDoStartChallengeWebcam(Date.now())   // Note: Use date to ensure wake up
            console.log("perf_cam.4263:  ******* PERF RUN START DETECTED @REACT ******** ", INFO.drill_tot_rep_cnt, " ShowPerf=",ShowPerf);
            //if ((INFO.bot_slave_mode === false) && (!INFO.auto_run_mode)) {
            //if ((INFO.catalog_type !== "today") && (INFO.bot_slave_mode === false)) {
            if ((INFO.catalog_type !== "today") && (INFO.bot_slave_mode === false) && (!INFO.auto_run_mode)) {
                INFO.disable_calibration = false;
                handleExpand("run_challenge.3582");  // do not expand right away in chain auto mode, wait for "raise hand"
            }
            if (INFO.drill_chain_mode === true) {
                INFO.disable_calibration = true;
                setHandsFree(true);
            }
        } else {

            GATag("Learn", "Challenge.Stop", "", 0);  // (cat, act, lab, val)
            stopChallengeWebcam("save", "handle.perf.cam.2925");        // normal exit
            console.log("perf_cam.4267: ------- PERF RUN COMPLETED @REACT -------- ", INFO.rep_run_cnt);
            updateDrillHistory(SelectedItem.hash, SelectedItem.name, SelectedItem.goals);
            if (INFO.bot_slave_mode === true) {
                setShowBotSlave(true);
            }
        }
        setRefresh(Date.now());
    }


    const handleRunPracticeWebcam = (mode) => {
        var start = false;
        if(!mode) {
            start = !INFO.webcam_started
        } else {
            start = (mode === "start") ? true : false;
        }

        //console.log("train.245:  RUN PRACTICE ENTERED!  ", INFO.session_name, "  webcam=",INFO.webcam_started,"  intrp=",INFO.interrupted_mode);
        if (start == true) {
            GATag("Learning", "Practice.Start", INFO.session_name, 0);		 // (cat, act, lab, val)
            INFO.countdown_time = null;
            setCountdownTime(null);     // clear the timer
            setCountdownMsg(null)
            playAudio(CONSTS.START_RUN_PATH, "run_practice_cam.2696");

            TIMES.webcam_start = Date.now();
            setEnableWebcam(true);
            setDoStartPracticeWebcam(Date.now());        // Note: random each time to ensure action
            console.log("drill_cam.2853:  ******* PRACTICE RUN START DETECTED @REACT ******** ", INFO.drill_tot_rep_cnt, " cat_type=",INFO.catalog_type, " chain=",INFO.drill_chain_mode, " drill1=",INFO.auto_run_mode);
            //if ((INFO.bot_slave_mode === false) && (!INFO.auto_run_mode)) {
            if ((INFO.catalog_type !== "today") && (INFO.bot_slave_mode === false) && (!INFO.auto_run_mode)) {
                INFO.disable_calibration = false;
                handleExpand("run_practice.3460");  // do not expand right away in chain auto mode, wait for "raise hand"
            }

            if (INFO.drill_chain_mode === true) {
                console.log("drill_cam.2911:         ! ! ! !  DISABLE CALIB UNTIL EXPANDED");
                INFO.disable_calibration = true;
                setHandsFree(true);
            }
        } else {

            GATag("Learning", "Practice.Stop", INFO.session_name, 0);		 // (cat, act, lab, val)
            stopPracticeWebcam("save", "handle.run.pract.cam.2744");
            console.log("drill_cam.2862: ------- PRACTICE RUN COMPLETED @REACT -------- ", INFO.rep_run_cnt);
            updateDrillHistory(SelectedItem.hash, SelectedItem.name, SelectedItem.goals);
            if (INFO.bot_slave_mode === true) {
                setShowBotSlave(true);
            }
            //handleExpand();
        }
        //setRefresh(Date.now());   cause loop?
    }



    function handleRunGame(mode) {
        var start = false;
        if(!mode) {
            start = !GameStarted;
        } else {
            start = (mode === "start") ? true : false;
        }

        //if (GameStarted == false) {
        if (start == true) {
            INFO.sidebar_width = 0;     // rungame in full screen
            INFO.sidebar_height = 0;     // rungame in full screen
            INFO.summary_created = false;





            // TODO: merget to output
            //
            if(false || (INFO.record_output == true)) {
                setTimeout(async () => {
                    INFO.record_output = true;
                    //INFO.output_canvas = "drill_output";
                    //initVideoDisplay("drill_output", "record_game.5434");        // draw to output canvas
                    initVideoDisplay("output", "record_game.5434");        // draw to output canvas
                    copyDivScreen("original", "game.create.5435");      // do not start multiple loops
                    recordOutput(INFO.out_canvas, "game_intro", true); // start recording when session starts
                },  1000);
            }





            var [swidth, sheight] = adjustDisplayDiv("rungame.3406");
            setPlayerVideoWidth(swidth);
            setPlayerVideoHeight(sheight);
            INFO.drill_running = true;

            console.log("train.750:  RUN GAME ISSUED!  ", INFO.session_name, "  GameStarted=",GameStarted, " width=",swidth, " height=",sheight);
            GATag("Learning", "Game.Start", INFO.session_name, 0);		 // (cat, act, lab, val)
            setGameStarted(true);
        } else {
            console.log("train.760:  RUN GAME STOPPPED!  ", INFO.session_name, "  GameStarted=",GameStarted);
            INFO.sidebar_width = CONSTS.SIDEBAR_SMALL_WIDTH;
            INFO.sidebar_height = CONSTS.SIDEBAR_HEIGHT;     // rungame in full screen
            GATag("Learning", "Game.Stop", INFO.session_name, 0);		 // (cat, act, lab, val)
            setGameStarted(false);
            updateDrillHistory(SelectedItem.hash, SelectedItem.name, SelectedItem.goals);
        }
    }


    function handleRunMock(mode) {
        var start = false;
        if(!mode) {
            start = !GameStarted;
        } else {
            start = (mode === "start") ? true : false;
        }

        //if (MockStarted === 0) {
        if (start == true) {
            INFO.sidebar_width = 0;     // rungame in full screen
            INFO.sidebar_height = 0;     // rungame in full screen
            INFO.summary_created = false;

            var [swidth, sheight] = adjustDisplayDiv("runmock.3430");
            setPlayerVideoWidth(swidth);
            setPlayerVideoHeight(sheight);
            INFO.drill_running = true;

            console.log("train.2184:  RUN SIMULATION ISSUED!  ", INFO.session_name, "  MockStarted=",MockStarted, " width=",swidth, " height=",sheight);
            GATag("Learning", "Mock.Start", INFO.session_name, 0);		 // (cat, act, lab, val)
            //setMockStarted(true);
            setMockStarted(MockStarted + 1);
        } else {
            console.log("train.3820:  RUN SIMULATION STOPPPED!  ", INFO.session_name, "  MockStarted=",MockStarted);
            INFO.sidebar_width = CONSTS.SIDEBAR_SMALL_WIDTH;
            INFO.sidebar_height = CONSTS.SIDEBAR_HEIGHT;     // rungame in full screen
            GATag("Learning", "Mock.Stop", INFO.session_name, 0);		 // (cat, act, lab, val)
            //setMockStarted(false);
            setMockStarted(0);
            updateDrillHistory(SelectedItem.hash, SelectedItem.name, SelectedItem.goals);
        }
    }










        // live AI analysis mode
        //
        // src: startChallengeWebcam()
        //
        const handleAnalyzeWebcam = async () => {
            GATag("Learn", "AnalyzeWebcam.Show", "", 0);  // (cat, act, lab, val)

            console.log("runv.3166:  # # # # # # START ANALYZE WEBCAM  webcam=",INFO.webcam, " dev_ai_run=",INFO.dev_ai_running, " dev_recording=",INFO.dev_recording, " vid_stopped=",INFO.dev_video_stopped);
            setVideoStarted(true);      // KLUDGE, this hides the tutorial, should use INFO.webcam_started?
            setDevAnalyzeRunning(false);
            //setDevRunningAI(false);
            //INFO.dev_ai_running = false;
            //INFO.dev_recording = false;

            //setShowAnalyzeWebcam(true);
            //setShowAnalyzeVideo(false);
            //setAnalyzeStarted(AnalyzeStarted + 1);
            //INFO.has_calibration = false;
            //INFO.pose_top = null;
            //INFO.pose_bot = null;
            //INFO.rep_run_cnt = 0;
            //INFO.summary_created = false;
            //var video_container = document.getElementById('video_container');
            //video_container.style.display = "flex";
            //var analysis_container = document.getElementById('results_container');
            //analysis_container.style.display = "flex";

            INFO.interrupted_mode = false;    //setState("interrupted", false);   NOT THIS!  SMOKING GUN!
            TIMES.webcam_start = Date.now();

            INFO.webcam_started = true;
            setButtonText("STOP AI"); 
            resetSession();     // in case of repeat runs
            //setState('session_stopped', false);       // THIS CAUSED MODULE TO FAIL?!?!
            INFO.session_name = SessionName;

            //initWebcamAI(guiState.net, true);     // anlyze need its own version!
			if(INFO.webcam == null) {
				var cameraParams = {targetFPS: 60, sizeOption: '640 X 480'};
				INFO.webcam = await CameraClass.setupCamera(cameraParams);		// returns a new obj

                var output = document.getElementById('output');        // vimeo video output
                var width = (parseInt(output.style.width.toString().replace("px","")));
                var height = (parseInt(output.style.height.toString().replace("px","")));
                setCanvasVideoWidth(width);      // <canvas id="output" > element
                setCanvasVideoHeight(height);
                console.log("runv.3172:   + + + + ANALYZE WEBCAM CREATED   webcam=",INFO.webcam, " wd=",width, " ht=",height);
			}

            setTimeout(() =>{
                INFO.dev_video_stopped = false;
                INFO.dev_record_mode = "original";
                initVideoDisplay("vcanvas", "anal_webcam.4014");        // draw to output canvas

                console.log("learn.189:     # # # # #  START SHOWING RAW WEBCAM");
                drawVideoScreen("original", "analyze.webcam.5020");      // do not start multiple loops

            }, 100);        // slight delay for React to turn on <canvas>


            setRefresh(Date.now());
            setAnalyzerRefresh(AnalyzerRefresh+1);
            console.log("runv.3144:  ANALYZE WEBCAM START ISSUED   perf=",INFO.perf_mode, SelectedItem);
        }


        // show the cone target in a <Div> immediately (instead of render in canvas) to reduce visual latency
        //     - for ShowPerf
        //
        function handleShowDivTargetCone() {
                //var scheme = {x: "left", y: "b50", move: "static", duration: Infinity};
                //var yy = INFO.cone_target_y + 50;
                var xx = INFO.cone_target_x;
                var yy = INFO.cone_target_y;

                console.log("div.585:        PROCESS <DIV> TARGET DISPLAY...  xx=", xx, " yy=",yy, " target_idx=",INFO.target_idx, "  game_target=",INFO.game_target.length);
                if ((xx !== 0) && (INFO.target_idx !== null)) {
                    // display new <div> target cone for immediate player notification
                    //
                    //var video = document.querySelector('#vcanvas');
                    var video = document.getElementById(INFO.analysis_canvas);
                    var vww = video.width;
                    var vhh = video.height;
                    //var output = document.querySelector('#output');
                    var output = document.querySelector('#video_container');
                    //var ww = output.offsetWidth;
                    //var hh = output.offsetHeight;
                    var ww = Math.floor(output.clientWidth);
                    var hh = Math.floor(output.clientHeight);
                    var scalex = Math.floor(ww / vww);
                    var scaley = Math.floor(hh / vhh);

                    var iww = INFO.image_width;
                    var ihh = INFO.image_height;
                    var canvas = INFO.out_canvas;
                    var cww = canvas.width;
                    var chh = canvas.height;
                    console.log("div.638:        SCREENS:   vww=",vww," vhh=",vhh, " iww=",iww, "  ihh=",ihh, "  cww=",cww, "  chh=",chh, " ww=",ww, " hh=",hh);

                    const X_OFFSET = 0;  // -10
                    const Y_OFFSET = 0; // 0
                    var twd =  Math.floor(INFO.scale_factor * 50);
                    var tht = Math.floor(INFO.scale_factor * 50);
                    xx = Math.floor(((xx + X_OFFSET) * scalex)-(twd/2));
                    yy = Math.floor(((yy + Y_OFFSET) * scaley)-(tht/2)+(40/ scaley));
                    console.log("div.644:        TARGET:   o.x=",INFO.cone_target_x, "  o.y=",INFO.cone_target_y, "  xx=",xx, "  yy=",yy, " scalex=",scalex, "  scaley=",scaley);

                    INFO.game_screen = {x: ww, y: hh};
                    var color = "rgba(0,255,0, 0.3)";		// target is always green
                    //var scheme = {x: xx, y: yy, move: "static", duration: 7000};
                    var scheme = {x: xx, y: yy, move: "static", duration: Infinity};

                    var target_element = document.getElementById('target');
                    target_element.style.width = twd+"px";
                    target_element.style.height = tht+"px";
                    var target = new TargetClass(target_element);

                    console.log("div.540:        SHOW <DIV> TARGET... x=",xx, " y=",yy,"  scrn.w=",ww, " scrn.h=",hh, " t.wd=",twd, " t.ht=",tht);
                    target.color = color;
                    target.create(scheme, INFO.game_screen);
                    target.start();
                    INFO.game_target.push(target);
                } else {
                    // remove new <div> target cone
                    //
                    console.log("challenge.564:      CLEAN UP <DIV> TARGET...  game_target.len=", INFO.game_target.length);
                    for(var i = 0; i < INFO.game_target.length; i++ ) {
                        INFO.game_target[i].stop();   // remove previous target objects;
                        INFO.game_target[i].destroy();   // remove previous target objects;
                    }
                    INFO.game_target = [];
                }

        }

        // ABOVE FROM WEBCAM ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




    // EVENT: auto stop initiated form lower level, keep UI in sync
    //
    function handleStopEvent() {
            GATag("Learning", "Webcam.Auto_Stop", INFO.session_name, 0);		 // (cat, act, lab, val)

            if (INFO.practice_mode === true) stopPracticeWebcam("auto", "handle.stop.event.4621");    // needed this
            if (INFO.perf_mode === true) stopChallengeWebcam("auto", "handle.stop.event.4622");    // needed this

            console.log("home.860: ------- RUN AUTO COMPLETED @REACT -------- ", INFO.rep_run_cnt, " practice=",INFO.practice_mode, " perf=",INFO.perf_mode);
            updateDrillHistory(SelectedItem.hash, SelectedItem.name, SelectedItem.goals);
    }


    // called up from <Mode>
    const handleRecording = event =>  {
        var mode = event.target.checked;
        //console.log("train_record.442:  RECORD_MODE = ", mode);
        setRecording(mode);
    }





    // *********************************** PRESENTATION MANAGEMENT ROUTINES  ***********************************
    //


    // expand practice webcam window in sidebar
    //
    const handleExpand = (from) => {
        console.log("expand.4180:    # # # # RUN EXPAND:   from=",from,"  MAX_SIDEBAR =", INFO.max_sidebar, "  width=",INFO.sidebar_width);
        if(INFO.max_sidebar === true) {
            INFO.max_sidebar = false;
            setExpandIcon(faAngleLeft);
            INFO.sidebar_width = CONSTS.SIDEBAR_SMALL_WIDTH;
            console.log("expand.895:       . . .  CONTRACT SIDEBAR WIDTH=", INFO.sidebar_width, " from=",from);
            //setNoticeSmall(false);
        } else {
            INFO.max_sidebar = true;
            setShowRaiseHand(false);
            setExpandIcon(faAngleRight);
            //setNoticeSmall(true);
            //var display_width = document.getElementById("display_container").offsetWidth;
            var display_width = window.innerWidth;
            INFO.sidebar_width = Math.floor(display_width * CONSTS.SIDEBAR_BIG_RATIO);
            INFO.disable_calibration = false;    // see the full screen, ready to go
            console.log("expand.756:       . . . EXPANDED SIDEBAR WIDTH=", INFO.sidebar_width, "  display=",display_width, " from=",from);
        }

        var [swidth, sheight] = adjustDisplayDiv("expand.4194");
        setPlayerVideoWidth(swidth);
        setPlayerVideoHeight(sheight);
        setRefresh(Date.now());
    }

    const handleShowGraph = event =>  {
        GATag("Learn", "Graph.Show", "", 0);		 // (cat, act, lab, val)
        var mode = event.target.checked;
        if(ShowGraph == true) {
            setShowGraph(false);
        } else {
            GATag("Learn", "History.Show", INFO.session_name, 0);  // (cat, act, lab, val)
            setShowGraph(true);
        }
    }

    const handleRunSlowMo = event =>  {
        GATag("Learn", "Video.SlowMo", "", 0);		 // (cat, act, lab, val)
        var mode = event.target.checked;
        //console.log("train_slowmo.420:  SLOW_MO = ", mode);
        setSlowMo(mode);
        var speed = (mode == true) ? 0.5 : 1.0;
        setPlayerSpeed(INFO.learn_player, speed);

        var iframe = document.querySelector("iframe");
        INFO.video_owidth = iframe.offsetWidth;		// this does not change
        INFO.video_oheight = iframe.offsetHeight;
        console.log("run_slowmo.900:       SET VIDEO FILE DIM  wd=", INFO.video_owidth, " ht=", INFO.video_oheight);
    }


    const renderRedirect = () => {
        if (LearnRedirect == true) {
            //GATag("onboard", "non-auth", "redirect", State.target_path);  // (cat, act, lab, val)
            console.log("#################### menu.renderRedirect:  ", LearnTarget);
            return <Redirect to={LearnTarget} />
        }
    }

    const handleDismissInvite = () => {
        console.log("#################### Toggle Dismiss Invite ");
        setShowSendInvite(false);
    }

    const handleGetInviteToken = (token) => {
        console.log("#################### Learn: Got Invite Token: ", token);
        // Get token
    }

    const handleShowAdminDialog = () => {
        console.log("#################### Show Admin Dialog   players=",INFO.db_players);
        setShowAdminDialog(true);
        setRefresh(Date.now());
    }

    const handleDismissSwitchUser = user => {
        setShowAdminDialog(false);
    }

    const handleDismissSlave = () => {
        setShowBotSlave(false);
    }


    const handleShowInvite = () => {
        GATag("Learn", "Invite.Show", "", 0);  // (cat, act, lab, val)
        console.log("#################### Show Send Invite ");
        setShowSendInvite(true);
    }







    const handleSwitchUser = user => {
        GATag("Learn", "Admin.SwitchUser", user.key, 0);		 // (cat, act, lab, val)
        console.log("learn.2049: ------------>  SWITCHING TO user=", user, "  <----------------");
        setShowAdminDialog(false);

        AdminSwitchUser(user);      // GOD-ONLY: assume chosen user identity
        loadUserState(INFO.uid, null)            // read init data from database
        .then(()=>{
            setRefresh(Date.now());
            setDashReload(DashReload + 1);
            console.log("learn.2058:      ........RELOAD DASH");
            setLearnRedirect(true);
            setLearnTarget("/menu");
        })
    }


    // shared by both Vimeo & Youtube
    // NOTE: In order to use <VideoFrame>, we need this call back so we can load the player AFTER iframe is rendered
    //
    const handleVideoRendered = (event) => {
        // install vimeo player here, after it is rendered with URL
        //var iframe = document.querySelector("iframe");
        //console.log("#################### Handle Got VideoFrame Rendered ", iframe);
        //var player = event.target;
        //player.playVideo();     // vimeo

        var player = event;
        INFO.learn_player = player;         // for control from <Result>
        if(player) {
            console.log("learn.2515:       ++++++++++++++++++++ Handle <Learn> Video IFRAME READY   playerType=", PlayerType, " width=", VideoWidth, " height=",VideoHeight);   //, " url=",player.getPlayerURL());  " playerState=", player, 
            var timer0 = setTimeout(async () => {
                    player.mute();
                    player.start();     // vimeo: was play()
                },  CONSTS.MOCK_PRESTART_DELAY);
            setRampStartTimer(timer0);

            /* do we?
            var [swidth, sheight] = adjustDisplayDiv("video_rended.3855");
            setPlayerVideoWidth(swidth);
            setPlayerVideoHeight(sheight);
            */

            setVideoFrameReady(Date.now());
            setVideoPlayer(player);   // if playing, remember plyaer so we can cleanup
        }
    }


    // player ready notified by lower level
    //
    const handleAnalyzeVideoRendered = (event) => {
        var player = event;
        setPlayerPausedAutoSave(false);     // initialize

        INFO.learn_player = player;         // for control from <Result>
        if(player) {
            console.log("learn.2988:       +++++++++++++++++++++ Handle <ANALYZE> Video IFRAME READY    playerState=", player, " playerType=", PlayerType, " width=", VideoWidth, " height=",VideoHeight, " url=",player.getPlayerURL());
            var timer0 = setTimeout(async () => {
                    player.mute();
                    player.start();     // vimeo: was play()
                },  CONSTS.MOCK_PRESTART_DELAY);
            setRampStartTimer(timer0);

            var output = document.getElementById('drill_output');   // <video id="drill_output"> element
            //output.setAttribute("width", INFO.video_width+"px");      // NOTE: CAN NOT RELY ON REACT VAR!!!
            //output.setAttribute("height", INFO.video_height+"px");
            output.setAttribute("width", INFO.video_width);      // do not add "px"
            output.setAttribute("height", INFO.video_height);
            setCanvasVideoWidth(INFO.video_width);      // <canvas id="output" > element
            setCanvasVideoHeight(INFO.video_height);

            var [swidth, sheight] = adjustDisplayDiv("anal_vid_render.3888");
            setPlayerVideoWidth(swidth);    // NOTE: this set the presentation size
            setPlayerVideoHeight(sheight);
            console.log("learn.3002:                   AFTER ADJUST   swidth=",swidth, "  sheight=",sheight, " VideoWidth=",INFO.video_width, " VideoHeight=",INFO.video_height);

            setVideoFrameReady(Date.now());
            setVideoPlayer(player);   // if playing, remember plyaer so we can cleanup

        }
    }

    // track analyzer video player state change
    //     - detect if player paused, could be auto-stop for recording
    //
    const handleAnalyzeVideoStateChange = (event) => {
        //var player = event.target;
        var player = INFO.learn_player;
        var state = player.getPlayerState();
        var paused = player.getPaused();
        var time = player.getTime();
        //console.log("learn.3168:      .  .  .  .  .  ANALYZER PLAYER STATE CHANGE:   ",state, "  playerType=",PlayerType);
        //if (state == "have_enough_data") {
        if (paused === true) {
            console.log("learn.3170:      .  .  .   NATIVE PLAYER PAUSED   @time=",time, "  autosave=", PlayerPausedAutoSave);
            setAnalyzePlayerPaused(true);
            setAnalyzerRefresh(AnalyzerRefresh+1);
        }
    }



    // track video player state change
    //
    const handleVideoStateChange = (event) => {
        //var player = event.target;
        var player = INFO.learn_player;
        var state = player.getPlayerState();
        //console.log("learn.2529:      .  .  .  .  .  PLAYER STATE CHANGE:   ",state, "  youtube=",INFO.youtube_player, " playerType=",PlayerType);
        if (state === "playing") {
            //console.log("learn.2532:      .  .  .   PLAYER IS PLAYING   youtube=",INFO.youtube_player);
            setVideoPlayer(player);   // if playing, remember plyaer so we can cleanup
        }
    }


    // <Learn> wrapper - call from lower level
    const handleSetLearnPlayerTime = (pct, move) => {

        //console.log("learn.2536:      SET LEARN TIME   pct=",pct, " move=",move);       //, " ", INFO.learn_player);
        if(INFO.learn_player !== null) {
            setPlayerTime(INFO.learn_player, pct, move);
        }
    }



    // EVENT: hot keys processing
    //    - <space>:  stop and start video
    //    - t:  target of this pass (start, target)
    //    - p:  all available passing targets (start, target1, target2, ...)
    //    - m:  comment reaction time  (start, a-time, b-time, ....)
    //    - c:  clear current entry
    //    - s:  save current entry to db
    //    - a:  audio on/off
    //
    // NOTE: <ctrl>[1, 2, 3] are trapped by Browser to switch tabs
    // 
    const handleKeyDown = async (event) => {
        var player = INFO.learn_player;
        var keycode = event.code;
        var shift = event.shiftKey;
        var ctrl = event.ctrlKey;
        var alt = event.altKey;
        //event.preventDefault();     // block new ones to prevent overflow

        if (!player) return;
        //console.log("learn.2940:          KEY DOWN:  ", keycode, " shift=",event.shiftKey, " ctrl=",event.ctrlKey, " player=",player.type);


        switch(keycode) {
            case "Space":
                handlePlayerPlay();
                setPlayerPausedReplay(false);   // no more auto looping
                setAnalyzerRefresh(AnalyzerRefresh+1);
                break;

            case "ArrowLeft":
                var steps = findSkipSteps(shift, ctrl, alt);
                player.singleStep(-steps);
                //processPlayerSkip(-steps, ctrl, alt);
                //checkDetectBoundary();
                //console.log("mock.500:          BACK STEP VIDEO  steps=",steps, " shift=",shift, " ctrl=",ctrl, " alt=",alt);     // player=",player);
                break;
            case "ArrowRight":
                var steps = findSkipSteps(shift, ctrl, alt);
                player.singleStep(steps);
                //processPlayerSkip(steps, ctrl, alt);
                //checkDetectBoundary();
                //console.log("mock.512:          FORWARD STEP VIDEO  steps=",steps, " shift=",shift, " ctrl=",ctrl, " alt=",alt);     // player=",player);
                break;

            case "KeyS":
                // start and stop making drill
                if (shift === true){
                    var start0 = INFO.learn_player.getTime();
                    var start = Math.floor(start0 * 1000) / 1000;
                    console.log("replay.3126:          START RECORD TIME  start=",start, " end=",VideoRecordEnd);
                    setVideoRecordStart(start);

                    //INFO.making_drill = state;
                    //setMakingDrillStart(state);
                }
                break;
            case "KeyE":
                // start and stop making drill
                if (shift === true){
                    var end0 = INFO.learn_player.getTime();
                    var end = Math.floor(end0 * 1000) / 1000;
                    console.log("replay.3159:          STOP RECORD TIME  start=",VideoRecordStart, " end=",end);
                    setVideoRecordEnd(end);
                }
                break;

            case "KeyA":
                player.mute();
                break;

            case "Digit0":
                if (alt === true){ player.setSpeed(0.5); }
                break;
            case "Digit1":
                if (alt === true){ player.setSpeed(1); }
                if (shift === true) {
                    INFO.detection_mark[0] = INFO.current_hidx;
                    console.log("replay.3759:          SET AI TIME MARKER  1 =",INFO.current_hidx);
                }
                break;
            case "Digit2":
                if (alt === true){ player.setSpeed(2); }
                if (shift === true) {
                    INFO.detection_mark[1] = INFO.current_hidx;
                    console.log("replay.3759:          SET AI TIME MARKER  2 =",INFO.current_hidx);
                }
                break;
            case "Digit3":
                if (alt === true){ player.setSpeed(2); }
                if (shift === true) {
                    INFO.detection_mark[2] = INFO.current_hidx;
                    console.log("replay.3759:          SET AI TIME MARKER  3 =",INFO.current_hidx);
                }
                break;
            case "Digit4":
                if (shift === true) {
                    INFO.detection_mark[3] = INFO.current_hidx;
                    console.log("replay.3759:          SET AI TIME MARKER  4 =",INFO.current_hidx);
                }
                break;
        }
    }


    const handlePlayerPlay = async (event) => {
        var player = INFO.learn_player;
        //var paused = await player.getPaused();
        var paused = player.paused;  // do we really need this?  takes awhile
        if (paused == true) {
            console.log("mock.515:          KEY START VIDEO  ");    //player=",player);
            player.start();
        } else {
            console.log("mock.518:          KEY PUASE VIDEO  ");    //player=",player);
            player.pause();
        }
    }


    // UI controlled dynamic mode
    //
    const handleKnnMode = (mode) => (event) => {
        var val = null;
        switch (mode) {
            case "debug":
                if (DevMarkerTrace === true) {
                    val = false;
                } else {
                    val = true;
                }

                setDevMarkerTrace(val);
                INFO.knn_debug_mode = val;
                break;

            case "reset":
                if (DevMarkerReset === true) {
                    val = false;
                } else {
                    val = true;
                }

                setDevMarkerReset(val);
                INFO.knn_reset_mode = val;
                break;
        }
        console.log("knn.3801:       KNN   debug=",INFO.knn_debug_mode, " reset=",INFO.knn_reset_mode);    //player=",player);
    }



    const handleLimbSelect = (limb) => (event) => {
        var input = limb+"_state";
        var value = (INFO[input] === true) ? false : true;

        INFO[input] = value;
        switch(limb) {
            case "TL":
                setTLState(value);
                break;
            case "TR":
                setTRState(value);
                break;
            case "BL":
                setBLState(value);
                break;
            case "BR":
                setBRState(value);
                break;
            case "CH":
                setCHState(value);
                break;
            case "CB":
                setCBState(value);
                break;
        }

        //setRefresh(Date.now());
        console.log("dev.3492:  # # # # # # # #  SELECT LIMB  ", limb, "  input=", input, "  output=",INFO[input]);
    }



    // DEV MODE: START NEW DRILL ACTION: "loop" or "create"
    //    - seek to start time
    //    - turn on mediaRecorder
    //    - stop recording at end time
    //    - create Drill record
    //
    //  NOTE: MUST INIT ADDED VARS IN handleShowAnalyzeVideo()!!!
    //
    const handleDevCreateAction = (mode) => (event) => {
        var player = INFO.learn_player;
        switch (mode){
            case "loop":
                document.getElementById('drill_output').focus();
                if ((PlayerPausedReplay === false) || (PlayerPausedReplay === null)) {
                    console.log("dev.3358:  # # # # # # # #  LOOP NEW DRILL");
                    player.setTime(VideoRecordStart);
                    player.setStop(VideoRecordEnd);
                    player.start();
                    setAnalyzePlayerPaused(false);
                    setPlayerPausedReplay(true);  // keep replaying
                    setAnalyzerRefresh(AnalyzerRefresh+1);
                } else {
                    console.log("dev.3384:  # # # # # # # #  STOP DRILL LOOP");
                    player.pause();
                    //setAnalyzePlayerPaused(false);
                    setAnalyzePlayerPaused(true);
                    setPlayerPausedReplay(false);  // stop looping
                    setAnalyzerRefresh(AnalyzerRefresh+1);
                }

                break;
            case "create":
                console.log("dev.3311:  # # # # # # # #  CREATE NEW DRILL =",DevDrillCreateOpen);
                console.log("dev.3315:                . . . . Forward to " ,VideoRecordStart);
                INFO.dev_analyze_mode = true;
                INFO.dev_video_stopped = false;
                INFO.dev_recording = true;
                setDevRecording(true);      // display output canvas
                setPlayerPausedAutoSave(false);  // wait for AnalyzePlayerPaused to write out to vimeo
                setAnalyzerRefresh(AnalyzerRefresh+1);

                // if validate drill input data
                //    - start video recording
                //    - wait for video to stop in useEffect(PlayerPausedAutoSave)
                //    - wait for video save to vimeo, return video link
                //    - wait for wakeup_db_event event, create db drill record
                //
                var key = document.getElementById('drill_key').value;
                var name = document.getElementById('drill_name').value;
                var type = document.getElementById('drill_type').value;
                //var notes = document.getElementById('drill_notes').value;
                var notes = DrillNotes + " s:"+VideoRecordStart+" e:"+VideoRecordEnd;

                /* key = "test"; name = "test-drill-name"; type = "skill";*/
                if (key && name && type) {
                    setTimeout(() =>{
                        INFO.dev_record_mode = "original";
                        initVideoDisplay("output", "record_raw.4974");        // draw to output canvas
                        drawVideoScreen("original", "dev.create.6013");      // do not start multiple loops
                        recordOutput(INFO.output_canvas, key, true); // start recording when session starts

                        console.log("learn.3440:     # # # # #  START RECORDING RAW-ONLY VIDEO");
                    }, 100);        // slight delay for React to turn on <canvas>
                }


                // called after vimeo recording is stored (wakeup_db_event)
                //
                const storedDrill = () => {
                    window.removeEventListener("wakeup_db", storedDrill, false);
                    INFO.dev_recording = false;
                    setDevRecording(false);         // hide the recording canvas

                    var drill = {};
                    drill.key = key;
                    drill.name = name;
                    drill.type = type;
                    drill.notes = notes;
                    drill.version = 1;
                    drill.level = 1;
                    drill.seq = 111;
                    drill.subtype = "new";

                    drill.drill_video = INFO.video_ready.video;
                    drill.org_key = "axos";
                    drill.org_id = "master:axos:9233";
                    drill.width = INFO.video_width;			// orig video file aspect ratio, this chgs later
                    drill.height = INFO.video_height;		// orig video file aspect ratio, this chgs later

                    console.log("learn.3453:     # # # # #  WOKE UP ON DB_EVENT:  video_ready=",INFO.video_ready);
                    var out = CreateDatabase("drills", "_auto_", drill)
                        .then(res => {
                            console.log("store_drill.3467: ",res)
                            return res;
                        });

                }
                window.addEventListener("wakeup_db", storedDrill, false);


                player.setTime(VideoRecordStart);
                player.setStop(VideoRecordEnd);
                player.start();
                setAnalyzePlayerPaused(false);
                setPlayerPausedAutoSave(true);  // wait for AnalyzePlayerPaused to write out to vimeo
                setAnalyzerRefresh(AnalyzerRefresh+1);

                console.log("dev.3440:                . . . . Create DRILL:  key=",key, " name=",name, " type=", type);

                document.getElementById('drill_output').focus();
                break;
        }

    }


    // Controls model extraction AI params
    //
    const handleDrillShowAIOptions = (event) => {
        console.log("dev.3580:          SHOW AI PARAM DRAWER  vale=",DevAIControlOpen);
        if(DevAIControlOpen === false) {
            setDevAIControlOpen(true);
        } else {
            setDevAIControlOpen(false);
        }
    }



    // Shows Create Drill panel
    //
    const handleDrillShowAction = (event) => {
        console.log("dev.3275:          SHOW DRILL CREATE DRAWER  vale=",DevDrillCreateOpen);
        if(DevDrillCreateOpen === false) {
            setDevDrillCreateOpen(true);
        } else {
            setDevDrillCreateOpen(false);
        }
    }


    //
    // ref: copy Catalog.handleSelect()
    const toggleSettingDrawer = () => {
        GATag("Learn", "Setting.Toggle", "", 0);  // (cat, act, lab, val)
        console.log("#################### Toggle Setting Drawer ", SettingDrawerOn);
        if(SettingDrawerOn === true) {
            setSettingDrawerOn(false);
        } else {
            setSettingDrawerOn(true);
        }
    };


    // MOVE TO UTIL
    // return ready-to-plot results  [{name: <name>, data: [<data>]}]
    const CreatePerfArray = (sessions) => {
        var out = [], idx = 0;
        out["idx"] = [];
        for(var i = 0; i < sessions.length; i++) {
            var session = sessions[i]
            console.log(i+": ", session);
            for (var prop in session) {
                if(Object.prototype.hasOwnProperty.call(session, prop)) {
                    //console.log("create_perf.542:  prop=", prop, "  session=", session);
                    if(out[prop] == undefined) {
                        out[prop] = [];
                    }
                    out[prop].push(session[prop]);
                }
                out["idx"].push(idx);
                idx = idx + 1;
            }
        }
        //console.log("create_perf.546:  out=", out);
    }


    // UTIL - Share with Challenge?
    // read session history from db and prepare for graph display
    //
    const updateDrillHistory = (drill_hash, drill_name, fields) => {

        if ((drill_hash === undefined) || (fields === undefined)) {
            console.log("drill_history.3459:  BAD PARAM drill=", drill_hash, " drill_name=",drill_name," fields=",fields);
            setDrillSummary([{"field": "---", "value": "---", "timestamp": "NONE" }]);
            return
        }

        FetchFirestoreDrillSummary(drill_hash, fields)   // read summary from Stats db
        .then(summary => {
            // for next goal: out.next_rec, out.limit_rec
            console.log("update_drill_history.1245:        .  .  .  .  drill_hash=",drill_hash, "  summary=", summary)
            setDrillSummary(summary);
        })

        //console.log("dirll_history.568: ----->  START READING DRILL HISTORY drill=", drill_name, " fields=",fields);
        FetchFirestoreDrillHistory(drill_hash, drill_name)
            .then(sessions => {
                var remove;
                if (sessions === null) {
                    return;
                }

                // loop reverse to remove negative numbers, splice out invalid sessions
                //console.log("learn_history.1652:           .  .  .  .  DRILL HISTORY RECEIVED    session=", sessions.length, " fields=",fields);
                for (var i = (sessions.length - 1); i >= 0; i--) {
                    var session = sessions[i];
                    remove = false;
                    for (var j = 0; j < fields.length; j++) {
                        var field = fields[j];
                        //console.log("dirll_history.848:              ",i,":   ",session[field]);
                        if ((session[field] < 0) || (session[field] === undefined)) {
                            session[field] = 0;
                            remove = true;
                        }
                    }
                    if(remove === true) {
                        sessions.splice(i, 1);      // remove
                    }
                }

                //var out = CreatePerfArray(sessions);
                setHistory(sessions);              // target sequence
                setFields(fields);              // target sequence

                //setDrillSummary(processDrillHistory(sessions, fields));   // ****  NOT FINISHED YET....
                // extract key metrics (like last "record time" so we can display in summary
            })
    }




                                //src="http://www.youtube.com/embed/n_dZNLr2cME?rel=0&hd=1" 
                                //width="560" height="349" 
                                //width={VidWidth} height={VidHeight}
                        //ToggleSetting={toggleSettingDrawer}
                        //GoBack={handleGoCatalog} />
                    //{ ShowNeedHorizontal && <FullScreen Message={"PLEASE ROTATE TO HORIZONTAL MODE"} />}
    return (
        <React.Fragment>
            <Container id="train_root" className={classes.train_root}>
                { ShowTutorial && <Tutorial  Show={ShowTut} ZIndex={410} Dismiss={handleDismissTutorial}/> }
                { ShowGraph && <LineChart ID="learn" History={History} Fields={Fields} Dismiss={handleDismissGraph} /> }
                { ShowCountdown && 
                    <Countdown Msg={CountdownMsg} 
                    Name={CountdownName} 
                    Background={BotSlaveBackground} 
                    Title={BotSlaveDrillTitle} 
                    List={CountdownList} 
                    TextStyle={classes.slave1_rank_text} 
                    Delay={CountdownTime} 
                    Dismiss={handleDismissCountdown} 
                    ZIndex={410} /> }
                { ShowWait && 
                    <Wait Warning={Warning} 
                    Outcome={Outcome} 
                    Summary={Summary} 
                    Report={Report} 
                    Confirmation={Confirmation} 
                    ValidateRun={ValidateRun}
                    Progress={Progress} 
                    ShowSpinner={ShowWaitSpinner} 
                    Dismiss={handleDismissWait} 
                    Submit={handleSubmitWait} /> }
                { ShowBugReport && <BugReport Summary={Summary} Dismiss={handleDismissBug} Bug={handleSubmitBug} /> }
                { ShowSendInvite && <SendInvite Dismiss={handleDismissInvite} GetToken={handleGetInviteToken} /> }
                { ShowAdminDialog && <SwitchUser Users={INFO.db_players} SwitchAction={handleSwitchUser} Dismiss={handleDismissSwitchUser} /> }
                { ShowBotSlave && <BotSlave Background={BotSlaveBackground} Title={BotSlaveDrillTitle} Ranks={BotSlaveRanks} Notes={BotSlaveNote} Dismiss={handleDismissSlave} /> }


                <Drawer id="setting_drawer" anchor={"left"} className={classes.drawer_panel} open={SettingDrawerOn} onClose={toggleSettingDrawer}>
                    <Settings ShowInvite={handleShowInvite} Toggle={toggleSettingDrawer} ShowAdmin={handleShowAdminDialog} />
                </Drawer>
                { ShowDashboard && <Dashboard 
                        Action={handleDashboardSelect} 
                        DrillAction={handleDrillSelect} 
                        VerticalMode={VerticalMode}
                        Photo={INFO.avatar}
                        Reload={DashReload}
                        ToggleSetting={toggleSettingDrawer}  {...props} />}


                { ShowCatalog && <Catalog Title={CatalogTitle}
                        Tab={TabSelected}
                        Type={CatalogType}
                        Items={CatalogItems}
                        Groups={CatalogGroups}
                        Refresh={CatalogRefresh}
                        Theme={classes.catalog_theme}
                        ToggleSetting={toggleSettingDrawer}
                        TabSelect={handleTabSelect}
                        Select={handleItemSelect}
                        ShowTutorial={handleShowTutorial}
                        DismissTutorial={handleDismissTutorial}
                        Icon={faAngleDoubleRight}
                        GoBack={handleGoBack}  />}


                {!ShowDashboard && <Container id="display_container" className={classes.display_container}>

                    <GoBack Title={(SelectedItem === undefined) ? "UNKNOWN" : SelectedItem.name} 
                        Icon={faAngleDoubleRight} 
                        ToggleSetting={toggleSettingDrawer}
                        Bug={handleShowBug} 
                        Tutorial={handleShowTutorial} 
                        GoBack={handleManualGoCatalog} />

                    { ShowNeedHorizontal && <FullScreen Image={require("../assets/images/rotate_screen_icon.gif")}
                                                        Message={"PLEASE ROTATE DEVICE TO HORIZONTAL MODE"} />}

                    {/* false && ShowPerf &&
                        <React.Fragment>
                            <Container id="video_container" className={classes.video_container}>
                                {!INFO.webcam_started && <Direction Directions={UseDirections} BarColor={"yellow"} FontColor={"red"} Display={true} SmallSize={false}/>}
                                {(ShowPreFlight) && <Fade in={ShowPreFlight} timeout={{enter: 100, exit: 2000}}>
                                    <Notice Instrns={WarningText} 
                                            BarColor={"#c3ab19"} 
                                            FontColor={"white"} 
                                            Style={{position: "absolute", top: "0px", left: "0px"}}
                                            Display={ShowPreFlight}  />
                                </Fade>}

                                { ShowRaiseHand && <Notice Instrns={Notices} 
                                        BarColor={"yellow"} 
                                        FontColor={"red"} 
                                        Display={ShowRaiseHand} 
                                        Style={{position: "relative"}}
                                        SmallSize={false}/> }

                                <Webcam ID={"perf_webcam_container"}
                                        Class={classes.perf_webcam_container} 
                                        WebcamWidth={WebcamWidth}
                                        WebcamHeight={ WebcamHeight }
                                        CanvasVideoWidth={CanvasVideoWidth} 
                                        CanvasVideoHeight={CanvasVideoHeight} />
                            </Container>

                            <Results 
                                Parent={"Challenge"}
                                Message={""}
                                Hide={false} 
                                DisableRun={NoAI}
                                WebcamStarted={INFO.webcam_started} 
                                DrillSummary={DrillSummary}
                                Recording={Recording} 
                                HandsFree={HandsFree}
                                RunAction={handleRunChallengeWebcam} 
                                RunRecord={handleRecording} 
                                ShowGraph={handleShowGraph} 
                                ButtonText={ButtonText} 
                                Style={ResultStyle}

                                Stop={RunStopped} 
                                />
                        </React.Fragment>
                    */}



                    { (ShowDrill || ShowPerf) &&
                        <React.Fragment>
                            <Container id="drill_video_container" className={classes.drill_container}>
                                {(ShowPreFlight) && <Fade in={ShowPreFlight} timeout={{enter: 100, exit: 2000}}>
                                    <Notice Instrns={WarningText} 
                                            BarColor={"#c3ab19"} 
                                            FontColor={"white"} 
                                            SmallSize={true}
                                            Style={{position: "relative", top: "0px", left: "0px"}}
                                            Display={ShowPreFlight}  />
                                </Fade>}

                                { ShowRaiseHand && <Notice Instrns={Notices} 
                                        BarColor={"yellow"} 
                                        FontColor={"red"} 
                                        Display={ShowRaiseHand} 
                                        Style={{position: "relative"}}
                                        SmallSize={false}/> }

                                { false && <Webcam ID={"webcam_container"}
                                        Class={classes.webcam_container}
                                        WebcamWidth={WebcamWidth}
                                        WebcamHeight={ WebcamHeight }
                                        CanvasVideoWidth={CanvasVideoWidth} 
                                        CanvasVideoHeight={CanvasVideoHeight} />}

                                <VideoFrame Source={SelectedItem.url} 
                                            SelectedItem={SelectedItem}
                                            Loop={true} 
                                            Width={PlayerVideoWidth} 
                                            Height={PlayerVideoHeight}
                                            onReady={handleVideoRendered}
                                            onStateChange={handleVideoStateChange}
                                            PlayerType={PlayerType}
                                            ShowVideoControl={ShowVideoControl}
                                            Style={classes.drill_iframe} />
                            </Container>


                            { ShowPerf && <Results 
                                Parent={"Challenge"}
                                Message={""}
                                Hide={false} 
                                DisableRun={NoAI}
                                WebcamStarted={INFO.webcam_started} 
                                DrillSummary={DrillSummary}
                                Recording={Recording} 
                                HandsFree={HandsFree}
                                RunAction={handleRunChallengeWebcam} 
                                RunRecord={handleRecording} 
                                ShowGraph={handleShowGraph} 
                                ButtonText={ButtonText} 
                                Style={ResultStyle}
                                Title={SelectedItem.name}
                                ShowExpand={ShowExpand}
                                ExpandIcon={ExpandIcon}
                                Refresh={Refresh}
                                RunExpand={handleExpand}

                                Stop={RunStopped} 
                                />
                            }

                            { ShowDrill && <Results 
                                Parent={"Learn"}
                                Message={""}

                                Hide1={HideResults} 
                                Hide={false} 

                                DisableRun={NoAI}
                                WebcamStarted={INFO.webcam_started} 
                                DrillSummary={DrillSummary}
                                Recording={Recording} 
                                HandsFree={HandsFree}
                                RunAction={handleRunPracticeWebcam} 
                                RunRecord={handleRecording} 
                                ShowGraph={handleShowGraph} 
                                ButtonText={ButtonText}
                                Style={ResultStyle}
                                Title={SelectedItem.name}
                                ShowExpand={ShowExpand}
                                ExpandIcon={ExpandIcon}
                                Refresh={Refresh}
                                RunExpand={handleExpand}

                                RunSlowMo={handleRunSlowMo} 
                                SlowMo={SlowMo} 
                                SetVideoPosition={handleSetLearnPlayerTime} 
                                />
                            }
                        </React.Fragment>
                    }



                    { ShowGame &&
                        <React.Fragment>
                            <Game Type="simple" 
                                GameStarted={GameStarted}
                                Instrns={Instrns}
                                UseDirections={UseDirections}
                                Finished={handleStopGame} 
                                Fingers={GameFingers} 
                                Scheme={GameScheme} 
                                //Finished={event => handleStopGame("save")} 
                                GameCnt={GameCnt} />

                            <Results 
                                Parent={"Game"}
                                Message={""}
                                Title={SelectedItem.name}
                                Hide={GameStarted} 
                                DisableRun={false}
                                WebcamStarted={false} 
                                DrillSummary={DrillSummary}
                                Refresh={Refresh}
                                HandsFree={HandsFree}
                                RunAction={handleRunGame} 
                                ShowGraph={handleShowGraph} 
                                ButtonText={ButtonText}
                                Style={ResultStyle}/>

                            <Container id="dummy_video_container" className={classes.dummy_container}>
                                <iframe id="review_output"
                                        className={classes.dummy_container}
                                        frameBorder="0">
                                </iframe>
                            </Container>

                        </React.Fragment>
                    }



                    { ShowMock &&
                        <React.Fragment>
                            <Mock Mode="run" 
                                MockStarted={MockStarted}
                                Instrns={Instrns}
                                UseDirections={UseDirections}
                                XVideoWidth={PlayerVideoWidth} 
                                XVideoHeight={PlayerVideoHeight}
                                Finished={handleStopMock} 
                                SelectedItem={SelectedItem}
                                MockCnt={MockCnt} />

                            <Results 
                                Parent={"Mock"}
                                Message={""}
                                Title={SelectedItem.name}
                                Hide={(MockStarted > 0) ? true : false} 
                                DisableRun={NoDetect}
                                DrillSummary={DrillSummary}
                                Refresh={Refresh}
                                ButtonText={ButtonText}
                                Style={ResultStyle}
                                HandsFree={HandsFree}
                                WebcamStarted={false} 
                                SetVideoPosition={handleSetLearnPlayerTime} 
                                RunAction={handleRunMock} 
                                ShowGraph={handleShowGraph} />

                            <Container id="dummy_video_container" className={classes.dummy_container}>
                                <iframe id="review_output"
                                        className={classes.dummy_container}
                                        frameBorder="0">
                                </iframe>
                            </Container>

                        </React.Fragment>
                    }



                    { ShowAnalyze &&
                        <React.Fragment>
                            <Container id="display_container1" className={classes.adisplay_container}>

                                {ShowDevDrillCreate &&
                                <Container id="dev_control_container" className={classes.dev_control_container}>
                                    <Container id="create_drill_container" className={classes.create_drill_container}>
                                        {DevDrillCreateOpen &&
                                        <Container id="drill_btn_container" className={classes.drill_drawer_container}>

                                                {/*<label htmlFor="key" className={classes.input_label}>Key:</label>*/}
                                                <label className={classes.input_label}>Start: {VideoRecordStart}</label>
                                                <label className={classes.input_label}>End: {VideoRecordEnd}</label>
                                                <input type="text" id="drill_key" name="key" placeholder="key" className={classes.text_input}/>
                                                <input type="text" id="drill_name" name="name" placeholder="name" className={classes.text_input}/>
                                                <input type="text" id="drill_type" name="type" placeholder="type" className={classes.text_input}/>

                                                {HasVideoEnds &&
                                                <React.Fragment>
                                                    <Button id="new_loop_btn" variant="contained" 
                                                        className={classes.dev_ctl_btn} onClick={handleDevCreateAction("loop")}>
                                                        LOOP
                                                    </Button>
                                                    <Button id="new_create_btn" variant="contained" 
                                                        className={classes.dev_ctl_btn} onClick={handleDevCreateAction("create")}>
                                                        CREATE
                                                    </Button> 
                                                </React.Fragment>}
                                        </Container>
                                        }

                                        <Button id="submit_btn" className={classes.dev_toggle_btn} onClick={handleDrillShowAction}>
                                            EDIT DRILL
                                        </Button> 
                                    </Container>

                                    <Container id="create_drill_container" className={classes.create_drill_container}>
                                        {DevAIControlOpen &&
                                        <Container id="drill_btn_container" className={classes.drill_drawer_container}>

                                                <label className={classes.input_label}>Start: {VideoRecordStart}</label>
                                                <label className={classes.input_label}>End: {VideoRecordEnd}</label>
                                                <FormGroup className={classes.checkbox_group}>
                                                    <FormControlLabel control={
                                                        <Checkbox id="UL" checked={DevMarkerTrace} size="small" onChange={handleKnnMode("debug")} />
                                                    } label="KNN DEBUG" className={classes.checkbox_input}/>
                                                    <FormControlLabel control={
                                                        <Checkbox id="UL" checked={DevMarkerReset} size="small" onChange={handleKnnMode("reset")} />
                                                    } label="KNN RESET" className={classes.checkbox_input}/>

                                                    <FormControlLabel control={
                                                        <Checkbox id="UL" checked={TLState} size="small" onChange={handleLimbSelect("TL")} />
                                                    } label="Left Arm" className={classes.checkbox_input}/>
                                                    <FormControlLabel control={
                                                        <Checkbox id="UR" checked={TRState} size="small" onChange={handleLimbSelect("TR")} />
                                                    } label="Right Arm" className={classes.checkbox_input}/>
                                                    <FormControlLabel control={
                                                        <Checkbox id="BL" checked={BLState} size="small" onChange={handleLimbSelect("BL")} />
                                                    } label="Left Leg" className={classes.checkbox_input}/>
                                                    <FormControlLabel control={
                                                        <Checkbox id="BR" checked={BRState} size="small" onChange={handleLimbSelect("BR")} />
                                                    } label="Right Leg" className={classes.checkbox_input}/>
                                                    <FormControlLabel control={
                                                        <Checkbox id="CH" checked={CHState} size="small" onChange={handleLimbSelect("CH")} />
                                                    } label="Head" className={classes.checkbox_input}/>
                                                    <FormControlLabel control={
                                                        <Checkbox id="CB" checked={CBState} size="small" onChange={handleLimbSelect("CB")} />
                                                    } label="Body" className={classes.checkbox_input}/>
                                                </FormGroup>

                                                <React.Fragment>
                                                    <Button id="create_ai_btn" variant="contained" 
                                                        className={classes.dev_ctl_btn} onClick={handleDevCreateAction("loop")}>
                                                        CREATE MODEL
                                                    </Button> 
                                                </React.Fragment>
                                        </Container>}

                                        <Button id="submit_btn" className={classes.dev_toggle_btn} onClick={handleDrillShowAIOptions}>
                                            AI CONTROL
                                        </Button> 
                                    </Container>
                                </Container>}


                                <Container id="display_container" className={(HideResult === true) ? classes.full_drill_container : classes.adrill_container}>
                                    {(!VideoStarted && !HideInstruction) && 
                                        <Direction Directions={UseDirections} 
                                               BarColor={"yellow"} FontColor={"red"} Display={true} SmallSize={false}/>}

                                    
                                    {ShowEditMockVideo && <React.Fragment>
                                        <Mock Mode="edit" 
                                            MockStarted={1}
                                            Instrns={Instrns}
                                            UseDirections={[]}
                                            XVideoWidth={PlayerVideoWidth} 
                                            XVideoHeight={PlayerVideoHeight}
                                            Finished={handleStopMock} 
                                            SelectedItem={SelectedItem}
                                            Footage={EditMockFootage}
                                            ShowVideoControl={false}
                                            MockCnt={MockCnt} />
                                    </React.Fragment>}


                                    {ShowAnalyzeVideo && <React.Fragment>
                                        <VideoFrame Source={ReviewVideo} 
                                            Loop={true} 
                                            Width1={PlayerVideoWidth} 
                                            Height1={PlayerVideoHeight}
                                            Width={CanvasVideoWidth} 
                                            Height={CanvasVideoHeight} 
                                            SelectedItem={VideoItem}
                                            onReady={handleAnalyzeVideoRendered}
                                            onStateChange={handleAnalyzeVideoStateChange}
                                            PlayerType={PlayerType}
                                            Player={VideoPlayer}
                                            ShowVideoControl={ShowVideoControl}
                                            Style={classes.drill_iframe} />
                                            
                                        <canvas id="vcanvas" width={CanvasVideoWidth} height={CanvasVideoHeight} className={classes.dev_vcanvas} />
                                        <canvas id="output"  width={CanvasVideoWidth} height={CanvasVideoHeight} className={classes.dev_output_canvas} />
                                        {/*((DevRunningAI === true) || (DevRecording === true)) */}
                                    </React.Fragment>
                                    }

                                    {ShowAnalyzeWebcam && 
                                        <Webcam ID={"video_container"}
                                            Class={classes.perf_webcam_container} 
                                            WebcamWidth={WebcamWidth}
                                            WebcamHeight={ WebcamHeight }
                                            CanvasVideoWidth={CanvasVideoWidth} 
                                            CanvasVideoHeight={CanvasVideoHeight} />}

                                    {ShowBotMaster && 
                                        <BotAdmin/>}
                                </Container>

                                {!HideResult && 
                                    <Results Parent={"VideoReview"}
                                        Message={""}
                                        Hide={HideResults} 
                                        Videos={VideosList}
                                        DrillSummary={DrillSummary}
                                        Refresh={Refresh}
                                        Title={SelectedItem.name}
                                        DevAnalyzeMode={DevAnalyzeMode}
                                        ShowDevButton={ShowDevButton}
                                        DevAction={handleDevActionProcess} 
                                        RecordAction={handleRecordAnalyzeVideo} 
                                        RunAction={handleAnalyzeSidebarSelection} 
                                        //DrillMode={INFO.making_drill}
                                        ButtonText={ButtonText} />}
                            </Container>
                    </React.Fragment>}


                </Container>}
            </Container>

            {renderRedirect()}
        </React.Fragment>
    )
}

export default withRouter(Learn)